var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 176V16H496V176H16Z",
    fill: "#2980B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 336V176H496V336H16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 496V336H496V496H16Z",
    fill: "#2980B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.264 301.127C256.549 301.127 257.943 301.127 263.816 299.695C269.688 298.3 274.533 294.741 275.67 294.227C276.808 293.713 278.459 293.859 278.459 293.859C277.835 293.199 276.037 291.547 273.505 291.547C270.935 291.547 271.963 291.547 269.798 292.464C267.632 293.346 263.118 296.097 255.485 296.097H255.339C247.705 296.097 242.934 293.346 240.769 292.464C238.603 291.547 239.594 291.547 237.061 291.547C234.492 291.547 232.731 293.199 232.07 293.859C232.07 293.859 233.758 293.713 234.896 294.227C236.034 294.741 240.878 298.3 246.751 299.695C252.585 301.127 254.017 301.127 255.264 301.127H255.264Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.304
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.73 296.127C233.354 295.76 232.583 294.733 232.583 294.733L234.895 294.219C233.758 293.705 232.07 293.851 232.07 293.851C231.629 294.219 231.702 294.659 231.629 294.989C231.592 295.32 231.592 295.834 231.849 296.09C232.069 296.31 232.73 296.127 232.73 296.127L232.73 296.127Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.304
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.887 294.225L232.575 294.739C232.575 294.739 233.345 295.766 232.721 296.133L236.795 295.362C236.795 295.362 236.172 294.922 234.887 294.225V294.225Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.304
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.832 296.127C277.208 295.76 277.942 294.733 277.942 294.733L275.666 294.219C276.804 293.705 278.455 293.851 278.455 293.851C278.932 294.219 278.858 294.659 278.932 294.989C278.969 295.32 278.968 295.834 278.712 296.09C278.456 296.31 277.832 296.127 277.832 296.127L277.832 296.127Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.304
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.666 294.225L277.942 294.739C277.942 294.739 277.208 295.766 277.832 296.133L273.758 295.362C273.758 295.362 274.381 294.922 275.666 294.225V294.225Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.304
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M239.051 292.633L238.02 295.197L238.496 295.382C239.267 295.712 240.033 295.539 240.399 294.695C240.73 293.813 240.287 293.165 239.553 292.871L239.051 292.633H239.051ZM239.263 293.161L239.342 293.188C239.929 293.444 240.285 293.864 240.029 294.562C239.735 295.223 239.152 295.242 238.602 294.985L238.496 294.959L239.263 293.161V293.161Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.644 293.75L240.506 296.278L240.212 296.164L241.35 293.637L241.644 293.75Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M242.748 294.299C242.211 294.313 241.7 294.674 241.453 295.224C241.122 295.959 241.443 296.744 242.14 297.075C242.837 297.369 243.66 297.052 243.99 296.282C244.284 295.585 243.973 294.736 243.276 294.405C243.102 294.331 242.927 294.295 242.748 294.299V294.299ZM242.721 294.722C242.845 294.721 242.989 294.746 243.118 294.801C243.668 295.021 243.814 295.61 243.594 296.123C243.373 296.637 242.776 296.899 242.298 296.678C241.859 296.458 241.618 295.907 241.875 295.356C242.041 294.971 242.35 294.725 242.721 294.722L242.721 294.722Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.79 296.059C245.753 295.877 245.681 295.73 245.497 295.656C245.314 295.583 245.021 295.656 244.947 295.877C244.874 296.096 245.021 296.281 245.131 296.39L245.314 296.537C245.607 296.794 245.791 297.088 245.607 297.528C245.424 298.005 244.947 298.189 244.506 298.042C244.139 297.895 243.919 297.455 244.029 297.014L244.359 297.088C244.249 297.345 244.396 297.638 244.652 297.748C244.91 297.858 245.203 297.675 245.314 297.418C245.423 297.125 245.24 296.941 245.056 296.757L244.91 296.61C244.69 296.39 244.507 296.133 244.653 295.766C244.8 295.362 245.241 295.215 245.607 295.362C245.9 295.473 246.048 295.693 246.084 295.987L245.79 296.059V296.059Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.812 296.204L247.371 297.746C247.261 298.186 247.261 298.627 247.738 298.773C248.252 298.921 248.472 298.554 248.619 298.113L249.059 296.534L249.352 296.645L248.875 298.297C248.728 298.884 248.252 299.251 247.664 299.067C247.077 298.921 246.857 298.37 247.04 297.783L247.517 296.094L247.812 296.204V296.204Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.516 300.02L249.975 297.493L249.571 299.504L249.277 299.469L249.828 296.609L251.332 299.102L251.736 297.125L252.03 297.16L251.516 300.02Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.214 299.95L252.543 297.23L252.837 297.265L252.507 300.02L252.214 299.95Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M254.564 297.345C253.794 297.309 253.174 297.923 253.137 298.693C253.1 299.538 253.688 300.163 254.459 300.2C255.193 300.237 255.849 299.67 255.886 298.826C255.923 298.055 255.299 297.345 254.564 297.345ZM254.512 297.742C255.098 297.779 255.473 298.275 255.437 298.826C255.437 299.413 254.972 299.804 254.459 299.804C253.945 299.767 253.534 299.297 253.534 298.746C253.57 298.196 253.961 297.742 254.512 297.742V297.742Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.709 300.099L256.58 298.114L256.727 300.169H256.397L256.177 297.309L258.306 299.286L258.159 297.265L258.489 297.23L258.709 300.099Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.435 299.688L259.92 296.976L260.251 296.941L260.728 299.32L261.499 299.18L261.572 299.504L260.435 299.688Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.902 299.399L261.278 296.714L261.609 296.645L262.233 299.321L261.902 299.399Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M262.761 296.363C262.646 296.369 262.537 296.389 262.417 296.416L262.126 296.522L262.867 299.165L263.448 299.033C263.889 298.886 264.256 298.553 264.109 298.002C264.035 297.708 263.752 297.463 263.422 297.5C263.569 297.353 263.591 297.076 263.554 296.892C263.416 296.451 263.105 296.344 262.761 296.363V296.363ZM262.814 296.707C262.989 296.678 263.154 296.749 263.237 297.024C263.347 297.355 263.123 297.454 262.867 297.527L262.787 297.553L262.523 296.76H262.629C262.693 296.732 262.755 296.717 262.814 296.707L262.814 296.707ZM263.237 297.817C263.452 297.793 263.684 297.833 263.739 298.108C263.849 298.439 263.6 298.591 263.342 298.663L263.104 298.742L262.893 297.897L263.052 297.87C263.116 297.852 263.165 297.825 263.237 297.817Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.609 296.575L265.719 296.863L264.728 297.196L265.058 298.184L266.086 297.817L266.196 298.149L264.875 298.595L263.957 295.989L265.315 295.508L265.389 295.796L264.361 296.164L264.617 296.898L265.609 296.575Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M266.779 295.07C266.522 295.033 266.312 295.092 266.092 295.202L265.721 295.36L266.752 297.924L267.043 297.819L266.647 296.708L266.752 296.682L267.889 297.449L268.286 297.316L267.043 296.497C267.373 296.313 267.481 295.913 267.334 295.545C267.26 295.325 267.036 295.106 266.779 295.07H266.779ZM266.7 295.413C266.842 295.427 266.969 295.52 267.043 295.704C267.189 296.07 266.887 296.255 266.594 296.365L266.541 296.391L266.197 295.545L266.277 295.519C266.405 295.464 266.557 295.399 266.699 295.413H266.7Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.298 294.704L268.732 294.074L268.872 294.337L268.286 294.59L269.318 296.829L269.021 296.978L267.998 294.739L267.447 294.993L267.298 294.704Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M269.815 293.377L270 296.523L270.344 296.338L270.291 295.624L271.375 295.069L271.956 295.545L272.247 295.36L269.815 293.377H269.815ZM270.185 294.117L271.031 294.804L270.265 295.201L270.185 294.117V294.117Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M272.438 292.27C272.168 292.285 271.88 292.369 271.618 292.534L271.142 292.798L272.596 295.177L273.019 294.94C273.753 294.5 274.078 293.764 273.601 292.957C273.303 292.452 272.886 292.244 272.438 292.27L272.438 292.27ZM272.57 292.693C272.827 292.716 273.081 292.856 273.283 293.168C273.65 293.792 273.306 294.265 272.755 294.596L272.702 294.622L271.697 292.983L271.777 292.904C272.052 292.757 272.313 292.67 272.57 292.693H272.57Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.939 302.665C230.379 302.665 230.709 302.335 230.709 301.894C230.709 301.49 230.379 301.16 229.939 301.16C229.536 301.16 229.168 301.49 229.168 301.894C229.168 302.335 229.536 302.665 229.939 302.665Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.608 308.02C226.048 308.02 226.378 307.691 226.378 307.25C226.378 306.846 226.049 306.479 225.608 306.479C225.204 306.479 224.837 306.846 224.837 307.25C224.837 307.691 225.205 308.02 225.608 308.02Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.551 291.212C215.954 291.212 216.321 290.844 216.321 290.441C216.321 290.001 215.954 289.67 215.551 289.67C215.111 289.67 214.78 290.001 214.78 290.441C214.78 290.844 215.11 291.212 215.551 291.212Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.308 294.333C209.748 294.333 210.152 293.966 210.152 293.488C210.152 293.049 209.748 292.645 209.308 292.645C208.831 292.645 208.464 293.049 208.464 293.488C208.464 293.966 208.831 294.333 209.308 294.333Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.174 275.471C208.615 275.471 209.018 275.105 209.018 274.627C209.018 274.186 208.615 273.783 208.174 273.783C207.698 273.783 207.331 274.186 207.331 274.627C207.331 275.106 207.697 275.471 208.174 275.471Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.922 277.01C203.399 277.01 203.766 276.643 203.766 276.166C203.766 275.689 203.399 275.322 202.922 275.322C202.482 275.322 202.078 275.689 202.078 276.166C202.078 276.643 202.481 277.01 202.922 277.01Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.603 260.202C206.081 260.202 206.447 259.798 206.447 259.358C206.447 258.881 206.081 258.514 205.603 258.514C205.127 258.514 204.759 258.881 204.759 259.358C204.759 259.799 205.127 260.202 205.603 260.202Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.909 244.749C201.349 244.749 201.753 244.382 201.753 243.942C201.753 243.465 201.349 243.098 200.909 243.098C200.431 243.098 200.065 243.464 200.065 243.942C200.065 244.382 200.431 244.749 200.909 244.749Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.889 246.289C207.366 246.289 207.733 245.923 207.733 245.445C207.733 245.006 207.366 244.602 206.889 244.602C206.411 244.602 206.045 245.006 206.045 245.445C206.044 245.922 206.411 246.289 206.889 246.289Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.759 233.415C213.2 233.415 213.603 233.048 213.603 232.571C213.603 232.13 213.2 231.764 212.759 231.764C212.282 231.764 211.915 232.13 211.915 232.571C211.916 233.048 212.282 233.415 212.759 233.415Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.284 229.854C208.762 229.854 209.128 229.487 209.128 229.01C209.128 228.57 208.762 228.166 208.284 228.166C207.808 228.166 207.44 228.569 207.44 229.01C207.44 229.487 207.807 229.854 208.284 229.854Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.2 221.192C217.677 221.192 218.044 220.825 218.044 220.348C218.044 219.87 217.677 219.504 217.2 219.504C216.722 219.504 216.356 219.87 216.356 220.348C216.355 220.825 216.722 221.192 217.2 221.192Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.997 260.313C199.474 260.313 199.841 259.945 199.841 259.505C199.841 259.065 199.474 258.697 198.997 258.697C198.556 258.697 198.19 259.065 198.19 259.505C198.19 259.945 198.556 260.313 198.997 260.313Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M230.666 305.82C230.666 305.82 230.042 303.142 230.152 302.518L230.813 302.004",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M229.642 306.844C229.642 306.844 227.257 306.954 226.486 307.211C226.486 307.211 226.486 307.358 226.23 307.872",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M214.891 294.74C214.891 294.74 214.744 291.547 215.405 291.29C215.405 291.29 216.028 291.034 216.396 290.52",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M212.463 293.706C212.463 293.706 210.665 293.448 210.15 293.706C210.15 293.706 210.04 294.22 209.636 294.367",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M209.02 274.988L208.397 275.356C207.736 275.612 206.488 278.695 206.488 278.695C206.488 278.695 204.433 277.153 203.552 277.006H202.635",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M198.557 259.939C198.557 259.939 199.071 260.454 199.585 260.197C199.585 260.197 202.117 261.849 202.263 262.509C202.263 262.509 204.943 259.83 205.456 260.086C205.456 260.086 205.713 260.454 206.227 259.939",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M201.382 244.275C201.382 244.275 201.639 244.642 202.116 244.899C202.116 244.899 203.29 246.587 203.29 247.835C203.29 247.835 205.456 245.927 206.079 246.074C206.079 246.074 206.85 246.33 207.363 246.074",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M207.625 229.633C207.625 229.633 208.138 230.256 208.505 229.743C208.505 229.743 210.046 231.651 209.129 233.083C209.129 233.083 211.294 232.57 211.954 232.936C211.954 232.936 212.211 233.817 212.982 233.303",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.303 322.265C270.303 322.265 267.001 322.009 266.487 322.009C265.973 322.009 264.835 319.732 264.321 319.33C263.807 318.962 255.146 314.742 249.531 313.861C243.915 312.98 235.291 309.641 233.492 308.76C224.17 304.282 213.747 295.988 211.435 292.574C209.012 289.015 206.443 280.719 205.306 276.279C204.791 274.223 202.002 265.819 202.002 260.094C202.002 253.451 202.773 247.983 203.801 243.652C204.791 239.321 212.242 226.624 216.792 220.971C216.792 220.971 206.553 236.825 204.791 242.881C203.03 249.12 202.515 256.717 202.626 261.048C202.736 264.608 205.708 277.637 210.039 287.216C213.489 294.886 216.499 295.804 221.894 300.097C224.427 302.117 229.271 305.309 233.345 307.365C237.418 309.383 246.08 311.952 248.392 312.319C250.667 312.723 262.265 316.136 263.806 316.907C265.35 317.678 269.276 321.128 270.304 322.265L270.303 322.265Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.209 292.718C212.466 291.544 212.576 290.663 212.98 290.296C213.346 289.892 214.632 288.35 214.888 287.36C215.145 286.332 214.888 285.562 214.888 285.047C214.888 284.533 215.254 282.772 215.254 282.772C215.254 282.772 214.631 280.606 214.117 280.202C213.603 279.835 212.319 278.036 212.062 277.523C212.062 277.523 212.208 278.551 211.804 279.065C211.437 279.579 211.291 280.863 211.291 281.598C211.291 282.368 211.547 284.167 211.291 285.047C211.034 286.038 210.667 286.846 210.924 287.983C211.145 288.901 212.209 292.718 212.209 292.718L212.209 292.718Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.803 291.432C211.803 291.432 208.904 287.726 208.904 286.184C208.904 284.679 208.648 283.761 208.391 283.395C208.134 283.029 206.482 281.083 207.988 278.698C208.648 277.67 208.758 277.744 209.125 276.642C209.639 275.247 210.667 275.247 210.813 273.854C210.813 273.854 211.181 275.505 211.291 276.899C211.437 278.294 211.181 278.808 211.07 279.577C210.923 280.349 211.437 281.23 211.437 282.366C211.437 283.541 211.291 283.982 211.291 284.679C211.289 285.047 210.811 289.891 211.803 291.432L211.803 291.432Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.471 311.329C244.471 311.329 242.011 311.071 241.094 310.925C240.434 310.851 238.928 310.485 238.085 310.154C237.351 309.897 235.919 309.126 234.672 307.805C232.323 305.309 232.543 303.987 232.139 303.877C231.295 303.731 233.46 303.511 234.488 303.658C235.479 303.768 236.874 304.502 237.792 305.382C238.746 306.264 240.214 307.255 240.727 307.622C241.241 308.025 241.608 308.172 242.158 308.907C242.709 309.641 242.673 310.118 244.471 311.329V311.329Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.846 313.12C247.846 313.12 241.68 310.368 241.056 309.854C240.395 309.376 239.368 308.385 238.707 307.688C238.083 306.99 235.477 305.669 235.037 304.826C234.744 304.238 233.129 302 232.174 300.238C231.697 299.32 236.285 300.532 236.285 300.532C240.029 302.037 238.34 300.973 240.395 302.514C241.643 303.469 242.487 304.276 242.818 304.974C243.294 306.075 243.846 307.982 244.396 308.974C244.91 309.964 245.9 311.248 247.846 313.12V313.12Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.187 313.898C251.187 313.898 246.085 312.577 243.773 309.421C242.121 307.255 242.121 307.917 241.424 307.182C240.58 306.264 239.259 305.274 238.158 303.402C238.268 303.586 236.69 298.411 236.763 297.786C236.8 297.42 238.708 298.044 240.249 298.704C241.571 299.255 242.341 300.319 243.479 301.017C244.837 301.898 245.021 304.099 245.645 305.128C246.525 306.632 246.636 307.403 246.636 308.136C246.599 309.274 247.259 309.641 247.626 310.595C248.068 311.732 249.425 311.549 251.187 313.898H251.187Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.041 312.207C243.041 312.207 238.71 310.299 238.086 310.152C237.426 310.042 237.168 309.638 236.288 309.381C235.554 309.197 234.893 308.647 233.095 309.014C232.324 309.197 229.168 309.895 228.397 309.528C227.626 309.124 229.534 311.694 230.415 312.206C231.333 312.721 232.838 312.978 234.122 312.831C235.406 312.721 237.169 312.831 237.829 312.831C238.452 312.831 238.82 312.978 239.737 312.721C240.619 312.464 240.875 312.06 243.041 312.207H243.041Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.976 312.207C245.976 312.207 241.131 310.996 240.324 310.996C239.517 310.996 237.204 311.143 236.25 311.327C235.333 311.474 232.434 311.18 231.589 311.621C230.708 312.024 226.855 312.575 225.827 312.318C224.8 312.097 227.883 315.07 229.094 315.4C233.021 316.501 231.846 316.355 234.379 315.694C235.921 315.29 238.123 315.18 238.893 315.07C239.664 314.923 239.517 314.482 240.545 314.042C241.572 313.602 243.297 312.501 245.976 312.207V312.207Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.935 314.229C249.935 314.229 245.091 312.209 241.31 313.237C238.704 313.971 238.777 313.861 237.75 314.045C236.539 314.229 235.511 313.604 233.53 314.411C232.539 314.815 228.318 316.541 227.144 316.467C226.079 316.394 230.52 319.293 231.732 319.11C235.622 318.559 239.292 319.88 241.09 319.146C242.705 318.522 243.66 318.082 244.467 317.825C245.274 317.531 245.715 316.797 246.228 316.43C246.742 316.027 247.072 315.036 249.935 314.229L249.935 314.229Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.068 303.106C224.068 303.106 221.279 300.024 220.728 299.62C220.215 299.216 218.894 298.262 218.196 297.638C217.609 297.124 217.021 295.986 215.223 295.546C214.453 295.362 212.581 294.995 212.031 294.334C211.517 293.636 212.14 296.794 212.728 297.637C213.316 298.481 214.564 299.362 215.774 299.803C216.985 300.243 218.526 301.124 219.077 301.417C219.664 301.674 219.958 301.968 220.875 302.115C221.793 302.299 222.197 302.042 224.068 303.106L224.068 303.106Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.708 304.391C226.708 304.391 221.973 301.052 221.239 300.684C220.505 300.354 219.147 299.877 218.266 299.583C217.349 299.326 214.963 297.601 214.009 297.601C213.055 297.601 211.257 297.527 210.449 296.904C209.605 296.243 210.339 299.216 211.257 300.06C214.303 302.775 212.211 301.968 214.743 302.483C216.284 302.812 218.34 303.657 219.073 303.877C219.844 304.097 219.917 303.62 221.018 303.694C222.12 303.731 224.176 303.51 226.707 304.391L226.708 304.391Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.841 305.272C227.841 305.272 225.896 303.987 222.043 303.326C219.4 302.849 219.51 302.739 218.52 302.482C217.345 302.115 217.088 302.115 214.923 302.005C213.858 301.931 209.675 303.29 208.684 302.703C207.766 302.189 209.711 303.987 210.886 304.427C212.574 305.052 212.354 306.153 214.189 306.74C216.134 307.364 218.189 308.135 219.327 307.915C220.208 307.731 220.869 307.327 222.116 307.217C223.326 307.069 225.455 305.308 227.841 305.272V305.272Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.247 304.283C228.247 304.283 229.201 299.659 228.394 298.558C227.991 298.043 227.476 297.31 227.366 296.134C227.256 294.997 226.485 293.089 225.971 292.465C225.458 291.804 224.429 288.868 224.686 288.135C224.686 288.135 222.008 290.777 222.154 292.465C222.264 294.117 222.264 293.714 222.154 294.484C222.007 295.254 222.777 297.786 223.292 298.558C223.805 299.328 223.549 301.64 224.062 302.117C224.577 302.631 227.624 304.687 228.247 304.283L228.247 304.283Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.841 305.271C228.135 305.418 226.227 303.803 225.308 303.399C224.428 303.032 220.867 302.004 220.61 301.123C220.354 300.205 217.417 297.16 217.308 296.389C217.198 295.802 216.647 294.591 216.794 293.966C216.904 293.342 217.161 291.801 217.564 290.92C217.93 290.003 218.812 287.875 219.729 287.471C219.729 287.471 220.463 289.893 220.72 290.774C220.977 291.691 221.234 292.719 221.638 293.196C222.004 293.711 223.289 296.131 223.399 297.05C223.546 297.931 224.17 300.866 224.317 301.49C224.428 302.114 226.813 304.721 227.841 305.272L227.841 305.271Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.209 292.719C212.32 293.38 210.301 292.059 209.273 292.059C208.246 292.059 205.2 292.462 204.429 291.692C203.659 290.92 202.521 289.526 202.117 289.269C201.75 289.012 200.355 286.7 199.951 285.453C199.584 284.168 196.905 281.855 196.538 281.599C196.538 281.599 200.209 280.865 202.52 282.37C204.796 283.912 204.943 283.544 205.456 283.765C205.969 284.022 209.897 287.361 210.154 288.609C210.411 289.893 212.063 292.059 212.209 292.719L212.209 292.719Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.209 292.718C212.209 292.718 208.906 290.405 208.136 290.516C207.365 290.663 203.768 287.983 203.549 286.332C203.402 285.451 201.677 284.203 201.383 283.653C200.466 282.111 199.951 278.699 198.704 277.781C198.704 277.781 202.154 278.662 203.035 278.809C204.687 279.066 206.081 279.322 206.706 280.717C207.366 282.112 207.88 283.286 208.394 283.396C208.907 283.543 209.642 285.305 209.899 287.102C210.154 288.865 212.209 292.718 212.209 292.718H212.209Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.967 275.362C206.517 276.242 206.48 270.259 206.701 269.636C206.957 269.011 207.618 267.727 208.131 267.213C208.646 266.699 208.646 264.938 208.902 264.424C209.122 263.91 209.012 260.461 208.646 259.58C208.646 259.58 207.618 260.351 207.104 260.974C206.59 261.599 205.709 261.856 205.453 262.626C205.196 263.398 204.682 263.398 204.315 264.168C203.912 264.939 203.544 266.187 203.802 267.214C204.059 268.242 203.912 268.609 203.912 269.526C203.912 270.406 205.196 274.224 205.967 275.362L205.967 275.362Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.077 275.869C206.077 275.869 205.82 274.217 206.48 273.593C207.103 272.932 207.728 272.932 207.985 272.566C208.241 272.162 208.131 271.684 208.388 271.171C208.645 270.657 209.195 269.813 209.269 269.372C209.526 267.977 210.296 266.436 209.636 264.932C209.636 264.932 208.241 265.408 207.875 265.665C207.471 265.923 206.333 266.95 206.223 267.978C206.077 269.116 205.967 269.262 205.563 269.887C205.196 270.51 204.682 272.42 205.306 273.593C205.967 274.732 206.077 275.869 206.077 275.869L206.077 275.869Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.372 256.389C202.372 256.389 202.115 252.683 203.142 251.544C204.17 250.406 204.427 248.242 206.703 247.066C206.703 247.066 206.592 247.984 206.703 248.608C206.85 249.232 207.106 251.031 206.703 251.654C206.335 252.315 205.051 253.452 205.051 253.967C205.051 254.481 204.17 255.765 203.546 256.022C202.885 256.242 202.372 256.389 202.372 256.389L202.372 256.389Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.372 258.403C202.372 258.403 202.372 255.761 203.142 254.99C203.913 254.22 204.317 253.815 204.684 253.338C205.051 252.825 205.455 251.54 206.335 251.026C207.216 250.512 208.758 249.228 208.905 248.75C208.905 248.75 209.271 251.906 208.391 253.595C207.474 255.246 207.474 256.128 206.483 256.494C205.456 256.898 205.309 257.155 204.942 257.412C204.538 257.669 203.915 258.036 203.4 258.036C202.885 258.036 202.372 258.402 202.372 258.402L202.372 258.403Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.307 275.759C205.454 276.493 205.967 274.107 203.289 274.107C200.61 274.107 198.443 273.079 197.527 272.162C196.646 271.281 196.132 270.656 195.765 270.252C195.361 269.886 194.37 268.344 194.224 267.574C194.113 266.839 193.343 264.013 193.453 263.5C193.453 263.5 194.885 263.756 195.508 264.27C196.132 264.785 197.306 264.785 197.931 265.188C198.554 265.555 199.069 266.583 199.473 266.95C199.839 267.354 200.977 267.354 201.491 268.088C202.005 268.858 202.885 270.511 203.032 271.281C203.142 272.051 204.06 272.822 204.684 273.189C205.307 273.594 205.197 275.099 205.307 275.759H205.307Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.053 274.735C205.053 274.735 203.292 272.569 202.374 272.569C201.494 272.569 199.218 270.256 199.071 269.266C198.961 268.239 198.191 266.33 197.676 265.927C197.163 265.56 196.282 264.679 196.392 263.138C196.539 261.596 196.539 259.064 196.539 259.064C196.539 259.064 197.053 260.606 197.787 260.973C198.557 261.34 199.952 261.854 200.209 262.368C200.465 262.882 201.494 262.882 201.897 264.424C202.263 265.929 202.263 265.819 202.521 266.332C202.778 266.846 203.401 267.471 203.658 268.498C203.915 269.523 205.31 272.165 205.053 274.735L205.053 274.735Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.414 260.678C202.342 261.375 203.442 259.32 201.019 258.585C198.56 257.851 196.872 256.309 196.322 255.246C195.771 254.218 195.478 253.485 195.221 253.044C195.001 252.567 194.487 250.915 194.597 250.182C194.671 249.448 194.781 246.695 195.038 246.254C195.038 246.254 196.249 246.878 196.653 247.502C197.093 248.162 198.158 248.493 198.634 249.007C199.075 249.52 199.258 250.585 199.515 251.062C199.772 251.502 200.8 251.833 201.057 252.641C201.314 253.485 201.645 255.246 201.534 255.98C201.461 256.714 202.048 257.632 202.525 258.183C203.002 258.696 202.451 260.054 202.414 260.678H202.414Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.448 259.654C202.448 259.654 201.42 257.194 200.613 256.975C199.806 256.718 198.484 254.626 198.411 253.672C198.302 252.571 198.155 250.736 197.787 250.259C197.421 249.782 196.76 248.204 197.274 246.846C197.824 245.487 198.669 243.689 198.669 243.689C198.669 243.689 199.403 244.827 199.807 245.525C200.467 246.847 201.128 246.956 201.238 247.47C201.312 248.02 202.119 248.351 202.413 249.415C202.817 250.847 202.376 250.773 202.45 251.323C202.56 251.837 202.963 252.608 202.89 253.599C202.852 254.588 203.403 257.414 202.448 259.654L202.448 259.654Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.427 244.277C204.537 243.91 205.308 243.506 206.225 243.249C207.106 242.993 208.501 240.973 209.124 240.46C209.711 239.909 210.042 239.102 210.812 238.662C211.583 238.221 212.06 236.643 212.317 235.102C212.317 235.102 210.152 235.615 209.528 235.725C208.905 235.872 207.62 236.643 207.106 237.266C206.593 237.891 206.078 238.918 205.564 239.174C205.051 239.432 204.426 240.973 204.426 242C204.427 242.992 204.427 244.277 204.427 244.277L204.427 244.277Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.317 243.135C204.317 243.135 204.171 241.63 204.171 240.969C204.171 240.199 203.694 238.144 204.795 236.492C205.565 235.354 208.392 233.188 209.126 233.078C209.126 233.078 209.639 235.097 209.529 235.72C209.383 236.38 208.722 238.913 208.134 239.169C207.547 239.427 206.079 242.474 204.317 243.135H204.317Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.657 244.275C203.328 244.825 203.548 242.367 202.777 241.743C202.006 241.082 201.896 240.202 201.896 239.173C201.896 238.145 202.116 237.412 202.262 236.751C202.373 236.127 204.318 233.448 204.172 232.678C204.172 232.678 205.273 235.174 205.566 235.871C205.97 236.751 205.309 237.669 205.456 238.403C205.566 239.174 206.19 240.569 205.713 241.339C205.309 242 204.172 243.395 203.657 244.275H203.657Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.408 231.14C210.408 231.14 210.554 230.774 211.692 230.774C212.83 230.774 214.481 230.663 214.995 230.148C215.509 229.635 216.39 228.974 216.904 228.717C217.417 228.497 218.299 227.323 218.446 226.809C218.555 226.295 219.473 225.303 219.841 225.303C219.841 225.303 218.446 225.156 216.905 225.561C215.4 225.927 213.235 226.698 212.721 227.726C212.206 228.718 210.407 231.14 210.407 231.14L210.408 231.14Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.814 230.877C211.107 231.757 213.236 229.996 213.713 229.372C214.227 228.711 214.998 227.72 214.998 227.72C214.998 227.72 216.21 226.253 216.54 225.665C217.311 224.27 217.127 221.738 216.796 221.959C216.393 222.216 214.998 222.986 214.631 223.133C214.227 223.244 213.493 223.5 213.236 224.124C212.979 224.785 212.722 225.665 212.319 226.069C211.952 226.436 209.64 227.72 210.813 230.877H210.814Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.044 230.878C210.044 230.878 211.806 229.63 212.466 228.97C213.237 228.236 212.833 227.209 213.237 226.694C213.567 226.217 214.485 225.042 214.228 224.272C213.972 223.501 213.494 221.336 213.494 221.336C213.494 221.336 212.577 222.217 211.953 222.878C211.293 223.501 211.183 224.016 210.925 224.786C210.669 225.557 210.155 226.071 209.898 226.694C209.641 227.318 209.898 228.603 210.044 229.373C210.154 230.144 210.044 230.878 210.044 230.878V230.878Z",
    fill: "#1F601A",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M238.194 311.175C238.194 311.175 229.79 311.065 229.018 310.037",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M243.041 312.207C243.041 312.207 237.572 313.712 234.636 313.345C231.7 312.978 230.306 313.602 229.644 313.602C229.021 313.602 225.828 312.317 225.828 312.317",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M248.649 314.229C248.649 314.229 244.429 314.999 243.548 315.256C242.667 315.512 238.336 317.164 237.052 317.164C236.024 317.164 233.528 317.054 232.831 317.164C231.583 317.422 228.243 317.164 227.473 316.798",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M232.73 304.17C232.73 304.17 235.923 306.079 236.436 306.703C236.913 307.364 239.739 309.639 240.253 309.639",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M232.73 300.203C232.73 300.203 238.198 304.938 239.079 305.562C239.997 306.223 245.355 311.434 245.979 312.205",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M237.162 298.182C237.162 298.182 241.493 301.631 242.007 303.026C242.521 304.421 243.805 306.072 243.805 306.072C243.805 306.072 245.603 309.631 246.228 310.146C246.851 310.659 248.136 312.017 249.678 312.971",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M212.463 294.992C212.463 294.992 217.014 298.846 218.261 299.58",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M210.56 297.412C210.56 297.412 215.148 300.604 217.166 301.375C219.221 302.109 220.873 302.77 225.314 303.394",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M227.113 305.195C227.113 305.195 222.012 304.938 221.131 305.195C220.251 305.451 216.286 304.534 215.259 304.276C214.231 304.056 210.157 303.286 209.644 303.139",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M219.331 287.98C219.331 287.98 219.075 290.769 219.478 291.944C219.846 293.082 221.644 296.384 221.497 297.155C221.387 297.926 222.524 301.375 223.552 302",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M224.576 288.496C224.576 288.496 223.658 291.285 224.062 292.203C224.429 293.084 225.053 294.736 225.053 295.763C225.053 296.79 225.714 298.296 225.971 298.955C226.228 299.579 225.824 301.744 226.484 302.368C227.108 303.029 227.879 304.166 227.879 304.166",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M197.305 282C197.305 282 201.379 283.542 201.893 284.533C202.37 285.561 203.141 285.818 203.545 286.332",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M212.319 278.186C212.319 278.186 213.347 282.259 213.09 283.287C212.833 284.279 212.833 286.333 212.833 287.103C212.833 287.875 211.695 290.92 211.805 291.434",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M210.67 274.734C210.67 274.734 210.302 277.157 210.156 278.184C210.046 279.175 210.156 280.862 209.899 281.487C209.642 282.11 209.275 285.561 209.899 287.102",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M199.479 278.186C199.479 278.186 202.782 280.975 203.552 281.746C204.323 282.516 207.736 286.186 207.883 287.103C207.993 287.985 210.416 290.774 211.186 291.434",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M193.862 263.908C193.862 263.908 197.165 267.211 197.423 267.982C197.679 268.753 199.075 270 199.735 270.404",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M209.384 265.303C209.384 265.303 208.136 267.212 208.136 267.835C208.136 268.497 207.623 270.149 207.108 270.771C206.779 271.212 205.713 273.084 205.824 274.221",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M208.394 259.939C208.394 259.939 207.881 261.738 207.624 262.986C207.367 264.27 206.706 265.555 206.486 266.325C206.229 267.096 205.201 270.766 205.569 273.078",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M196.797 259.83C196.797 259.83 197.165 261.592 198.045 262.509C198.963 263.39 200.358 264.675 200.468 265.408C200.615 266.178 201.753 269.995 203.037 271.281C204.322 272.565 204.432 273.85 204.432 273.85",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M195.512 246.846C195.512 246.846 195.878 249.011 196.135 249.635C196.392 250.259 197.42 253.085 198.448 253.966",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M206.483 247.463C206.483 247.463 205.822 249.224 205.712 249.996C205.565 250.766 204.795 251.648 204.685 252.051C204.538 252.417 204.061 253.702 204.061 253.702",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M208.758 249.223C208.648 249.993 207.216 252.305 207.106 252.673C206.959 253.076 206.225 254.838 205.455 255.352C204.684 255.865 202.409 257.517 202.519 258.177",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M198.811 244.275C198.811 244.275 198.701 247.064 199.214 248.092C199.728 249.119 200.352 250.661 200.609 251.432C200.866 252.166 200.866 253.45 200.975 254.331C201.122 255.248 201.49 256.9 202.003 257.523",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M211.955 235.613C211.955 235.613 210.12 237.705 209.276 238.549C208.432 239.393 205.202 242.88 205.055 243.504",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M208.91 233.701C208.91 233.701 207.112 237.628 206.708 238.252C206.341 238.913 205.974 239.94 205.974 239.94",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M204.317 233.557C204.317 233.557 204.428 236.639 204.317 237.41C204.171 238.144 204.171 239.428 204.317 239.832C204.428 240.199 203.914 242.989 203.804 243.649",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M219.069 225.666C219.069 225.666 214.996 228.089 214.371 228.712",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M216.65 222.473L213.861 226.546L213.237 227.721",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M213.495 222.105C213.495 222.105 212.577 224.271 212.467 225.152C212.32 226.069 211.072 228.859 210.559 229.886",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M216.54 220.455C216.54 220.455 216.136 221.336 217.678 221.08",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.892 311.943C254.892 311.943 255.515 310.402 256.8 311.797C256.8 311.797 258.341 315.394 257.166 315.503C256.029 315.651 254.891 315.87 254.781 315.247C254.635 314.623 254.892 311.944 254.892 311.944V311.943Z",
    fill: "#00209F"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.541 311.437C256.541 311.437 256.944 305.968 257.679 305.711C258.449 305.454 260.761 304.169 262.156 305.307C263.551 306.481 262.266 312.134 261.753 312.648C261.275 313.161 260.505 314.74 257.569 314.373L257.165 312.978C257.165 312.978 258.706 312.832 259.734 312.317C260.762 311.803 261.092 311.326 261.019 310.812C260.872 310.042 260.945 307.216 260.175 306.959C259.403 306.702 258.192 306.335 258.192 306.335C258.192 306.335 257.054 310.592 256.798 311.803L256.541 311.437L256.541 311.437Z",
    fill: "#00209F"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.782 315.251C254.782 315.251 249.533 318.297 252.212 322.885L250.414 321.747C250.414 321.747 249.423 323.546 250.304 324.573C250.304 324.573 246.744 321.38 249.533 317.563C252.359 313.709 254.635 313.966 254.635 313.966L254.782 315.251H254.782Z",
    fill: "#00209F",
    stroke: "black",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.782 312.722C254.782 312.722 252.469 311.181 249.166 312.061C249.166 312.061 247.698 307.327 248.249 305.822C248.505 305.125 249.019 305.052 249.019 305.052C249.019 305.052 247.367 304.06 247.881 308.501C248.395 312.979 249.276 314.227 249.276 314.227C249.276 314.227 253.606 314.483 254.634 313.969L254.782 312.722V312.722Z",
    fill: "#00209F",
    stroke: "black",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.782 312.723C254.782 312.723 250.194 305.052 249.02 305.052C249.02 305.052 247.699 304.868 250.671 304.538C251.699 304.427 253.35 304.538 254.121 305.969C254.892 307.364 255.515 310.666 255.773 311.181C255.773 311.181 254.892 311.438 254.782 312.722L254.782 312.723Z",
    fill: "#00209F",
    stroke: "black",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.782 312.723C254.782 312.723 251.699 311.292 251.332 310.924C250.928 310.557 250.304 306.227 250.671 306.484C250.671 306.484 249.423 305.053 249.02 305.053C248.763 305.053 247.882 305.713 248.139 307.218C248.396 308.76 248.763 311.071 249.167 312.062C249.166 312.062 251.589 311.072 254.782 312.724V312.723Z",
    fill: "#011322",
    stroke: "black",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.573 315.253C257.573 315.253 259.225 316.28 259.225 318.188C259.225 320.097 259.996 323.547 261.537 324.317C261.537 324.317 261.904 322.886 262.418 322.629C262.418 322.629 263.96 324.428 264.437 324.428C264.437 324.428 263.556 322.776 263.556 322.005C263.556 321.234 262.785 318.299 262.014 317.564C261.28 316.794 259.738 314.995 257.574 314.371V315.253H257.573L257.573 315.253Z",
    fill: "#00209F",
    stroke: "black",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.199 306.336L256.805 311.804L257.171 312.979C257.171 312.979 257.686 312.832 257.942 312.208C258.199 311.547 258.97 306.849 259.374 306.702L258.199 306.336L258.199 306.336Z",
    fill: "#011322",
    stroke: "black",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.706 314.625C254.706 314.625 252.21 315.397 251.256 317.341C251.256 317.341 250.926 316.093 254.632 314.295L254.706 314.626L254.706 314.625Z",
    fill: "#011D33"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.649 314.625C257.649 314.625 259.374 315.323 259.815 316.35C259.815 316.35 258.163 315.249 257.649 315.066V314.626V314.625Z",
    fill: "#011D33"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.705 313.162C254.705 313.162 250.815 313.787 249.971 313.603C249.971 313.603 251.145 313.86 254.779 313.529L254.705 313.162V313.162Z",
    fill: "#011D33"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.024 310.811C261.024 310.811 261.465 312.757 261.759 312.647C262.089 312.5 262.75 309.381 262.786 307.913C262.86 306.481 262.162 306.151 261.575 306.224C261.024 306.261 260.694 307.546 260.767 308.133C260.804 308.683 260.951 310.482 261.024 310.811V310.811Z",
    fill: "#011D33"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.803 311.8C256.803 311.8 258.381 315.324 257.17 315.507C255.995 315.691 257.684 315.654 256.876 313.231C256.546 312.314 256.032 311.176 255.775 311.176C255.776 311.177 256.693 311.507 256.803 311.8V311.8Z",
    fill: "#011D33"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M254.892 311.943C254.892 311.943 255.515 310.402 256.8 311.797C256.8 311.797 258.341 315.394 257.166 315.503C256.029 315.651 254.891 315.87 254.781 315.247C254.635 314.623 254.892 311.944 254.892 311.944V311.943Z",
    stroke: "black",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M256.541 311.437C256.541 311.437 256.944 305.968 257.679 305.711C258.449 305.454 260.761 304.169 262.156 305.307C263.551 306.481 262.266 312.134 261.753 312.648C261.275 313.161 260.505 314.74 257.569 314.373L257.165 312.978C257.165 312.978 258.706 312.832 259.734 312.317C260.762 311.803 261.092 311.326 261.019 310.812C260.872 310.042 260.945 307.216 260.175 306.959C259.403 306.702 258.192 306.335 258.192 306.335C258.192 306.335 257.054 310.592 256.798 311.803L256.541 311.437L256.541 311.437Z",
    stroke: "black",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.891 218.696C250.56 217.889 250.488 212.457 250.56 211.613C250.67 210.144 253.202 202.951 253.716 202.107C254.267 201.263 254.121 201.079 254.34 200.565L255.074 199.574C255.625 200.492 256.028 201.923 256.138 203.061C256.138 203.061 255.662 206.511 255.257 208.053C254.891 209.594 253.899 211.723 253.716 212.163C253.239 213.228 253.276 214.219 253.57 214.292L250.891 218.696L250.891 218.696Z",
    fill: "#00209F"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.264 211.465L255.668 211.905C256.806 210.694 256.878 208.162 256.878 208.162L256.145 203.061C256.145 203.061 255.668 206.511 255.264 208.053C254.897 209.594 253.906 211.722 253.722 212.163C252.988 213.999 253.539 214.218 253.576 214.292L255.264 211.465L255.264 211.465Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.661 211.903C256.799 210.692 256.872 208.16 256.872 208.16C256.872 208.16 257.68 212.307 257.239 213.189C256.799 214.07 256.799 213.812 256.872 214.253L255.661 211.903V211.903Z",
    fill: "#00209F"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M256.871 214.255C256.798 213.815 256.798 214.072 257.238 213.191C257.679 212.31 256.871 208.162 256.871 208.162L256.137 203.061C256.027 201.923 255.624 200.492 255.073 199.574L254.339 200.565C254.12 201.078 254.267 201.262 253.716 202.107C253.202 202.951 250.67 210.144 250.559 211.613C250.487 212.457 250.559 217.889 250.89 218.696",
    stroke: "black",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.264 200.264C255.264 200.264 255.19 199.457 255.117 199.163C255.08 199.016 255.557 199.897 255.961 199.787C256.695 200.007 257.503 200.998 257.723 201.255C257.392 201.732 256.622 202.65 256.071 202.466C255.594 202.319 255.705 201.622 255.557 201.182C255.483 200.962 255.227 200.668 255.264 200.264V200.264Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M255.298 199.605C255.334 199.642 255.554 199.899 255.591 199.936C255.774 200.046 255.958 199.936 256.178 200.083C256.728 200.449 256.912 200.78 257.5 201.368",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M255.814 200.164C256.511 200.494 256.878 201.045 257.355 201.632C257.355 201.632 257.392 201.558 257.355 201.558",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.486 199.681C254.486 199.681 255.219 199.314 255.476 199.167C255.623 199.094 254.926 199.828 255.183 200.158C255.22 200.929 254.597 202.03 254.376 202.324C253.826 202.177 253.275 202.177 252.835 201.333C252.652 201.039 253.165 200.708 253.496 200.415C253.678 200.267 254.082 199.791 254.486 199.681H254.486Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M255.145 199.461C255.109 199.534 254.926 199.791 254.926 199.901C254.889 200.084 255.036 200.231 254.999 200.488C254.852 201.111 254.595 201.405 254.266 202.176",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M254.782 200.164C254.708 200.935 254.341 201.448 253.938 202.109C253.938 202.072 254.048 202.109 254.048 202.109",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.628 199.165C256.141 198.542 257.058 197.991 257.499 198.358C257.536 198.395 257.902 198.614 258.013 198.835C258.233 199.092 258.196 199.202 258.086 199.496C257.756 200.156 256.875 199.826 256.325 199.533C256.214 199.459 255.885 199.165 255.701 199.239C255.407 199.349 255.517 199.349 255.407 199.349C255.517 199.422 255.628 199.386 255.701 199.422C256.214 199.568 256.582 199.862 257.205 200.156C257.646 200.339 258.453 199.752 258.417 199.349C258.417 198.871 257.646 198.027 257.279 198.027C256.435 198.027 255.774 198.541 255.187 199.202C255.334 199.092 255.517 199.312 255.628 199.165L255.628 199.165Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.145 199.165C254.669 198.542 253.751 197.991 253.311 198.358C253.274 198.395 252.907 198.614 252.797 198.835C252.577 199.055 252.577 199.202 252.724 199.496C253.018 200.156 253.935 199.826 254.448 199.533C254.595 199.459 254.926 199.165 255.109 199.239C255.402 199.349 255.292 199.349 255.402 199.349C255.292 199.422 255.182 199.386 255.072 199.422C254.595 199.568 254.228 199.862 253.568 200.156C253.128 200.339 252.356 199.752 252.356 199.349C252.393 198.835 253.164 198.027 253.531 198.027C254.375 198.027 255.036 198.541 255.586 199.202C255.475 199.092 255.292 199.312 255.145 199.165V199.165Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.331 198.802C255.111 198.728 254.855 198.948 254.781 199.095C254.708 199.278 254.855 199.571 255.074 199.608C255.368 199.718 255.771 199.645 255.845 199.315C255.918 199.021 255.589 198.948 255.331 198.802Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.298 193.701C255.298 193.701 255.628 195.684 256.619 197.115C257.61 198.545 255.408 198.363 255.261 198.876C255.261 198.876 254.601 197.445 253.903 197.078C253.903 197.078 255.004 195.353 255.298 193.738V193.701L255.298 193.701Z",
    fill: "#FFCC00"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M255.298 193.701C255.298 193.701 255.628 195.684 256.619 197.115C256.619 197.115 255.408 198.363 255.261 198.876C255.261 198.876 254.601 197.445 253.903 197.078C253.903 197.078 255.004 195.353 255.298 193.738",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M255.264 195.791C255.264 195.791 255.52 196.672 255.814 197.259C255.814 197.259 255.337 197.627 255.264 197.846C255.264 197.846 255.008 197.259 254.75 197.113C254.75 197.113 255.227 196.342 255.264 195.791V195.791Z",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.264 293.673C255.19 293.673 255.08 293.525 254.971 293.489C254.64 293.269 254.017 293.269 253.87 293.085C252.989 292.095 253.576 290.186 253.942 289.012C254.676 286.81 254.786 284.791 255.264 282.699H255.3C255.777 284.791 255.887 286.81 256.585 289.012C256.988 290.186 257.576 292.095 256.695 293.085C256.512 293.269 255.925 293.269 255.594 293.489C255.483 293.525 255.374 293.673 255.264 293.673H255.264Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.264 282.627C255.741 284.719 255.887 286.847 256.585 289.049C256.952 290.15 257.503 291.912 256.842 292.903V292.866C257.172 292.866 257.466 292.756 257.76 292.646C257.87 292.609 257.979 292.572 258.016 292.462C258.126 292.279 258.273 292.132 258.42 292.022C258.64 291.875 258.898 291.985 259.118 291.838C259.192 291.765 259.228 291.691 259.265 291.691C259.705 291.471 260.146 291.214 260.329 290.737C260.439 290.407 260.476 290.039 260.403 289.672C260.366 289.416 260.256 289.232 260.182 289.012C260.035 288.681 259.889 288.351 259.742 288.021C259.595 287.69 259.374 287.397 259.228 287.066C259.155 286.883 259.081 286.736 258.971 286.589C258.898 286.442 258.787 286.296 258.714 286.149C258.641 286.002 258.457 285.891 258.347 285.745C258.2 285.598 258.163 285.598 258.053 285.488C258.016 285.452 257.833 285.415 257.87 285.341C257.797 285.341 257.686 285.268 257.65 285.231C257.356 284.607 257.099 284.277 256.806 283.653C256.659 283.396 256.622 282.919 256.622 282.625H255.264V282.627L255.264 282.627Z",
    fill: "#00209F"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.264 282.627C254.824 284.719 254.677 286.847 253.942 289.049C253.612 290.15 253.062 291.912 253.722 292.903L253.685 292.866H253.722C253.392 292.866 253.098 292.756 252.768 292.646C252.694 292.609 252.584 292.572 252.511 292.462C252.401 292.279 252.291 292.132 252.108 292.022C251.924 291.875 251.668 291.985 251.447 291.838C251.374 291.765 251.337 291.691 251.265 291.691C250.824 291.471 250.421 291.214 250.237 290.737C250.127 290.407 250.09 290.039 250.163 289.672C250.2 289.416 250.309 289.232 250.384 289.012C250.531 288.681 250.677 288.351 250.824 288.021C250.971 287.69 251.153 287.397 251.337 287.066C251.411 286.883 251.484 286.736 251.594 286.589C251.668 286.442 251.74 286.296 251.85 286.149C251.924 286.002 252.108 285.891 252.218 285.745C252.365 285.598 252.401 285.598 252.511 285.488C252.547 285.452 252.731 285.415 252.694 285.341C252.768 285.341 252.877 285.268 252.877 285.231C253.208 284.607 253.465 284.277 253.758 283.653C253.905 283.396 253.942 282.919 253.942 282.625H255.264V282.627L255.264 282.627Z",
    fill: "#00209F"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M254.638 282.703C254.638 282.703 253.794 286.152 253.316 287.034C252.803 287.915 250.82 289.53 252.105 292.025",
    stroke: "#011322",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M254.706 282.703C254.706 282.703 253.898 286.189 253.384 287.07C252.87 287.988 250.925 289.639 252.246 292.135",
    stroke: "#011D33",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M254.815 282.703C254.815 282.703 253.972 286.226 253.457 287.143C252.981 288.025 251.035 289.749 252.393 292.245",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M254.892 282.703C254.892 282.703 254.084 286.299 253.57 287.18C253.057 288.062 251.148 289.822 252.506 292.391",
    stroke: "#033054",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M255.002 282.703C255.002 282.703 254.158 286.336 253.643 287.253C253.13 288.135 251.258 289.932 252.653 292.502",
    stroke: "#053A65",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M254.562 282.703C254.562 282.703 253.754 286.042 253.203 286.997C252.69 287.915 250.707 289.53 252.029 291.988",
    stroke: "#011D33",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M254.452 282.736C254.452 282.736 253.681 285.928 253.094 286.994C252.58 287.874 250.598 289.49 251.92 291.948",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M254.376 282.736C254.376 282.736 253.605 285.819 252.982 286.957C252.504 287.838 250.486 289.453 251.807 291.948",
    stroke: "#033054",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M254.266 282.736C254.266 282.736 253.569 285.745 252.871 286.92C252.394 287.838 250.412 289.416 251.697 291.911",
    stroke: "#053A65",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M254.198 282.771C254.198 282.771 253.501 285.633 252.803 286.919C252.29 287.799 250.307 289.415 251.629 291.873",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M255.078 282.703C255.078 282.703 254.271 286.41 253.756 287.29C253.243 288.172 251.407 290.042 252.765 292.649",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M258.343 285.748C258.453 285.895 258.637 286.005 258.71 286.152C258.784 286.299 258.894 286.446 258.967 286.593C259.077 286.74 259.151 286.887 259.224 287.069C259.37 287.4 259.591 287.694 259.738 288.024C259.885 288.354 260.032 288.685 260.178 289.015C260.252 289.236 260.362 289.419 260.399 289.676C260.472 290.043 260.436 290.41 260.325 290.741C260.142 291.217 259.701 291.475 259.261 291.695C259.224 291.695 259.187 291.768 259.114 291.842C258.894 291.989 258.637 291.879 258.416 292.026C258.269 292.136 258.122 292.283 258.012 292.465C257.975 292.576 257.866 292.612 257.756 292.649C257.462 292.759 257.168 292.869 256.838 292.869V292.906V292.869C256.802 292.943 256.728 293.016 256.692 293.09C256.508 293.274 255.921 293.274 255.59 293.493C255.48 293.53 255.37 293.678 255.26 293.678C255.186 293.678 255.076 293.53 254.967 293.493C254.636 293.274 254.013 293.274 253.866 293.09C253.792 293.016 253.756 292.943 253.719 292.869V292.906L253.682 292.869H253.719C253.389 292.869 253.095 292.759 252.765 292.649C252.691 292.612 252.581 292.576 252.508 292.465C252.398 292.283 252.288 292.136 252.104 292.026C251.921 291.879 251.665 291.989 251.444 291.842C251.371 291.768 251.334 291.695 251.261 291.695C250.821 291.475 250.417 291.217 250.234 290.741C250.124 290.41 250.087 290.043 250.16 289.676C250.197 289.419 250.306 289.236 250.381 289.015C250.528 288.685 250.674 288.354 250.821 288.024C250.967 287.694 251.15 287.4 251.334 287.069C251.407 286.887 251.481 286.74 251.591 286.593C251.664 286.446 251.737 286.299 251.847 286.152C251.921 286.005 252.104 285.895 252.215 285.748",
    stroke: "black",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.884 250.553C230.636 247.434 229.315 241.047 229.388 239.58C229.644 233.561 229.572 231.763 230.122 225.598L236.324 232.681C236.177 235.066 236.141 235.8 236.324 237.304C236.398 237.855 236.728 240.571 237.168 241.635L231.884 250.553V250.553Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.162 241.628C236.722 240.564 236.392 237.849 236.318 237.298C236.135 235.793 236.171 235.059 236.318 232.674L240.135 236.894L237.162 241.628H237.162Z",
    fill: "#00209F"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.387 247.465C221.277 246.07 221.167 244.529 221.167 243.832C221.203 239.501 220.69 237.079 221.167 232.491C221.534 228.895 222.415 224.16 222.231 220.27C222.157 219.169 222.377 218.068 222.415 217.004L230.122 225.592C229.572 231.758 229.645 233.556 229.388 239.574C229.315 241.042 230.636 247.428 231.884 250.548L230.27 253.263L221.387 247.465L221.387 247.465Z",
    fill: "#00209F"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.783 259.104C226.27 258.26 225.829 255.838 225.719 255.361C225.463 254.077 225.463 253.342 225.536 251.141L229.794 253.93L226.783 259.104H226.783Z",
    fill: "#00209F"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.628 279.431C214.151 279.138 213.344 278.293 213.087 277.559C212.572 276.091 212.683 276.127 212.316 274.513C212.097 273.596 212.097 272.568 211.875 271.614C211.693 270.66 210.334 267.614 210.298 266.366C210.152 262.366 208.829 259.65 209.16 255.282C209.38 251.906 210.151 247.318 209.783 243.794C209.673 242.84 209.82 241.738 209.857 240.785L218.518 246.437C218.188 252.236 218.335 253.851 218.335 259.465C218.298 260.824 219.509 266.328 220.977 268.788L214.628 279.43L214.628 279.431Z",
    fill: "#00209F"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.017 282.627C230.632 284.095 233.605 284.866 234.082 285.197C235.146 285.967 236.724 287.105 239.404 287.252C241.385 287.399 242.266 286.885 244.285 286.628C246.597 286.334 243.991 286.702 246.23 286.224C247.367 285.93 247.367 285.747 248.908 285.38C250.046 285.123 251.184 284.829 251.881 283.875C252.138 283.508 252.358 283.215 252.395 282.627H253.936C254.083 283.067 253.642 283.912 253.496 284.206C253.386 284.353 253.202 284.609 253.093 284.756C252.873 285.233 252.909 285.123 252.505 285.49C252.396 285.564 251.919 285.967 251.772 286.04C251.479 286.261 251.185 286.555 250.854 286.591C249.349 286.849 248.726 287.178 247.294 287.582C245.936 287.986 246.67 287.913 245.643 288.17C245.129 288.279 244.101 288.683 243.588 288.757C242.67 288.904 242.523 289.051 241.569 289.271C239.11 289.821 236.725 289.674 234.302 289.528C233.312 289.455 230.889 288.94 230.045 288.353C228.54 287.288 225.237 286.885 223.769 285.858C223.55 285.71 222.631 285.27 222.449 285.086C221.017 283.912 219.879 283.581 218.375 282.627H229.017L229.017 282.627Z",
    fill: "#00209F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.656 282.627H252.401C252.364 283.215 252.143 283.508 251.886 283.875C251.189 284.829 250.051 285.123 248.914 285.38C247.702 285.673 246.454 285.013 245.17 285.013C242.087 284.059 241.72 283.104 240.656 282.627L240.656 282.627Z",
    fill: "#00209F"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.656 282.627C241.72 283.178 242.234 284.095 245.17 285.013C246.308 285.013 247.556 285.527 248.62 285.49C247.336 285.784 247.299 285.967 246.235 286.224C243.996 286.702 246.601 286.334 244.29 286.628C242.271 286.885 241.39 287.399 239.409 287.252C236.73 287.105 235.151 285.967 234.087 285.196C233.609 284.866 230.637 284.095 229.021 282.627H240.656L240.656 282.627Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M222.817 221.92C222.817 221.92 224.248 234.582 229.166 234.105",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M229.169 234.032C226.71 234.143 225.095 231.023 224.178 228.087C223.224 225.078 222.82 221.922 222.82 221.885",
    stroke: "#022847",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M229.169 233.999C226.71 233.926 225.095 230.77 224.251 228.017C223.261 225.118 222.82 221.888 222.82 221.852",
    stroke: "#032B4C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M229.203 233.964C226.744 233.744 225.093 230.515 224.285 227.945C223.331 225.12 222.854 221.89 222.817 221.816",
    stroke: "#032D4F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M229.203 233.923C226.744 233.519 225.093 230.216 224.322 227.867C223.368 225.115 222.854 221.848 222.817 221.738",
    stroke: "#032F53",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M229.237 233.855C226.741 233.341 225.09 229.965 224.393 227.799C223.438 225.12 222.851 221.817 222.814 221.707",
    stroke: "#043258",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M229.237 233.812C226.777 233.115 225.09 229.701 224.428 227.72C223.474 225.114 222.851 221.811 222.851 221.664",
    stroke: "#04345B",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M229.279 233.778C226.783 232.934 225.095 229.448 224.471 227.613C223.553 225.154 222.856 221.778 222.856 221.631",
    stroke: "#04365E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M229.279 233.745C226.783 232.717 225.095 229.194 224.544 227.543C223.59 225.157 222.893 221.781 222.856 221.561",
    stroke: "#043862",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M229.279 233.669C226.82 232.531 225.095 228.898 224.581 227.467C223.627 225.154 222.893 221.741 222.856 221.521",
    stroke: "#053B67",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M229.313 233.626C226.817 232.341 225.092 228.635 224.615 227.387C223.697 225.148 222.89 221.735 222.853 221.479",
    stroke: "#053D6A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M229.313 233.593C226.817 232.124 225.092 228.381 224.688 227.317C223.734 225.152 222.89 221.702 222.853 221.445",
    stroke: "#053F6E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M229.347 233.559C226.851 231.945 225.089 228.128 224.722 227.21C223.804 225.192 222.924 221.668 222.85 221.375",
    stroke: "#064172",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M222.85 221.336C222.924 221.666 223.841 225.189 224.759 227.134C225.089 227.831 226.851 231.722 229.347 233.484",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M223.003 219.061C223.003 219.061 227.113 229.117 229.718 227.979",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M229.719 227.977C228.581 228.454 226.893 226.435 225.535 224.087C224.066 221.517 223.002 219.021 223.002 219.021",
    stroke: "#022A49",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M229.719 227.943C228.728 228.383 226.967 226.438 225.572 224.016C224.067 221.337 223.002 218.988 223.002 218.988",
    stroke: "#032D4F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M229.719 227.91C228.875 228.276 227.04 226.441 225.608 223.946C224.03 221.121 223.039 218.955 223.039 218.955",
    stroke: "#033054",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M229.719 227.909C229.022 228.203 227.077 226.441 225.682 223.872C224.031 220.936 223.04 218.918 223.04 218.918",
    stroke: "#043359",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M229.753 227.866C229.166 228.123 227.147 226.434 225.716 223.792C224.028 220.709 223.074 218.838 223.074 218.838",
    stroke: "#043760",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M229.753 227.866C229.313 228.05 227.22 226.435 225.752 223.719C224.028 220.526 223.074 218.801 223.074 218.801",
    stroke: "#053A65",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M229.753 227.833C229.46 227.98 227.293 226.438 225.789 223.649C223.991 220.309 223.11 218.768 223.11 218.768",
    stroke: "#053D6A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M229.753 227.832C229.607 227.869 227.367 226.437 225.826 223.611C223.991 220.125 223.109 218.73 223.109 218.73",
    stroke: "#064171",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M223.113 218.697C223.113 218.697 223.993 219.909 225.865 223.541C227.407 226.441 229.755 227.799 229.755 227.799",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M236.545 238L239.734 237.408",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M236.325 234.734L239.776 236.604",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M236.249 234.879L239.776 236.604",
    stroke: "#064171",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M236.249 235.021L239.81 236.637",
    stroke: "#053E6C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M236.249 235.209L239.81 236.681",
    stroke: "#053B67",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M236.283 235.352L239.844 236.713",
    stroke: "#043862",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M236.283 235.504L239.886 236.714",
    stroke: "#04355C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M236.283 235.648L239.92 236.748",
    stroke: "#043258",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M236.283 235.791L239.954 236.789",
    stroke: "#032F53",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M236.283 235.979L239.996 236.824",
    stroke: "#032C4D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M236.283 236.131L240.03 236.858",
    stroke: "#022A49",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M236.503 237.847L239.776 237.373",
    stroke: "#064171",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M236.503 237.669L239.81 237.297",
    stroke: "#053E6C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M236.469 237.484L239.844 237.264",
    stroke: "#053B67",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M236.469 237.34L239.886 237.23",
    stroke: "#043862",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M236.435 237.154H239.92",
    stroke: "#04355C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M236.435 236.967L239.954 237.119",
    stroke: "#043258",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M236.435 236.824L239.996 237.044",
    stroke: "#032F53",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M236.393 236.637L240.064 237.009",
    stroke: "#032C4D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M236.393 236.461L240.106 236.968",
    stroke: "#022A49",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M236.359 236.309L240.14 236.901",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M221.387 237.229C221.387 237.229 221.571 239.907 222.157 241.045C223.001 242.624 225.461 245.046 228.286 246.808",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M228.357 246.804C226.522 245.629 224.871 244.162 223.733 242.877C223.109 242.217 222.595 241.519 222.265 240.969C221.678 239.794 221.421 237.152 221.421 237.152",
    stroke: "#022847",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M228.433 246.805C226.598 245.631 224.946 244.053 223.845 242.805C223.222 242.145 222.707 241.483 222.414 240.86C221.754 239.685 221.423 237.08 221.423 237.08",
    stroke: "#032B4C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M228.467 246.804C226.669 245.593 225.018 243.942 223.952 242.767C223.366 242.107 222.851 241.409 222.522 240.786C221.824 239.538 221.421 237.006 221.421 237.006",
    stroke: "#032D4F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M228.543 246.771C226.745 245.56 225.094 243.872 224.029 242.697C223.478 242.074 223.001 241.376 222.634 240.715C221.9 239.431 221.422 236.936 221.422 236.936",
    stroke: "#032F53",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M228.611 246.77C226.813 245.559 225.197 243.761 224.133 242.623C223.62 242.036 223.105 241.338 222.738 240.641C221.967 239.32 221.453 236.861 221.453 236.861",
    stroke: "#043258",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M228.687 246.771C226.889 245.523 225.273 243.652 224.246 242.551C223.733 241.964 223.255 241.267 222.851 240.569C222.044 239.174 221.456 236.789 221.456 236.789",
    stroke: "#04345B",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M228.721 246.771C226.996 245.487 225.344 243.542 224.353 242.477C223.876 241.927 223.362 241.23 222.958 240.496C222.114 239.064 221.453 236.715 221.453 236.715",
    stroke: "#04365E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M228.797 246.736C227.071 245.488 225.42 243.469 224.466 242.405C223.989 241.891 223.512 241.157 223.071 240.423C222.19 238.955 221.457 236.643 221.457 236.643",
    stroke: "#043862",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M228.873 246.737C227.147 245.452 225.496 243.36 224.579 242.333C224.139 241.855 223.625 241.122 223.184 240.351C222.266 238.809 221.496 236.57 221.496 236.57",
    stroke: "#053B67",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M228.907 246.737C227.218 245.453 225.604 243.251 224.686 242.26C224.246 241.782 223.769 241.048 223.291 240.278C222.374 238.7 221.493 236.498 221.493 236.498",
    stroke: "#053D6A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M228.983 246.737C227.295 245.415 225.68 243.176 224.799 242.222C224.396 241.745 223.882 241.011 223.404 240.204C222.45 238.589 221.496 236.424 221.496 236.424",
    stroke: "#053F6E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M229.059 246.695C227.371 245.374 225.756 243.062 224.912 242.144C224.508 241.704 224.031 240.933 223.553 240.126C222.526 238.437 221.498 236.346 221.498 236.346",
    stroke: "#064172",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M221.497 236.273C221.497 236.273 223.883 240.788 225.021 242.072C225.828 242.953 227.443 245.375 229.131 246.696",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M221.565 247.465C224.17 249.189 224.831 249.63 230.226 253.08L231.878 250.547C231.878 250.547 231.254 249.043 230.997 248.345",
    stroke: "#011D33",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M221.607 247.432C224.103 249.12 224.946 249.67 230.231 252.973L230.304 252.9C230.304 252.864 231.772 250.441 231.772 250.441C231.772 250.441 231.698 250.148 231.515 249.781C231.332 249.304 231.111 248.753 231.001 248.35",
    stroke: "#011E34",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M221.607 247.432C224.029 249.047 225.094 249.744 230.231 252.9L230.304 252.79C230.304 252.717 231.698 250.331 231.698 250.331C231.698 250.331 231.625 250.075 231.479 249.707C231.295 249.267 231.111 248.716 231.001 248.35",
    stroke: "#022037",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M221.607 247.432C223.956 248.973 225.24 249.781 230.231 252.79L230.304 252.68C230.304 252.606 231.625 250.257 231.588 250.257C231.588 250.257 231.551 250 231.405 249.67C231.258 249.23 231.075 248.715 230.964 248.349",
    stroke: "#022139",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M221.607 247.398C223.883 248.903 225.387 249.821 230.231 252.683L230.304 252.573C230.304 252.463 231.515 250.151 231.515 250.151C231.515 250.151 231.515 249.93 231.368 249.6C231.185 249.16 231.038 248.719 230.964 248.353",
    stroke: "#02223B",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M221.641 247.398C223.806 248.83 225.531 249.894 230.228 252.573C230.265 252.573 230.302 252.463 230.302 252.463C230.302 252.316 231.439 250.077 231.439 250.04C231.403 250.04 231.439 249.857 231.292 249.527C231.146 249.124 231.035 248.72 230.962 248.353",
    stroke: "#02233D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M221.641 247.355C223.733 248.75 225.678 249.925 230.266 252.457C230.266 252.457 230.303 252.347 230.34 252.347C230.34 252.164 231.367 249.961 231.331 249.961C231.331 249.961 231.367 249.777 231.257 249.447C231.11 249.081 231 248.714 230.963 248.346",
    stroke: "#022540",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M221.641 247.355C223.659 248.714 225.825 249.961 230.266 252.347L230.34 252.236C230.34 252.054 231.257 249.887 231.257 249.851C231.257 249.851 231.331 249.704 231.184 249.411C231.037 249.008 230.963 248.714 230.927 248.346",
    stroke: "#022541",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M221.641 247.355C223.586 248.64 225.972 250.034 230.266 252.273C230.266 252.236 230.34 252.127 230.34 252.127C230.34 251.907 231.184 249.778 231.147 249.741C231.147 249.741 231.257 249.631 231.147 249.338C231 248.971 230.963 248.678 230.927 248.347",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M221.675 247.322C223.509 248.57 226.116 250.075 230.263 252.167C230.263 252.131 230.336 252.057 230.336 252.02C230.336 251.763 231.07 249.671 231.07 249.671C231.07 249.671 231.18 249.561 231.07 249.268C230.923 248.938 230.923 248.681 230.923 248.351",
    stroke: "#022847",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M221.675 247.322C223.436 248.497 226.226 250.148 230.263 252.057C230.299 252.02 230.336 251.947 230.336 251.91C230.336 251.617 230.996 249.598 230.96 249.561C230.96 249.561 231.143 249.452 231.033 249.195C230.886 248.864 230.923 248.681 230.923 248.351",
    stroke: "#022A49",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M221.675 247.322C223.362 248.423 226.372 250.185 230.263 251.947C230.299 251.91 230.336 251.837 230.373 251.8C230.336 251.506 230.923 249.488 230.886 249.488C230.886 249.451 231.07 249.378 230.96 249.121C230.85 248.827 230.886 248.68 230.886 248.351",
    stroke: "#032A4A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M221.717 247.287C223.295 248.351 226.524 250.223 230.269 251.838C230.305 251.802 230.342 251.729 230.379 251.692C230.379 251.362 230.819 249.417 230.782 249.38C230.782 249.38 231.002 249.306 230.928 249.087C230.782 248.793 230.855 248.683 230.891 248.353",
    stroke: "#032B4C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M221.717 247.287C223.221 248.278 226.671 250.296 230.269 251.728C230.305 251.728 230.379 251.618 230.379 251.581C230.379 251.215 230.745 249.305 230.709 249.269C230.709 249.269 230.965 249.232 230.855 249.013C230.745 248.719 230.855 248.682 230.891 248.352",
    stroke: "#032D4F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M221.717 247.287C223.148 248.205 226.818 250.333 230.305 251.655C230.305 251.618 230.379 251.508 230.379 251.471C230.379 251.105 230.671 249.232 230.635 249.195H230.598C230.598 249.195 230.891 249.159 230.818 248.938C230.708 248.682 230.818 248.682 230.891 248.351",
    stroke: "#032E50",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M221.717 247.246C223.074 248.164 226.965 250.366 230.305 251.54C230.342 251.504 230.379 251.394 230.379 251.357C230.379 250.954 230.561 249.119 230.525 249.082L230.745 248.861C230.635 248.642 230.782 248.642 230.891 248.348",
    stroke: "#032F53",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M221.751 247.246C222.999 248.09 227.108 250.439 230.302 251.43C230.339 251.393 230.376 251.283 230.376 251.246C230.376 250.806 230.485 249.008 230.449 248.971C230.449 248.971 230.779 249.007 230.706 248.825C230.595 248.568 230.779 248.641 230.852 248.348",
    stroke: "#033156",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M221.751 247.211C222.925 248.018 227.255 250.477 230.302 251.321C230.339 251.285 230.376 251.174 230.412 251.138C230.412 250.661 230.375 248.936 230.339 248.899C230.339 248.899 230.706 248.936 230.632 248.753C230.559 248.532 230.742 248.643 230.852 248.35",
    stroke: "#043258",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M221.751 247.211C222.852 247.945 227.402 250.514 230.302 251.211C230.339 251.175 230.376 251.064 230.412 251.028C230.412 250.551 230.302 248.825 230.266 248.789C230.266 248.789 230.632 248.861 230.595 248.679C230.485 248.495 230.706 248.642 230.852 248.349",
    stroke: "#043359",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M221.751 247.211C222.778 247.871 227.512 250.588 230.302 251.101C230.339 251.064 230.412 250.992 230.412 250.918C230.412 250.404 230.228 248.753 230.155 248.679C230.155 248.679 230.595 248.79 230.522 248.606C230.448 248.422 230.706 248.643 230.852 248.35",
    stroke: "#04355C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M221.785 247.178C222.702 247.801 227.656 250.628 230.299 251.031C230.336 250.958 230.408 250.885 230.408 250.811C230.408 250.261 230.116 248.646 230.079 248.609C230.079 248.609 230.519 248.683 230.445 248.573C230.409 248.389 230.666 248.646 230.813 248.353",
    stroke: "#04365E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M221.785 247.178C222.629 247.728 227.803 250.701 230.299 250.922C230.373 250.848 230.408 250.775 230.408 250.701C230.408 250.151 230.042 248.573 229.969 248.499C229.969 248.499 230.445 248.609 230.408 248.499C230.336 248.353 230.666 248.609 230.813 248.353",
    stroke: "#043760",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M221.785 247.178C222.555 247.655 227.95 250.737 230.336 250.811C230.373 250.738 230.409 250.665 230.446 250.591C230.409 250.004 229.969 248.462 229.896 248.389C229.896 248.389 230.409 248.536 230.336 248.426C230.3 248.28 230.629 248.609 230.813 248.353",
    stroke: "#043862",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M221.827 247.135C222.488 247.576 228.103 250.769 230.341 250.695C230.378 250.658 230.414 250.548 230.451 250.475C230.451 249.851 229.864 248.346 229.827 248.309H229.79C229.79 248.309 230.341 248.455 230.305 248.346C230.268 248.236 230.598 248.602 230.818 248.346",
    stroke: "#053A65",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M221.827 247.135C222.415 247.539 228.25 250.842 230.341 250.585C230.378 250.548 230.451 250.438 230.451 250.365C230.451 249.704 229.79 248.273 229.717 248.199C229.717 248.199 230.268 248.382 230.23 248.309C230.194 248.199 230.598 248.602 230.818 248.346",
    stroke: "#053B67",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M221.827 247.135C222.34 247.465 228.397 250.879 230.341 250.475C230.378 250.438 230.451 250.328 230.451 250.255C230.451 249.594 229.717 248.163 229.644 248.126V248.09C229.644 248.09 230.23 248.31 230.194 248.237C230.157 248.126 230.561 248.603 230.781 248.347",
    stroke: "#053C68",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M221.827 247.102C222.268 247.395 228.543 250.919 230.341 250.405C230.414 250.331 230.451 250.222 230.451 250.149C230.451 249.451 229.607 248.093 229.533 248.02C229.533 248.02 230.157 248.24 230.12 248.167C230.083 248.093 230.523 248.607 230.78 248.35",
    stroke: "#053E6C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M221.861 247.102C222.191 247.322 228.688 250.992 230.339 250.295C230.411 250.221 230.448 250.111 230.485 250.037C230.448 249.304 229.531 247.982 229.457 247.909C229.457 247.909 230.081 248.166 230.081 248.092C230.044 248.056 230.521 248.606 230.778 248.349",
    stroke: "#053F6E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M221.861 247.102C222.118 247.248 228.798 251.028 230.339 250.184C230.411 250.111 230.448 250.001 230.485 249.927C230.485 249.194 229.421 247.872 229.347 247.835C229.347 247.835 230.044 248.092 230.007 248.056C230.007 247.982 230.484 248.569 230.778 248.35",
    stroke: "#053F6F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M221.861 247.059C222.044 247.169 228.945 251.059 230.339 250.068C230.411 249.995 230.448 249.921 230.485 249.811C230.485 249.04 229.347 247.792 229.274 247.719C229.274 247.719 229.971 248.013 229.971 247.976C229.934 247.939 230.484 248.563 230.741 248.343",
    stroke: "#064171",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M221.861 247.059C221.971 247.095 229.091 251.132 230.375 249.958C230.412 249.884 230.485 249.811 230.485 249.701C230.485 248.893 229.273 247.682 229.163 247.609L229.897 247.902C229.897 247.902 230.447 248.562 230.741 248.342",
    stroke: "#064374",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M221.903 247.025C221.903 247.025 230.124 251.65 230.491 249.595C230.491 248.751 229.096 247.54 229.096 247.54L229.867 247.833C229.867 247.833 230.417 248.566 230.747 248.347",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M220.947 268.79L214.561 279.432C214.083 279.139 213.276 278.295 213.019 277.561C212.542 276.092 212.615 276.092 212.249 274.515C212.066 273.597 212.029 272.57 211.845 271.615C211.625 270.661 210.267 267.615 210.23 266.367",
    stroke: "#011D33",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.617 211.625 270.59 211.845 271.544C212.029 272.499 212.066 273.527 212.248 274.443C212.615 276.022 212.541 275.985 213.056 277.452C213.276 278.186 214.12 279.031 214.561 279.324C214.597 279.324 220.91 268.791 220.947 268.791",
    stroke: "#011D33",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.581 211.625 270.553 211.809 271.507C212.029 272.462 212.066 273.453 212.285 274.37C212.652 275.911 212.541 275.911 213.056 277.379C213.313 278.076 214.12 278.921 214.561 279.215C214.598 279.215 220.873 268.827 220.947 268.792",
    stroke: "#011E34",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.581 211.588 270.516 211.809 271.47C212.029 272.389 212.066 273.38 212.285 274.296C212.652 275.838 212.541 275.801 213.056 277.269C213.313 277.967 214.12 278.774 214.561 279.068C214.634 279.104 220.873 268.828 220.947 268.791",
    stroke: "#011E34",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.545 211.588 270.48 211.809 271.397C212.029 272.352 212.066 273.306 212.285 274.223C212.652 275.728 212.578 275.728 213.056 277.159C213.313 277.856 214.12 278.664 214.561 278.958C214.671 278.994 220.837 268.827 220.947 268.792",
    stroke: "#011F36",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.545 211.588 270.443 211.809 271.361C212.029 272.279 212.066 273.269 212.285 274.149C212.652 275.654 212.578 275.618 213.092 277.048C213.349 277.746 214.12 278.553 214.598 278.847C214.671 278.884 220.8 268.827 220.947 268.792",
    stroke: "#011F36",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.545 211.551 270.369 211.809 271.288C212.029 272.205 212.066 273.196 212.285 274.076C212.652 275.544 212.578 275.544 213.092 276.938C213.349 277.636 214.12 278.443 214.598 278.737C214.708 278.774 220.8 268.828 220.947 268.791",
    stroke: "#022037",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.508 211.551 270.333 211.809 271.251C212.029 272.168 212.066 273.122 212.285 274.003C212.652 275.471 212.615 275.471 213.092 276.828C213.349 277.526 214.12 278.333 214.598 278.59C214.744 278.664 220.763 268.865 220.947 268.792",
    stroke: "#022037",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.508 211.551 270.296 211.809 271.214C212.029 272.095 212.066 273.049 212.285 273.93C212.652 275.361 212.615 275.361 213.129 276.755C213.385 277.416 214.157 278.186 214.598 278.48C214.744 278.517 220.763 268.864 220.947 268.791",
    stroke: "#022139",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.471 211.551 270.259 211.809 271.141C212.029 272.058 212.066 272.976 212.285 273.856C212.652 275.288 212.615 275.288 213.129 276.644C213.385 277.305 214.157 278.076 214.598 278.37C214.78 278.406 220.726 268.864 220.947 268.792",
    stroke: "#022139",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.471 211.515 270.222 211.809 271.104C212.029 271.985 212.066 272.902 212.322 273.783C212.688 275.214 212.615 275.177 213.129 276.535C213.385 277.195 214.157 277.967 214.598 278.26C214.817 278.296 220.69 268.865 220.947 268.792",
    stroke: "#022139",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.471 211.515 270.15 211.809 271.067C212.029 271.911 212.066 272.865 212.322 273.673C212.688 275.104 212.652 275.104 213.129 276.425C213.385 277.085 214.157 277.855 214.598 278.113C214.817 278.186 220.69 268.864 220.947 268.791",
    stroke: "#02223B",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.434 211.515 270.113 211.809 270.994C212.029 271.875 212.066 272.793 212.322 273.599C212.688 275.031 212.652 275.031 213.166 276.315C213.422 276.975 214.157 277.709 214.597 278.003C214.854 278.076 220.653 268.901 220.947 268.792",
    stroke: "#02223B",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.434 211.515 270.076 211.809 270.957C212.029 271.801 212.066 272.719 212.322 273.527C212.688 274.921 212.652 274.921 213.166 276.242C213.422 276.866 214.157 277.6 214.634 277.894C214.891 277.967 220.616 268.902 220.947 268.793",
    stroke: "#02233D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.398 211.478 270.04 211.809 270.92C212.029 271.764 212.066 272.646 212.322 273.453C212.688 274.848 212.688 274.848 213.166 276.132C213.422 276.755 214.193 277.49 214.634 277.784C214.891 277.856 220.616 268.902 220.947 268.792",
    stroke: "#02233D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.398 211.478 270.002 211.809 270.847C212.029 271.691 212.102 272.572 212.322 273.38C212.688 274.738 212.688 274.738 213.166 276.022C213.459 276.645 214.193 277.38 214.634 277.637C214.927 277.747 220.58 268.902 220.947 268.793",
    stroke: "#02233E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.369C210.267 267.361 211.478 269.929 211.809 270.81C212.029 271.654 212.102 272.499 212.322 273.306C212.688 274.664 212.688 274.664 213.203 275.911C213.459 276.536 214.193 277.27 214.634 277.527C214.964 277.637 220.58 268.901 220.947 268.792",
    stroke: "#02233E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.357 211.478 269.888 211.772 270.769C212.029 271.576 212.102 272.458 212.322 273.228C212.688 274.55 212.688 274.587 213.203 275.798C213.459 276.422 214.193 277.119 214.634 277.413C214.964 277.523 220.543 268.935 220.947 268.79",
    stroke: "#022540",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.357 211.441 269.852 211.772 270.696C212.029 271.503 212.102 272.384 212.322 273.155C212.725 274.476 212.725 274.476 213.203 275.724C213.459 276.312 214.193 277.009 214.634 277.266C215.001 277.376 220.506 268.935 220.947 268.789",
    stroke: "#022540",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.32 211.441 269.815 211.772 270.659C211.992 271.466 212.102 272.311 212.359 273.082C212.725 274.366 212.725 274.403 213.239 275.614C213.496 276.202 214.194 276.899 214.634 277.156C215.037 277.266 220.506 268.935 220.947 268.789",
    stroke: "#022540",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.32 211.441 269.742 211.772 270.622C211.992 271.393 212.102 272.238 212.359 273.008C212.725 274.293 212.725 274.293 213.239 275.504C213.496 276.092 214.23 276.789 214.634 277.046C215.037 277.156 220.469 268.935 220.947 268.789",
    stroke: "#022541",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.283 211.441 269.705 211.772 270.549C211.992 271.357 212.102 272.164 212.359 272.935C212.725 274.183 212.762 274.219 213.239 275.395C213.496 275.981 214.23 276.678 214.671 276.936C215.074 277.046 220.469 268.935 220.947 268.789",
    stroke: "#022541",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.283 211.405 269.668 211.772 270.512C211.992 271.283 212.102 272.091 212.359 272.861C212.725 274.109 212.762 274.109 213.239 275.285C213.532 275.871 214.23 276.532 214.671 276.789C215.111 276.936 220.433 268.972 220.947 268.789",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.283 211.405 269.631 211.772 270.475C211.992 271.21 212.102 272.054 212.359 272.788C212.725 274 212.762 274.036 213.276 275.21C213.532 275.761 214.23 276.422 214.671 276.679C215.111 276.825 220.396 268.971 220.947 268.789",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.246 211.405 269.595 211.772 270.402C211.992 271.173 212.102 271.98 212.359 272.715C212.725 273.926 212.762 273.963 213.276 275.101C213.532 275.651 214.23 276.312 214.671 276.569C215.148 276.715 220.396 268.971 220.947 268.789",
    stroke: "#022845",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.246 211.405 269.521 211.772 270.365C211.992 271.1 212.102 271.907 212.359 272.642C212.725 273.816 212.799 273.853 213.276 274.991C213.569 275.541 214.23 276.202 214.671 276.459C215.184 276.605 220.359 268.971 220.947 268.788",
    stroke: "#022845",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.21 211.368 269.484 211.772 270.328C211.992 271.063 212.102 271.834 212.359 272.568C212.762 273.743 212.799 273.779 213.276 274.881C213.569 275.431 214.23 276.092 214.671 276.312C215.184 276.496 220.322 268.971 220.947 268.788",
    stroke: "#022847",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.21 211.368 269.448 211.772 270.255C211.992 270.99 212.102 271.76 212.395 272.495C212.762 273.632 212.799 273.669 213.313 274.77C213.569 275.321 214.267 275.945 214.671 276.202C215.221 276.386 220.322 268.971 220.947 268.752",
    stroke: "#022847",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.21 211.368 269.411 211.772 270.218C211.992 270.953 212.102 271.687 212.395 272.384C212.762 273.559 212.835 273.596 213.313 274.66C213.569 275.21 214.267 275.835 214.671 276.092C215.258 276.239 220.286 269.008 220.947 268.752",
    stroke: "#022847",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.173 211.368 269.374 211.772 270.181C211.992 270.879 212.102 271.65 212.395 272.311C212.762 273.449 212.835 273.522 213.313 274.587C213.606 275.101 214.267 275.724 214.708 275.982C215.258 276.129 220.286 269.008 220.947 268.752",
    stroke: "#022A49",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.173 211.331 269.301 211.772 270.109C211.992 270.806 212.102 271.576 212.395 272.238C212.762 273.375 212.835 273.412 213.313 274.476C213.606 274.991 214.267 275.614 214.708 275.835C215.295 276.018 220.249 269.008 220.947 268.752",
    stroke: "#022A49",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.136 211.331 269.264 211.772 270.072C211.992 270.769 212.138 271.503 212.395 272.164C212.762 273.265 212.835 273.339 213.35 274.366C213.607 274.88 214.267 275.504 214.708 275.724C215.331 275.908 220.212 269.008 220.947 268.752",
    stroke: "#032A4A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 266.328C210.267 267.136 211.331 269.227 211.735 270.035C211.992 270.696 212.138 271.429 212.395 272.091C212.762 273.192 212.872 273.228 213.35 274.256C213.643 274.77 214.267 275.358 214.708 275.614C215.331 275.798 220.212 269.008 220.947 268.752",
    stroke: "#032A4A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 267.136 211.292 269.191 211.732 269.961C211.989 270.659 212.136 271.357 212.393 272.017C212.759 273.081 212.869 273.155 213.347 274.146C213.641 274.66 214.301 275.247 214.705 275.467C215.365 275.688 220.173 269.044 220.944 268.751",
    stroke: "#032B4C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 267.099 211.292 269.154 211.732 269.925C211.989 270.585 212.136 271.283 212.393 271.944C212.797 273.008 212.869 273.081 213.383 274.072C213.641 274.55 214.301 275.138 214.705 275.358C215.402 275.578 220.136 269.045 220.944 268.752",
    stroke: "#032B4C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 267.099 211.292 269.08 211.732 269.852C211.989 270.512 212.136 271.247 212.393 271.87C212.797 272.935 212.869 272.971 213.383 273.963C213.641 274.44 214.301 275.027 214.705 275.247C215.402 275.467 220.136 269.045 220.944 268.752",
    stroke: "#032C4D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 267.063 211.292 269.044 211.732 269.815C211.989 270.475 212.136 271.173 212.429 271.797C212.797 272.824 212.906 272.898 213.384 273.853C213.677 274.329 214.301 274.917 214.705 275.137C215.439 275.358 220.099 269.044 220.944 268.751",
    stroke: "#032C4D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 267.063 211.255 269.007 211.732 269.778C211.989 270.402 212.136 271.1 212.429 271.723C212.797 272.752 212.906 272.788 213.384 273.743C213.677 274.219 214.301 274.77 214.742 274.991C215.475 275.247 220.1 269.044 220.944 268.751",
    stroke: "#032C4D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 267.063 211.255 268.97 211.732 269.705C211.989 270.365 212.136 271.026 212.429 271.65C212.797 272.642 212.906 272.715 213.42 273.632C213.677 274.109 214.301 274.66 214.742 274.88C215.475 275.101 220.063 269.081 220.944 268.752",
    stroke: "#032D4F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 267.026 211.255 268.933 211.732 269.668C211.989 270.292 212.136 270.953 212.429 271.576C212.797 272.568 212.943 272.604 213.42 273.559C213.714 274 214.301 274.55 214.742 274.77C215.512 274.991 220.027 269.081 220.944 268.752",
    stroke: "#032D4F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 267.026 211.255 268.861 211.732 269.631C211.989 270.255 212.136 270.879 212.429 271.503C212.797 272.458 212.943 272.531 213.42 273.449C213.714 273.89 214.338 274.44 214.742 274.66C215.549 274.88 220.027 269.081 220.944 268.752",
    stroke: "#032E50",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 266.989 211.218 268.824 211.732 269.558C211.989 270.181 212.136 270.843 212.429 271.429C212.797 272.384 212.943 272.458 213.42 273.339C213.714 273.779 214.338 274.329 214.742 274.513C215.549 274.77 219.99 269.081 220.944 268.752",
    stroke: "#032E50",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 266.989 211.218 268.788 211.732 269.521C211.989 270.109 212.136 270.769 212.429 271.357C212.797 272.274 212.943 272.348 213.457 273.228C213.751 273.669 214.338 274.183 214.742 274.403C215.586 274.66 219.99 269.081 220.944 268.752",
    stroke: "#032F53",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 266.953 211.218 268.752 211.732 269.484C211.989 270.072 212.136 270.696 212.429 271.283C212.833 272.201 212.979 272.274 213.457 273.118C213.751 273.559 214.338 274.072 214.742 274.293C215.622 274.55 219.953 269.118 220.944 268.752",
    stroke: "#032F53",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 266.953 211.218 268.715 211.732 269.411C211.989 269.998 212.136 270.622 212.429 271.21C212.833 272.091 212.979 272.164 213.457 273.045C213.751 273.449 214.338 273.963 214.778 274.183C215.622 274.44 219.916 269.118 220.944 268.752",
    stroke: "#033054",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 266.953 211.181 268.641 211.732 269.374C211.989 269.961 212.136 270.549 212.466 271.137C212.833 272.017 212.979 272.091 213.457 272.935C213.751 273.339 214.338 273.853 214.778 274.036C215.659 274.33 219.916 269.118 220.944 268.752",
    stroke: "#033054",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 266.916 211.181 268.605 211.732 269.337C211.953 269.888 212.172 270.475 212.466 271.026C212.833 271.907 213.016 272.017 213.494 272.824C213.788 273.228 214.374 273.706 214.778 273.926C215.696 274.219 219.88 269.118 220.944 268.751",
    stroke: "#033054",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 266.916 211.181 268.568 211.696 269.264C211.953 269.815 212.172 270.439 212.466 270.953C212.832 271.834 213.016 271.907 213.494 272.715C213.788 273.118 214.374 273.596 214.778 273.816C215.696 274.109 219.844 269.118 220.944 268.752",
    stroke: "#033156",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 266.879 211.181 268.531 211.696 269.227C211.953 269.778 212.172 270.365 212.466 270.879C212.832 271.723 213.016 271.833 213.494 272.604C213.788 273.008 214.374 273.486 214.778 273.706C215.733 273.963 219.844 269.155 220.944 268.751",
    stroke: "#033156",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 266.879 211.145 268.494 211.696 269.191C211.953 269.705 212.172 270.292 212.466 270.806C212.832 271.65 213.016 271.723 213.53 272.531C213.824 272.934 214.374 273.375 214.778 273.559C215.769 273.853 219.807 269.155 220.944 268.751",
    stroke: "#043258",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.328C210.264 266.879 211.145 268.421 211.696 269.117C211.953 269.668 212.172 270.218 212.466 270.732C212.832 271.54 213.053 271.65 213.53 272.421C213.824 272.824 214.374 273.265 214.778 273.449C215.769 273.743 219.807 269.155 220.944 268.752",
    stroke: "#043258",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.844 211.145 268.386 211.696 269.082C211.953 269.596 212.172 270.147 212.466 270.661C212.869 271.468 213.053 271.578 213.53 272.313C213.824 272.717 214.374 273.12 214.778 273.34C215.806 273.634 219.77 269.156 220.944 268.753",
    stroke: "#043359",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.844 211.145 268.349 211.696 269.045C211.953 269.559 212.172 270.074 212.466 270.587C212.869 271.358 213.053 271.468 213.53 272.202C213.861 272.605 214.374 273.009 214.815 273.193C215.843 273.524 219.733 269.156 220.944 268.753",
    stroke: "#043359",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.807 211.108 268.312 211.696 268.972C211.953 269.486 212.172 270.037 212.503 270.514C212.869 271.285 213.09 271.394 213.567 272.092C213.861 272.496 214.411 272.899 214.815 273.083C215.843 273.414 219.733 269.193 220.944 268.753",
    stroke: "#04345B",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.807 211.108 268.239 211.696 268.935C211.953 269.413 212.172 269.963 212.503 270.44C212.869 271.175 213.09 271.285 213.567 271.982C213.861 272.386 214.411 272.79 214.815 272.973C215.879 273.303 219.697 269.193 220.944 268.753",
    stroke: "#04345B",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.807 211.108 268.202 211.696 268.898C211.953 269.376 212.172 269.89 212.503 270.367C212.869 271.101 213.09 271.211 213.567 271.909C213.861 272.276 214.411 272.68 214.815 272.863C215.916 273.193 219.697 269.193 220.944 268.753",
    stroke: "#04345B",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.77 211.071 268.165 211.696 268.826C211.953 269.303 212.172 269.817 212.503 270.294C212.869 270.992 213.09 271.102 213.567 271.799C213.898 272.167 214.411 272.534 214.815 272.717C215.916 273.084 219.66 269.194 220.944 268.754",
    stroke: "#04355C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.77 211.071 268.129 211.696 268.789C211.953 269.266 212.172 269.743 212.503 270.22C212.869 270.918 213.126 271.028 213.604 271.688C213.898 272.055 214.411 272.423 214.815 272.606C215.953 272.973 219.623 269.193 220.944 268.753",
    stroke: "#04355C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.734 211.071 268.092 211.696 268.753C211.953 269.193 212.172 269.671 212.503 270.148C212.869 270.845 213.126 270.955 213.604 271.579C213.898 271.946 214.411 272.313 214.815 272.497C215.99 272.863 219.623 269.194 220.944 268.754",
    stroke: "#04365E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.734 211.071 268.018 211.696 268.68C211.953 269.12 212.172 269.634 212.503 270.075C212.906 270.735 213.126 270.845 213.604 271.469C213.934 271.836 214.448 272.203 214.815 272.387C215.99 272.718 219.587 269.231 220.944 268.754",
    stroke: "#04365E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.734 211.034 267.982 211.696 268.643C211.953 269.083 212.172 269.56 212.503 270C212.906 270.661 213.163 270.772 213.604 271.395C213.934 271.726 214.448 272.093 214.852 272.24C216.026 272.606 219.55 269.231 220.944 268.754",
    stroke: "#043760",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.697 211.034 267.945 211.696 268.606C211.953 269.009 212.172 269.487 212.503 269.928C212.906 270.551 213.163 270.661 213.641 271.286C213.934 271.615 214.448 271.946 214.852 272.13C216.063 272.497 219.55 269.231 220.944 268.754",
    stroke: "#043760",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.697 211.034 267.908 211.659 268.533C211.953 268.973 212.209 269.413 212.54 269.854C212.907 270.478 213.164 270.588 213.641 271.176C213.934 271.505 214.448 271.836 214.852 272.02C216.063 272.387 219.513 269.231 220.944 268.717",
    stroke: "#043862",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.66 211.034 267.872 211.659 268.496C211.953 268.899 212.209 269.34 212.54 269.744C212.907 270.367 213.164 270.514 213.641 271.065C213.971 271.395 214.448 271.726 214.852 271.909C216.1 272.277 219.513 269.23 220.944 268.717",
    stroke: "#043862",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.66 210.998 267.798 211.659 268.423C211.953 268.862 212.209 269.266 212.54 269.67C212.907 270.294 213.201 270.404 213.677 270.955C213.971 271.286 214.448 271.615 214.852 271.762C216.137 272.166 219.477 269.266 220.944 268.717",
    stroke: "#043862",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.66 210.998 267.761 211.659 268.386C211.953 268.79 212.209 269.23 212.54 269.597C212.907 270.184 213.201 270.331 213.677 270.882C213.971 271.176 214.448 271.505 214.852 271.652C216.137 272.056 219.44 269.266 220.944 268.717",
    stroke: "#043963",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.624 210.998 267.725 211.659 268.349C211.953 268.716 212.209 269.156 212.54 269.524C212.907 270.111 213.201 270.221 213.677 270.772C214.007 271.065 214.485 271.359 214.852 271.542C216.173 271.946 219.44 269.266 220.944 268.717",
    stroke: "#043963",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.624 210.998 267.688 211.659 268.276C211.953 268.68 212.209 269.083 212.54 269.45C212.944 270 213.237 270.148 213.677 270.661C214.007 270.955 214.485 271.249 214.852 271.432C216.21 271.836 219.403 269.266 220.944 268.717",
    stroke: "#053A65",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.587 210.961 267.651 211.659 268.239C211.953 268.606 212.209 269.009 212.54 269.377C212.944 269.928 213.237 270.075 213.714 270.551C214.007 270.845 214.485 271.139 214.889 271.286C216.247 271.726 219.366 269.267 220.944 268.716",
    stroke: "#053A65",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.587 210.961 267.579 211.659 268.202C211.953 268.569 212.209 268.936 212.54 269.303C212.944 269.817 213.237 269.963 213.714 270.441C214.044 270.735 214.485 271.029 214.889 271.176C216.247 271.579 219.366 269.303 220.944 268.716",
    stroke: "#053B67",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.587 210.961 267.542 211.659 268.129C211.953 268.496 212.209 268.862 212.576 269.23C212.944 269.744 213.237 269.891 213.714 270.367C214.044 270.625 214.485 270.918 214.889 271.065C216.284 271.469 219.33 269.303 220.944 268.716",
    stroke: "#053B67",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.55 210.961 267.505 211.659 268.092C211.953 268.423 212.209 268.826 212.576 269.156C212.944 269.634 213.274 269.781 213.714 270.257C214.044 270.514 214.485 270.772 214.889 270.919C216.32 271.359 219.33 269.303 220.944 268.716",
    stroke: "#053C68",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.55 210.924 267.468 211.659 268.055C211.953 268.386 212.209 268.753 212.576 269.083C212.944 269.56 213.274 269.707 213.751 270.148C214.044 270.404 214.521 270.661 214.889 270.808C216.32 271.249 219.293 269.303 220.944 268.716",
    stroke: "#053C68",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.513 210.924 267.432 211.659 267.982C211.916 268.312 212.209 268.68 212.576 269.009C212.944 269.45 213.274 269.597 213.751 270.038C214.081 270.294 214.521 270.551 214.889 270.698C216.357 271.139 219.256 269.303 220.944 268.716",
    stroke: "#053C68",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.513 210.924 267.358 211.659 267.945C211.916 268.276 212.209 268.606 212.576 268.936C212.944 269.377 213.311 269.524 213.751 269.928C214.081 270.184 214.521 270.441 214.889 270.588C216.394 271.029 219.256 269.34 220.944 268.716",
    stroke: "#053D6A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.477 210.924 267.321 211.659 267.908C211.916 268.202 212.209 268.533 212.576 268.862C212.98 269.266 213.311 269.45 213.751 269.817C214.081 270.074 214.521 270.331 214.889 270.441C216.394 270.918 219.219 269.34 220.944 268.716",
    stroke: "#053D6A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.477 210.887 267.285 211.659 267.835C211.916 268.165 212.209 268.459 212.576 268.79C212.98 269.193 213.311 269.34 213.788 269.744C214.117 269.963 214.521 270.184 214.925 270.331C216.43 270.808 219.219 269.34 220.944 268.716",
    stroke: "#053E6C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.477 210.887 267.248 211.622 267.798C211.916 268.092 212.246 268.386 212.576 268.716C212.98 269.083 213.311 269.266 213.788 269.634C214.117 269.854 214.521 270.075 214.925 270.221C216.467 270.698 219.183 269.34 220.944 268.716",
    stroke: "#053E6C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.44 210.887 267.211 211.622 267.761C211.916 268.019 212.246 268.349 212.576 268.643C212.98 269.009 213.347 269.156 213.788 269.524C214.117 269.744 214.521 269.964 214.925 270.111C216.467 270.588 219.146 269.34 220.944 268.716",
    stroke: "#053F6E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.44 210.887 267.138 211.622 267.688C211.916 267.982 212.246 268.276 212.613 268.569C212.98 268.899 213.347 269.083 213.824 269.413C214.117 269.634 214.558 269.854 214.925 269.963C216.504 270.441 219.146 269.377 220.944 268.716",
    stroke: "#053F6E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.403 210.851 267.101 211.622 267.651C211.916 267.908 212.246 268.202 212.613 268.459C212.98 268.826 213.347 269.009 213.824 269.303C214.154 269.524 214.558 269.707 214.925 269.854C216.541 270.331 219.109 269.377 220.944 268.716",
    stroke: "#053F6F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.403 210.851 267.064 211.622 267.614C211.916 267.871 212.246 268.129 212.613 268.386C212.98 268.716 213.347 268.899 213.824 269.23C214.154 269.413 214.558 269.597 214.925 269.744C216.541 270.221 219.072 269.377 220.944 268.716",
    stroke: "#053F6F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.403 210.851 267.028 211.622 267.542C211.916 267.798 212.246 268.055 212.613 268.312C212.98 268.643 213.383 268.826 213.824 269.12C214.154 269.303 214.558 269.487 214.925 269.634C216.577 270.111 219.072 269.377 220.944 268.716",
    stroke: "#053F6F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.366 210.814 266.954 211.622 267.505C211.916 267.725 212.246 267.982 212.613 268.239C213.017 268.569 213.383 268.716 213.861 269.009C214.191 269.193 214.558 269.377 214.925 269.487C216.613 270 219.036 269.377 220.944 268.716",
    stroke: "#064171",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.366 210.814 266.917 211.622 267.468C211.916 267.688 212.246 267.945 212.613 268.165C213.017 268.459 213.383 268.643 213.861 268.899C214.191 269.083 214.558 269.266 214.962 269.377C216.613 269.891 219.036 269.377 220.944 268.716",
    stroke: "#064171",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.293C210.264 266.33 210.814 266.881 211.622 267.395C211.916 267.614 212.246 267.871 212.613 268.092C213.017 268.386 213.42 268.569 213.861 268.79C214.191 268.973 214.595 269.12 214.962 269.266C216.65 269.781 218.999 269.413 220.944 268.716",
    stroke: "#064172",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.26C210.264 266.333 210.814 266.847 211.622 267.362C211.916 267.582 212.246 267.802 212.613 268.022C213.017 268.279 213.42 268.463 213.861 268.72C214.227 268.866 214.595 269.013 214.962 269.16C216.687 269.674 218.962 269.417 220.944 268.72",
    stroke: "#064172",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.26C210.264 266.333 210.777 266.811 211.622 267.325C211.916 267.509 212.246 267.728 212.613 267.949C213.017 268.206 213.42 268.389 213.898 268.61C214.227 268.757 214.595 268.903 214.962 269.013C216.687 269.564 218.962 269.417 220.944 268.72",
    stroke: "#064374",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.26C210.264 266.296 210.777 266.737 211.622 267.252C211.916 267.472 212.246 267.655 212.65 267.875C213.017 268.095 213.42 268.279 213.898 268.5C214.227 268.646 214.595 268.793 214.962 268.903C216.723 269.454 218.926 269.417 220.944 268.72",
    stroke: "#064374",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.26C210.264 266.296 210.777 266.701 211.622 267.215C211.916 267.398 212.246 267.582 212.65 267.802C213.017 268.022 213.457 268.206 213.898 268.389C214.227 268.536 214.595 268.683 214.962 268.793C216.76 269.307 218.889 269.417 220.944 268.72",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M210.264 266.26C210.264 266.26 215.733 270.554 220.944 268.72",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M210.044 249.377C210.044 249.377 211.108 256.24 211.512 257.23C211.879 258.112 214.045 262.039 217.347 262.956",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M210.044 249.377C210.044 249.377 211.182 256.167 211.623 257.158C211.99 258.039 214.008 261.782 217.384 262.92",
    stroke: "#022A49",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M210.078 249.344C210.078 249.344 211.252 256.097 211.693 257.125C212.06 258.005 213.969 261.528 217.381 262.923",
    stroke: "#032B4C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M210.078 249.344C210.078 249.344 211.326 256.06 211.767 257.051C212.17 257.932 213.895 261.271 217.381 262.886",
    stroke: "#032E50",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M210.12 249.344C210.12 249.344 211.405 255.986 211.846 256.978C212.285 257.895 213.864 261.014 217.423 262.85",
    stroke: "#033054",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M210.12 249.344C210.12 249.344 211.478 255.949 211.956 256.941C212.359 257.858 213.827 260.721 217.424 262.85",
    stroke: "#043359",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M210.12 249.301C210.12 249.301 211.552 255.87 212.029 256.861C212.469 257.779 213.754 260.458 217.423 262.807",
    stroke: "#04355C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M210.154 249.301C210.154 249.301 211.621 255.834 212.099 256.825C212.539 257.742 213.713 260.201 217.42 262.807",
    stroke: "#043760",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M210.154 249.301C210.154 249.301 211.695 255.76 212.172 256.751C212.649 257.669 213.677 259.944 217.457 262.77",
    stroke: "#053A65",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M210.188 249.268C210.188 249.268 211.765 255.727 212.28 256.681C212.756 257.635 213.601 259.655 217.454 262.773",
    stroke: "#053C68",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M210.188 249.268C210.188 249.268 211.876 255.654 212.353 256.644C212.83 257.562 213.564 259.397 217.455 262.737",
    stroke: "#053F6E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 249.268C210.23 249.268 211.955 255.617 212.432 256.571C212.945 257.525 213.533 259.141 217.497 262.7",
    stroke: "#064172",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 249.225C210.23 249.225 212.029 255.537 212.506 256.491C213.019 257.445 213.496 258.877 217.497 262.694",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M210.484 245.156C210.484 245.156 211.365 254.846 218.264 257.525",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M210.484 245.156C210.521 245.193 210.887 248.276 212.282 251.285C213.383 253.597 215.218 256.24 218.264 257.488",
    stroke: "#022A49",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M210.518 245.156C210.518 245.193 210.958 248.349 212.352 251.248C213.38 253.377 215.215 256.13 218.261 257.488",
    stroke: "#032B4C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M210.518 245.156C210.554 245.23 211.068 248.459 212.426 251.175C213.417 253.157 215.215 256.02 218.261 257.451",
    stroke: "#032E50",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M210.56 245.156C210.56 245.23 211.184 248.533 212.542 251.138C213.423 252.973 215.221 255.91 218.268 257.414",
    stroke: "#033054",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M210.56 245.156C210.597 245.266 211.294 248.606 212.615 251.065C213.422 252.754 215.257 255.8 218.268 257.414",
    stroke: "#043359",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M210.594 245.156C210.594 245.266 211.401 248.68 212.686 251.028C213.456 252.533 215.255 255.689 218.264 257.377",
    stroke: "#04355C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M210.594 245.123C210.63 245.307 211.511 248.794 212.759 250.996C213.456 252.316 215.255 255.583 218.264 257.344",
    stroke: "#043760",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M210.594 245.123C210.667 245.307 211.621 248.866 212.833 250.922C213.493 252.134 215.255 255.473 218.264 257.307",
    stroke: "#053A65",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M210.636 245.123C210.673 245.343 211.737 248.94 212.912 250.886C213.499 251.913 215.261 255.363 218.27 257.307",
    stroke: "#053C68",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M210.636 245.123C210.709 245.343 211.848 249.014 213.022 250.812C213.535 251.693 215.261 255.253 218.27 257.271",
    stroke: "#053F6E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M210.67 245.123C210.707 245.38 211.955 249.124 213.092 250.775C213.532 251.472 215.258 255.143 218.267 257.234",
    stroke: "#064172",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M210.67 245.123C210.742 245.38 212.065 249.197 213.166 250.702C213.569 251.252 215.258 255.033 218.267 257.234",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M210.56 242.475C210.56 242.475 212.579 250.256 218.194 252.164",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M210.56 242.475C210.56 242.475 211.331 245.227 213.165 247.907C214.377 249.705 216.138 251.466 218.193 252.164",
    stroke: "#022847",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M210.56 242.441C210.56 242.441 211.367 245.157 213.202 247.836C214.487 249.671 216.285 251.505 218.193 252.166",
    stroke: "#032A4A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M210.56 242.408C210.56 242.408 211.404 245.087 213.276 247.766C214.597 249.637 216.432 251.546 218.193 252.133",
    stroke: "#032C4D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M210.594 242.365C210.594 242.365 211.438 245.007 213.346 247.723C214.704 249.594 216.613 251.576 218.191 252.127",
    stroke: "#032F53",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M210.594 242.365C210.594 242.365 211.475 244.935 213.42 247.65C214.815 249.558 216.76 251.614 218.228 252.091",
    stroke: "#033156",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M210.594 242.332C210.594 242.332 211.511 244.902 213.456 247.58C214.925 249.562 216.943 251.654 218.228 252.095",
    stroke: "#043359",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M210.594 242.289C210.594 242.289 211.548 244.822 213.53 247.501C215.035 249.519 217.09 251.684 218.228 252.088",
    stroke: "#04355C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M210.636 242.289C210.636 242.289 211.554 244.748 213.609 247.464C215.151 249.482 217.279 251.721 218.234 252.052",
    stroke: "#043760",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M210.636 242.256C210.636 242.256 211.59 244.678 213.682 247.394C215.26 249.449 217.425 251.798 218.233 252.055",
    stroke: "#043963",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M210.636 242.221C210.636 242.221 211.627 244.606 213.719 247.322C215.333 249.414 217.609 251.836 218.234 252.057",
    stroke: "#053B67",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M210.636 242.18C210.636 242.18 211.664 244.529 213.793 247.281C215.445 249.41 217.756 251.869 218.233 252.016",
    stroke: "#053E6C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M210.67 242.18C210.67 242.18 211.698 244.455 213.863 247.208C215.551 249.373 217.937 251.906 218.23 252.016",
    stroke: "#053F6F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M210.67 242.145C210.67 242.145 211.734 244.383 213.936 247.136C215.661 249.338 218.084 251.944 218.267 252.017",
    stroke: "#064172",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M210.67 242.111C210.67 242.111 211.771 244.313 213.973 247.066C215.771 249.305 218.267 251.984 218.267 251.984",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M225.566 253.082L229.423 253.784",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M225.972 256.018L229.423 254.555",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M225.532 253.191L229.389 253.784",
    stroke: "#064171",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M225.532 253.336L229.423 253.818",
    stroke: "#053E6C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M225.566 253.488L229.457 253.818",
    stroke: "#053B67",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M225.566 253.633L229.499 253.853",
    stroke: "#043862",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M225.566 253.783L229.533 253.851",
    stroke: "#04355C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M225.608 253.928L229.567 253.895",
    stroke: "#043258",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M225.608 254.038L229.609 253.895",
    stroke: "#032F53",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M225.608 254.182L229.643 253.928",
    stroke: "#032C4D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M225.642 254.334L229.677 253.928",
    stroke: "#022A49",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M225.938 255.84L229.457 254.479",
    stroke: "#064171",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M225.896 255.688L229.499 254.402",
    stroke: "#053E6C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M225.896 255.543L229.533 254.367",
    stroke: "#053B67",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M225.862 255.391L229.566 254.291",
    stroke: "#043862",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M225.828 255.247L229.609 254.258",
    stroke: "#04355C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M225.828 255.104L229.643 254.182",
    stroke: "#043258",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M225.786 254.918L229.677 254.148",
    stroke: "#032F53",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M225.752 254.774L229.719 254.072",
    stroke: "#032C4D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M225.752 254.621L229.753 254.037",
    stroke: "#022A49",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M225.718 254.477L229.786 253.961",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M229.237 282.703C229.237 282.703 227.181 282.813 226.998 282.887C226.777 282.923 218.63 282.74 218.63 282.74",
    stroke: "#032B4C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M229.279 282.736C229.279 282.736 227.26 282.92 226.967 282.993C226.636 283.029 218.709 282.773 218.709 282.773",
    stroke: "#032E50",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M229.279 282.771C229.279 282.771 227.334 283.028 226.93 283.101C226.489 283.176 218.782 282.808 218.782 282.808",
    stroke: "#033054",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M229.313 282.812C229.313 282.812 227.405 283.105 226.89 283.217C226.34 283.326 218.816 282.849 218.816 282.849",
    stroke: "#043359",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M229.313 282.812C229.313 282.812 227.478 283.217 226.817 283.326C226.193 283.473 218.89 282.886 218.89 282.886",
    stroke: "#04355C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M229.313 282.848C229.313 282.848 227.55 283.288 226.78 283.434C226.046 283.618 218.963 282.921 218.963 282.921",
    stroke: "#043760",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M229.347 282.881C229.347 282.881 227.622 283.394 226.741 283.578C225.897 283.725 219.034 282.954 219.034 282.954",
    stroke: "#053A65",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M229.347 282.924C229.347 282.924 227.659 283.511 226.705 283.694C225.75 283.878 219.071 283.033 219.071 283.033",
    stroke: "#053C68",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M229.389 282.957C229.389 282.957 227.738 283.581 226.673 283.801C225.609 284.021 219.15 283.066 219.15 283.066",
    stroke: "#053F6E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M229.389 282.99C229.389 282.99 227.81 283.687 226.637 283.908C225.462 284.165 219.223 283.1 219.223 283.1",
    stroke: "#064172",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M219.289 283.142C219.289 283.142 225.308 284.28 226.593 284.023C227.877 283.766 229.418 283.031 229.418 283.031",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M230.776 287.355C230.776 287.355 234.629 287.943 234.776 287.906C234.849 287.906 237.015 287.759 237.089 287.759C237.125 287.759 238.96 287.318 238.96 287.318",
    stroke: "#022A49",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M230.556 287.287C230.556 287.287 234.52 287.912 234.813 287.838C234.96 287.801 236.942 287.691 237.052 287.691C237.163 287.691 238.814 287.287 238.814 287.287",
    stroke: "#032D4F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M230.336 287.178C230.336 287.178 234.41 287.876 234.814 287.765C235.034 287.729 236.833 287.619 237.016 287.619C237.163 287.619 238.631 287.251 238.631 287.251",
    stroke: "#033054",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M230.116 287.068C230.116 287.068 234.263 287.803 234.85 287.693C235.144 287.656 236.759 287.546 236.979 287.546C237.163 287.509 238.447 287.252 238.447 287.252",
    stroke: "#043359",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M229.896 286.992C229.896 286.992 234.154 287.763 234.851 287.616C235.218 287.542 236.686 287.469 236.943 287.432C237.2 287.432 238.264 287.212 238.264 287.212",
    stroke: "#043760",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M229.677 286.883C229.677 286.883 234.044 287.727 234.888 287.543C235.329 287.47 236.577 287.396 236.906 287.359C237.2 287.359 238.081 287.176 238.081 287.176",
    stroke: "#053A65",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M229.457 286.771C229.457 286.771 233.898 287.689 234.888 287.505C235.438 287.395 236.503 287.322 236.869 287.285C237.237 287.248 237.897 287.138 237.897 287.138",
    stroke: "#053D6A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M229.237 286.695C229.237 286.695 233.788 287.649 234.925 287.429C235.512 287.282 236.393 287.209 236.833 287.209C237.237 287.172 237.75 287.135 237.75 287.135",
    stroke: "#064171",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M231 287.471L234.744 287.987L237.129 287.873L239.148 287.357",
    stroke: "#022743",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M229.017 286.586C229.017 286.586 233.678 287.614 234.962 287.356C236.21 287.099 237.567 287.099 237.567 287.099",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M247.44 287.135C247.44 287.135 249.862 286.255 251.073 285.815C253.348 284.97 253.605 282.695 253.605 282.695",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M247.186 286.409C247.186 286.409 248.654 285.822 249.865 285.381C253.094 284.17 252.727 282.629 252.727 282.629",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M246.966 286.553C246.966 286.553 248.874 285.819 249.865 285.452C250.379 285.268 251.04 284.975 251.37 284.754C251.81 284.497 252.361 283.984 252.508 283.726C252.802 283.286 252.802 282.662 252.802 282.662",
    stroke: "#053E6C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M246.746 286.739C246.746 286.739 249.132 285.821 249.866 285.564C250.233 285.417 251.114 285.05 251.334 284.903C251.665 284.683 252.435 284.059 252.545 283.875C252.766 283.508 252.912 282.664 252.912 282.664",
    stroke: "#043862",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M246.526 286.882C246.526 286.882 249.389 285.817 249.866 285.633C250.123 285.56 251.151 285.119 251.298 285.046C251.518 284.899 252.509 284.092 252.582 283.982C252.729 283.761 252.986 282.66 252.986 282.66",
    stroke: "#043258",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M246.306 287.069C246.306 287.069 249.609 285.822 249.866 285.747C249.976 285.674 251.224 285.234 251.297 285.16C251.407 285.124 252.582 284.17 252.619 284.096C252.692 283.986 253.096 282.701 253.096 282.701",
    stroke: "#032C4D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M247.186 287.179C247.186 287.179 250.122 286.078 251.113 285.71C251.81 285.454 252.544 284.83 252.874 284.39C253.352 283.692 253.535 282.701 253.535 282.701",
    stroke: "#053E6C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M246.89 287.179C246.89 287.179 250.414 285.894 251.147 285.6C251.661 285.418 252.579 284.683 252.799 284.353C253.166 283.839 253.423 282.701 253.423 282.701",
    stroke: "#043862",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M246.636 287.212C246.636 287.212 250.71 285.67 251.187 285.524C251.555 285.377 252.619 284.532 252.766 284.313C253.023 283.945 253.353 282.697 253.353 282.697",
    stroke: "#043258",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M246.374 287.212C246.374 287.212 250.962 285.487 251.219 285.414C251.402 285.34 252.613 284.386 252.723 284.276C252.833 284.092 253.273 282.697 253.273 282.697",
    stroke: "#032C4D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M246.084 287.208L251.26 285.302L252.654 284.243L253.168 282.695",
    stroke: "#022743",
    strokeWidth: 0.179484,
    strokeMiterlimit: 2.6131
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M252.1 282.703C252.1 282.703 249.972 282.813 249.751 282.887C249.531 282.923 241.053 282.74 241.053 282.74",
    stroke: "#032B4C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M252.143 282.736C252.143 282.736 250.051 282.92 249.72 282.993C249.39 283.029 241.132 282.773 241.132 282.773",
    stroke: "#032E50",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M252.143 282.771C252.143 282.771 250.124 283.028 249.683 283.101C249.243 283.176 241.205 282.808 241.205 282.808",
    stroke: "#033054",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M252.143 282.812C252.143 282.812 250.198 283.105 249.647 283.217C249.096 283.326 241.279 282.849 241.279 282.849",
    stroke: "#043359",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M252.177 282.812C252.177 282.812 250.267 283.217 249.607 283.326C248.947 283.473 241.349 282.886 241.349 282.886",
    stroke: "#04355C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M252.177 282.848C252.177 282.848 250.342 283.288 249.571 283.434C248.801 283.618 241.387 282.921 241.387 282.921",
    stroke: "#043760",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M252.211 282.881C252.211 282.881 250.412 283.394 249.532 283.578C248.614 283.725 241.458 282.954 241.458 282.954",
    stroke: "#053A65",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M252.21 282.924C252.21 282.924 250.486 283.511 249.458 283.694C248.467 283.878 241.531 283.033 241.531 283.033",
    stroke: "#053C68",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M252.253 282.957C252.253 282.957 250.528 283.581 249.427 283.801C248.326 284.021 241.61 283.066 241.61 283.066",
    stroke: "#053F6E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M252.253 282.99C252.253 282.99 250.601 283.687 249.39 283.908C248.179 284.165 241.683 283.1 241.683 283.1",
    stroke: "#064172",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M241.713 283.142C241.713 283.142 248.026 284.28 249.347 284.023C250.669 283.766 252.283 283.031 252.283 283.031",
    stroke: "#00209F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M221.387 247.464C221.277 246.4 221.24 245.336 221.24 244.749C221.277 240.381 220.69 237.078 221.166 232.491C221.534 228.895 222.414 224.16 222.231 220.27C222.157 219.169 222.377 218.068 222.415 217.004L240.141 236.896",
    stroke: "black",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M214.628 279.431C214.151 279.138 213.344 278.293 213.087 277.559C212.572 276.091 212.683 276.127 212.316 274.513C212.097 273.596 212.097 272.568 211.875 271.614C211.693 270.66 210.334 267.614 210.298 266.366C210.152 262.366 208.829 259.65 209.16 255.282C209.38 251.906 210.151 247.318 209.783 243.794C209.673 242.84 209.82 241.738 209.857 240.785L229.785 253.96",
    stroke: "black",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M253.936 282.627C254.083 283.067 253.642 283.912 253.496 284.206C253.386 284.353 253.202 284.609 253.093 284.756C252.872 285.233 252.909 285.123 252.505 285.49C252.396 285.564 251.918 285.967 251.771 286.04C251.478 286.261 251.184 286.555 250.854 286.591C249.349 286.849 248.725 287.178 247.294 287.582C245.935 287.986 246.67 287.913 245.642 288.17C245.129 288.279 244.101 288.683 243.587 288.757C242.67 288.904 242.523 289.051 241.569 289.271C239.109 289.821 236.725 289.674 234.302 289.528C233.311 289.455 230.889 288.94 230.045 288.353C228.54 287.288 225.236 286.885 223.769 285.858C223.549 285.71 222.631 285.27 222.448 285.086C221.017 283.912 219.879 283.581 218.375 282.627",
    stroke: "black",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.267 253.265L210.044 240.053L209.678 240.603L229.789 253.963L230.267 253.265Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.714 239.835C209.567 239.064 209.787 238.036 210.338 237.926C210.374 237.926 210.777 237.78 211.035 237.853C211.365 237.853 211.438 237.963 211.585 238.22C211.878 238.917 211.035 239.357 210.447 239.578C210.3 239.615 209.897 239.688 209.823 239.871C209.713 240.165 209.787 240.055 209.713 240.165C209.823 240.128 209.86 240.018 209.969 239.944C210.41 239.688 210.85 239.615 211.475 239.321C211.952 239.101 212.026 238.146 211.695 237.853C211.329 237.559 210.191 237.596 209.934 237.89C209.383 238.514 209.347 239.358 209.457 240.202C209.457 240.019 209.751 240.055 209.714 239.835L209.714 239.835Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.384 240.198C208.614 240.161 207.622 240.492 207.586 241.042C207.586 241.116 207.512 241.556 207.586 241.776C207.623 242.106 207.732 242.18 208.026 242.253C208.76 242.473 209.09 241.593 209.2 240.969C209.237 240.822 209.237 240.419 209.421 240.308C209.714 240.161 209.64 240.235 209.714 240.161C209.677 240.272 209.567 240.345 209.53 240.419C209.347 240.895 209.311 241.373 209.09 242.033C208.943 242.51 207.989 242.693 207.695 242.4C207.328 242.106 207.219 240.969 207.475 240.675C208.026 240.051 208.87 239.904 209.714 239.904C209.568 239.941 209.604 240.235 209.384 240.198L209.384 240.198Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.24 239.869C209.02 239.979 209.02 240.273 209.13 240.457C209.203 240.639 209.533 240.676 209.68 240.603C209.973 240.42 210.158 240.089 209.973 239.796C209.791 239.538 209.497 239.759 209.24 239.869V239.869Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.977 237.188C204.977 237.188 207.106 238.031 208.83 238.068C208.83 238.068 208.904 239.573 209.27 240.013C209.27 240.013 207.729 239.72 207.031 240.087C207.032 240.087 206.115 237.995 204.977 237.188H204.977Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M206.703 238.254C206.703 238.254 207.547 238.621 208.244 238.621C208.244 238.621 208.28 239.208 208.427 239.392C208.427 239.392 207.804 239.282 207.547 239.428C207.547 239.428 207.179 238.585 206.703 238.254V238.254Z",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.384 241.518C209.384 241.518 209.787 240.821 209.897 240.563C209.97 240.417 209.861 241.407 210.227 241.518C210.704 242.141 210.814 243.426 210.814 243.756C210.264 243.939 209.786 244.27 208.942 243.867C208.649 243.683 208.869 243.133 208.979 242.692C209.053 242.471 209.127 241.847 209.384 241.518L209.384 241.518Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M209.79 240.969C209.79 241.078 209.863 241.519 209.827 241.445C209.827 241.263 210.046 241.629 210.083 241.703C210.377 242.253 210.487 242.657 210.597 243.721",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M209.968 241.891C210.151 242.735 210.298 242.698 210.298 243.873L210.372 243.8",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M209.934 242.66C210.08 243.247 210.043 243.541 210.08 243.835C210.043 243.835 209.86 243.981 209.824 243.981",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.689 236.384L222.632 216.309L222.266 216.748L240.138 236.897L240.689 236.384Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.782 216.312C222.819 215.505 223.26 214.55 223.81 214.586C223.847 214.586 224.288 214.55 224.507 214.66C224.838 214.733 224.874 214.88 224.947 215.174C225.094 215.908 224.177 216.128 223.553 216.202C223.406 216.202 222.966 216.165 222.856 216.348C222.672 216.606 222.782 216.531 222.672 216.606C222.782 216.606 222.893 216.495 222.966 216.459C223.48 216.313 223.92 216.313 224.617 216.202C225.095 216.129 225.388 215.175 225.132 214.844C224.874 214.477 223.773 214.221 223.443 214.441C222.746 214.918 222.525 215.726 222.452 216.606C222.49 216.421 222.746 216.495 222.782 216.312V216.312Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.377 216.564C221.606 216.345 220.579 216.454 220.395 216.968C220.395 217.005 220.212 217.445 220.249 217.665C220.212 217.995 220.285 218.105 220.578 218.252C221.202 218.619 221.753 217.849 222.01 217.261C222.084 217.114 222.194 216.748 222.377 216.674C222.67 216.602 222.597 216.674 222.67 216.602C222.634 216.711 222.524 216.748 222.451 216.821C222.157 217.261 222.01 217.665 221.644 218.289C221.387 218.693 220.432 218.693 220.175 218.326C219.919 217.922 220.102 216.821 220.395 216.601C221.056 216.087 221.937 216.123 222.744 216.381C222.597 216.345 222.56 216.639 222.376 216.564H222.377Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.3 216.2C222.043 216.237 222.007 216.567 222.043 216.75C222.08 216.934 222.373 217.08 222.557 217.007C222.851 216.897 223.144 216.641 223.033 216.31C222.924 216.016 222.557 216.163 222.3 216.2Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.815 212.598C218.815 212.598 220.651 213.919 222.302 214.36C222.302 214.36 222.045 215.865 222.302 216.342C222.302 216.342 220.834 215.718 220.1 215.901C220.1 215.901 219.733 213.662 218.815 212.598V212.598Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M220.211 214.07C220.211 214.07 220.945 214.584 221.606 214.767C221.606 214.767 221.496 215.354 221.606 215.538C221.606 215.538 221.019 215.317 220.725 215.391C220.725 215.392 220.578 214.473 220.211 214.07L220.211 214.07Z",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.047 217.85C222.047 217.85 222.597 217.263 222.78 217.043C222.891 216.896 222.524 217.85 222.854 218.07C223.184 218.767 222.964 220.015 222.891 220.383C222.304 220.419 221.79 220.602 221.093 220.015C220.835 219.795 221.165 219.318 221.386 218.914C221.496 218.695 221.716 218.107 222.047 217.85L222.047 217.85Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M222.563 217.445C222.563 217.519 222.526 217.812 222.526 217.885C222.563 218.106 222.745 218.179 222.782 218.436C222.892 219.06 222.745 219.464 222.709 220.271",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M222.486 218.18C222.669 218.95 222.523 219.575 222.413 220.308C222.376 220.308 222.486 220.308 222.486 220.272",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M222.376 219.467C222.267 219.76 222.267 219.943 222.23 220.274C222.194 220.237 222.047 220.384 222.01 220.348",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M255.26 211.463L212.723 282.626H297.829L255.26 211.463Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.433833,
    strokeMiterlimit: 2.6131
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M255.26 216.088L216.871 280.317H293.683L255.26 216.088Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M228.247 261.229L216.871 280.317H293.683L282.27 261.229H228.247Z",
    fill: "#007E93",
    stroke: "#007E93",
    strokeWidth: 0.260341,
    strokeMiterlimit: 2.6131
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M248.581 227.314C250.38 225.699 252.582 225.039 255.151 225.002H255.335C257.831 225.039 260.363 225.626 261.977 227.314",
    stroke: "#086AAD",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M248.539 227.39C250.3 225.738 252.576 225.115 255.145 225.078H255.329C257.898 225.078 260.43 225.702 262.045 227.427",
    stroke: "#0863AA",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M248.505 227.501C250.267 225.776 252.579 225.152 255.185 225.115H255.369C257.937 225.152 260.507 225.776 262.121 227.538",
    stroke: "#095FA8",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M248.429 227.577C250.191 225.853 252.576 225.191 255.182 225.191H255.403C258.008 225.191 260.578 225.852 262.192 227.687",
    stroke: "#0A58A5",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M248.395 227.645C250.121 225.884 252.579 225.259 255.222 225.223H255.406C258.084 225.259 260.653 225.92 262.268 227.792",
    stroke: "#0A52A2",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M248.328 227.721C250.052 225.923 252.548 225.299 255.227 225.299H255.447C258.163 225.336 260.731 225.996 262.384 227.904",
    stroke: "#0B4D9F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M248.285 227.832C250.01 225.997 252.543 225.336 255.258 225.336H255.442C258.231 225.373 260.763 226.07 262.451 228.015",
    stroke: "#0C479D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M247.812 228.6C249.83 226.471 252.326 225.848 255.299 225.848H255.482C258.748 225.884 261.538 226.985 263.152 229.261",
    stroke: "#270A7F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M247.845 228.491C249.827 226.436 252.323 225.812 255.296 225.775H255.479C258.672 225.812 261.425 226.876 263.077 229.115",
    stroke: "#241183",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M247.922 228.415C249.867 226.36 252.326 225.736 255.262 225.736H255.446C258.602 225.773 261.354 226.764 263.006 229.003",
    stroke: "#221786",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M247.955 228.347C249.864 226.328 252.36 225.705 255.222 225.668H255.406C258.525 225.705 261.241 226.659 262.93 228.861",
    stroke: "#1F1F8A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M248.031 228.238C249.866 226.293 252.362 225.633 255.225 225.633H255.372C258.455 225.633 261.17 226.514 262.859 228.716",
    stroke: "#1A258D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M248.065 228.162C249.863 226.216 252.396 225.592 255.185 225.557H255.369C258.378 225.593 261.094 226.401 262.746 228.566",
    stroke: "#172D91",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M248.099 228.085C249.861 226.176 252.393 225.516 255.146 225.516H255.329C258.302 225.516 260.981 226.286 262.669 228.415",
    stroke: "#143393",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M248.175 227.974C249.9 226.102 252.433 225.478 255.148 225.441H255.295C258.231 225.441 260.91 226.175 262.598 228.304",
    stroke: "#113B97",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M251.034 223.136C252.282 222.255 253.604 221.998 255.255 221.998C256.834 221.998 258.228 222.255 259.439 223.062",
    stroke: "#FF0A00",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M251.001 223.204C252.249 222.323 253.606 222.066 255.258 222.066C256.837 222.066 258.267 222.323 259.479 223.131",
    stroke: "#FF1100",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M250.967 223.28C252.251 222.399 253.609 222.105 255.261 222.105C256.839 222.105 258.307 222.398 259.555 223.207",
    stroke: "#FF1500",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M250.933 223.391C252.218 222.474 253.575 222.18 255.264 222.18C256.878 222.18 258.347 222.473 259.595 223.281",
    stroke: "#FF1A00",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M250.891 223.466C252.175 222.549 253.569 222.256 255.258 222.256C256.873 222.256 258.378 222.549 259.626 223.357",
    stroke: "#FF2000",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M250.857 223.533C252.141 222.616 253.572 222.285 255.261 222.285C256.875 222.285 258.417 222.616 259.665 223.46",
    stroke: "#FF2700",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M250.814 223.609C252.099 222.692 253.53 222.361 255.255 222.361C256.87 222.361 258.448 222.692 259.696 223.536",
    stroke: "#FF2F00",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M250.781 223.685C252.065 222.731 253.533 222.438 255.258 222.438C256.91 222.438 258.488 222.768 259.773 223.612",
    stroke: "#FF3300",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M250.747 223.753C252.032 222.799 253.536 222.469 255.261 222.469C256.912 222.469 258.528 222.836 259.812 223.68",
    stroke: "#FF3C00",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M250.704 223.83C252.026 222.875 253.53 222.545 255.256 222.545C256.907 222.545 258.559 222.912 259.844 223.756",
    stroke: "#FF4100",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M250.671 223.906C251.992 222.952 253.496 222.621 255.259 222.621C256.946 222.621 258.598 222.988 259.883 223.832",
    stroke: "#FF4600",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M249.681 225.556C251.112 224.455 253.387 223.904 255.296 223.904C257.314 223.904 259.516 224.454 260.947 225.593",
    stroke: "#FFF500",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M249.757 225.445C251.151 224.344 253.39 223.83 255.298 223.83C257.28 223.83 259.445 224.343 260.876 225.519",
    stroke: "#FFEB00",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M249.791 225.369C251.223 224.268 253.387 223.754 255.295 223.754C257.24 223.754 259.406 224.267 260.837 225.406",
    stroke: "#FFE000",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M249.867 225.259C251.262 224.195 253.391 223.682 255.299 223.682C257.244 223.682 259.373 224.195 260.767 225.296",
    stroke: "#FFD600",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M249.901 225.193C251.296 224.129 253.388 223.615 255.296 223.615C257.204 223.615 259.297 224.129 260.727 225.193",
    stroke: "#FFCF00",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M249.977 225.083C251.372 224.019 253.427 223.541 255.299 223.541C257.207 223.541 259.263 224.019 260.656 225.12",
    stroke: "#FFC400",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M250.011 225.007C251.406 223.942 253.424 223.465 255.296 223.465C257.167 223.465 259.187 223.942 260.58 225.007",
    stroke: "#FFBA00",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M250.087 224.897C251.445 223.869 253.427 223.393 255.298 223.393C257.17 223.393 259.153 223.869 260.546 224.897",
    stroke: "#FFB000",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M250.121 224.82C251.516 223.755 253.424 223.314 255.296 223.314C257.13 223.314 259.113 223.791 260.47 224.82",
    stroke: "#FFA600",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M250.197 224.711C251.555 223.683 253.427 223.242 255.298 223.242C257.096 223.242 259.042 223.683 260.4 224.711",
    stroke: "#FF9C00",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M250.231 224.642C251.589 223.615 253.461 223.174 255.295 223.174C257.093 223.174 259.003 223.615 260.361 224.605",
    stroke: "#FF9100",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M250.307 224.523C251.665 223.533 253.463 223.092 255.299 223.092C257.06 223.092 258.969 223.532 260.291 224.487",
    stroke: "#FF8700",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M250.341 224.457C251.699 223.429 253.46 223.025 255.295 223.025C257.057 223.025 258.892 223.465 260.25 224.42",
    stroke: "#FF7D00",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M250.417 224.345C251.738 223.354 253.463 222.951 255.298 222.951C257.023 222.951 258.858 223.391 260.18 224.308",
    stroke: "#FF7500",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M250.451 224.269C251.808 223.278 253.46 222.875 255.295 222.875C257.019 222.875 258.782 223.278 260.103 224.196",
    stroke: "#FF6B00",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M250.527 224.161C251.847 223.17 253.499 222.803 255.298 222.803C256.985 222.803 258.748 223.206 260.069 224.124",
    stroke: "#FF6100",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M250.561 224.085C251.919 223.094 253.497 222.727 255.295 222.727C256.947 222.727 258.709 223.13 259.994 224.011",
    stroke: "#FF5700",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M249.495 225.742C250.999 224.568 253.311 224.018 255.293 224.018C257.348 224.018 259.587 224.604 261.055 225.779",
    stroke: "#EBF605",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M249.461 225.851C251.039 224.603 253.278 224.09 255.296 224.09C257.351 224.09 259.664 224.677 261.131 225.888",
    stroke: "#D6EC09",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M249.385 225.962C251.036 224.64 253.202 224.127 255.294 224.127C257.385 224.127 259.698 224.751 261.165 225.962",
    stroke: "#C2E30E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M249.317 226.071C251.079 224.676 253.171 224.199 255.299 224.199C257.391 224.199 259.74 224.823 261.208 226.071",
    stroke: "#ADD912",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M249.275 226.182C251.073 224.751 253.129 224.273 255.257 224.273C257.422 224.273 259.771 224.897 261.276 226.145",
    stroke: "#99CF16",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M249.207 226.291C251.116 224.786 253.061 224.309 255.263 224.309C257.465 224.309 259.851 224.969 261.318 226.255",
    stroke: "#85C61A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M249.165 226.401C251.11 224.824 253.019 224.383 255.257 224.383C257.459 224.383 259.882 225.043 261.386 226.329",
    stroke: "#70BC1F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M249.089 226.512C251.144 224.861 252.98 224.42 255.254 224.42C257.493 224.42 259.916 225.117 261.42 226.438",
    stroke: "#5CB323",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M249.021 226.578C251.15 224.889 252.911 224.486 255.26 224.486C257.499 224.486 259.958 225.183 261.499 226.505",
    stroke: "#47A928",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M248.691 227.17C250.563 225.519 252.728 224.932 255.298 224.932C257.72 224.932 260.253 225.556 261.867 227.134",
    stroke: "#0D74A4",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M248.725 227.129C250.633 225.441 252.726 224.854 255.295 224.854C257.717 224.854 260.213 225.514 261.828 227.056",
    stroke: "#127A97",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M248.767 227.061C250.712 225.373 252.768 224.822 255.3 224.822C257.686 224.822 260.219 225.483 261.797 226.988",
    stroke: "#17808B",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M248.801 226.985C250.783 225.297 252.765 224.783 255.298 224.783C257.647 224.783 260.179 225.443 261.72 226.912",
    stroke: "#1A847D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M248.835 226.952C250.854 225.227 252.799 224.713 255.258 224.713C257.644 224.713 260.14 225.41 261.68 226.842",
    stroke: "#1E8A6D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M248.877 226.876C250.933 225.151 252.804 224.674 255.263 224.674C257.613 224.674 260.109 225.371 261.65 226.803",
    stroke: "#238F5E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M248.911 226.841C251.003 225.079 252.838 224.639 255.261 224.639C257.573 224.639 260.069 225.336 261.61 226.731",
    stroke: "#2B944E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M248.945 226.765C251.074 225.003 252.835 224.6 255.258 224.6C257.533 224.6 260.066 225.297 261.57 226.655",
    stroke: "#2F9B3E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M259.408 222.984C258.197 222.177 256.803 221.92 255.261 221.92C253.609 221.92 252.325 222.214 251.077 223.058",
    stroke: "#FF0000",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M263.257 229.412C261.569 227.027 258.707 225.889 255.33 225.889C252.284 225.889 249.826 226.549 247.733 228.678",
    stroke: "#2A007C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M261.904 227.171C260.289 225.593 257.758 224.969 255.298 224.969C252.693 224.969 250.491 225.593 248.656 227.244",
    stroke: "#0671B0",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M262.53 228.16C260.804 226.069 258.162 225.408 255.263 225.408C252.548 225.408 249.941 226.032 248.217 227.904",
    stroke: "#0C419A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M261.024 225.7C259.556 224.526 257.318 223.975 255.299 223.975C253.354 223.975 251.005 224.525 249.574 225.626",
    stroke: "#FFFF00",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M259.916 223.906C258.631 223.062 256.943 222.658 255.255 222.658C253.493 222.658 251.951 223.025 250.63 224.016",
    stroke: "#FF4D00",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M261.532 226.579C260.026 225.257 257.531 224.523 255.256 224.523C252.87 224.523 251.145 224.927 248.98 226.689",
    stroke: "#33A02C",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M247.482 229.041C249.868 227.867 252.364 227.133 255.262 227.133C258.014 227.133 260.95 228.16 263.262 229.408L271.41 243.024C271.41 251.942 264.143 259.319 255.262 259.319C246.344 259.319 239.151 252.126 239.077 243.098L247.482 229.041L247.482 229.041Z",
    stroke: "#FEF2EC",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M255.264 227.315C257.979 227.315 260.879 228.38 263.154 229.591C263.191 229.591 271.191 242.987 271.191 243.023C271.191 251.794 264.035 259.097 255.264 259.097C246.456 259.097 239.373 252.014 239.3 243.096C239.3 243.059 247.557 229.259 247.594 229.259C249.942 228.086 252.401 227.314 255.264 227.314L255.264 227.315Z",
    stroke: "#FEF2EA",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 227.756C257.9 227.756 260.726 228.747 262.929 229.958C263.002 229.995 270.746 242.912 270.746 243.023C270.746 251.574 263.772 258.694 255.222 258.694C246.707 258.694 239.771 251.758 239.734 243.097C239.734 242.987 247.698 229.664 247.771 229.628C250.083 228.49 252.468 227.757 255.221 227.757L255.222 227.756Z",
    stroke: "#FEF0E6",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 228.195C257.828 228.195 260.579 229.15 262.709 230.324C262.856 230.398 270.343 242.876 270.343 243.06C270.343 251.354 263.553 258.254 255.222 258.254C246.928 258.254 240.211 251.537 240.138 243.096C240.138 242.912 247.845 230.103 247.991 229.994C250.231 228.892 252.542 228.195 255.222 228.195L255.222 228.195Z",
    stroke: "#FEEDE3",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 228.82C257.718 228.82 260.36 229.738 262.415 230.876C262.635 231.022 269.682 242.767 269.682 243.061C269.682 250.988 263.185 257.595 255.221 257.595C247.294 257.595 240.835 251.172 240.799 243.098C240.799 242.804 248.029 230.694 248.286 230.584C250.414 229.519 252.689 228.821 255.222 228.821L255.222 228.82Z",
    stroke: "#FEE8DC",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 229.26C257.644 229.26 260.213 230.141 262.194 231.242C262.488 231.425 269.241 242.693 269.241 243.06C269.241 250.767 262.929 257.189 255.221 257.189C247.514 257.189 241.275 250.914 241.239 243.096C241.239 242.729 248.175 231.131 248.506 230.948C250.56 229.921 252.762 229.26 255.221 229.26V229.26Z",
    stroke: "#FEE6D5",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 229.887C257.534 229.887 259.993 230.768 261.865 231.795C262.268 232.016 268.58 242.585 268.58 243.062C268.58 250.439 262.598 256.531 255.222 256.531C247.882 256.531 241.899 250.586 241.863 243.135C241.863 242.621 248.395 231.758 248.799 231.501C250.781 230.51 252.873 229.887 255.222 229.887L255.222 229.887Z",
    stroke: "#FEE3CF",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 230.326C257.497 230.326 259.809 231.133 261.68 232.161C262.121 232.418 268.177 242.51 268.177 243.062C268.177 250.182 262.341 256.09 255.222 256.09C248.102 256.09 242.34 250.327 242.304 243.135C242.304 242.548 248.543 232.161 248.984 231.905C250.928 230.914 252.946 230.326 255.222 230.326H255.221Z",
    stroke: "#FEE0CC",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 230.768C257.424 230.768 259.663 231.538 261.461 232.529C261.938 232.822 267.736 242.475 267.736 243.099C267.736 249.962 262.121 255.687 255.222 255.687C248.359 255.687 242.78 250.109 242.744 243.135C242.744 242.474 248.689 232.565 249.203 232.272C251.037 231.354 253.02 230.768 255.222 230.768H255.222Z",
    stroke: "#FEDEC6",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 233.559C256.946 233.559 258.672 234.146 260.067 234.917C260.947 235.43 264.911 242.037 264.911 243.138C264.911 248.459 260.58 252.863 255.221 252.863C249.9 252.863 245.569 248.533 245.532 243.138C245.532 242.037 249.606 235.247 250.524 234.733C251.955 233.999 253.497 233.559 255.221 233.559L255.222 233.559Z",
    stroke: "#FDCDAA",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 233.744C256.909 233.744 258.598 234.331 259.956 235.102C260.874 235.652 264.69 242.002 264.69 243.14C264.69 248.351 260.434 252.645 255.222 252.645C250.01 252.645 245.753 248.425 245.753 243.177C245.753 242.002 249.68 235.469 250.634 234.919C252.029 234.185 253.534 233.745 255.222 233.745L255.222 233.744Z",
    stroke: "#FDCDAA",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 234.801C256.727 234.801 258.231 235.314 259.442 236.012C260.507 236.636 263.626 241.81 263.626 243.132C263.626 247.756 259.846 251.572 255.221 251.572C250.597 251.572 246.854 247.829 246.817 243.168C246.817 241.81 250.047 236.489 251.148 235.864C252.359 235.205 253.716 234.801 255.221 234.801V234.801Z",
    stroke: "#FDC59E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 235.022C256.69 235.022 258.157 235.498 259.332 236.196C260.434 236.856 263.406 241.774 263.406 243.133C263.406 247.648 259.736 251.354 255.221 251.354C250.707 251.354 247.037 247.72 247.037 243.17C247.037 241.775 250.12 236.71 251.258 236.05C252.433 235.425 253.753 235.021 255.221 235.021V235.022Z",
    stroke: "#FDC59E",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M255.264 227.535C257.943 227.535 260.805 228.563 263.045 229.774C263.081 229.811 270.971 242.949 270.971 243.023C270.971 251.685 263.888 258.913 255.264 258.913C246.602 258.913 239.556 251.867 239.519 243.097C239.519 243.023 247.63 229.481 247.666 229.443C250.015 228.269 252.438 227.535 255.264 227.535L255.264 227.535Z",
    stroke: "#FEF0E9",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 227.975C257.864 227.975 260.652 228.965 262.819 230.14C262.929 230.213 270.562 242.912 270.562 243.059C270.562 251.463 263.662 258.473 255.221 258.473C246.816 258.473 239.99 251.647 239.916 243.096C239.916 242.949 247.77 229.885 247.88 229.811C250.157 228.672 252.505 227.975 255.221 227.975L255.222 227.975Z",
    stroke: "#FEEDE3",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 228.416C257.791 228.416 260.506 229.37 262.598 230.508C262.782 230.618 270.122 242.839 270.122 243.06C270.122 251.244 263.406 258.034 255.221 258.034C247.037 258.034 240.431 251.391 240.357 243.097C240.357 242.877 247.881 230.288 248.064 230.178C250.302 229.077 252.578 228.417 255.221 228.417L255.221 228.416Z",
    stroke: "#FEEBDF",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 228.602C257.754 228.602 260.433 229.556 262.525 230.694C262.709 230.804 269.902 242.805 269.902 243.062C269.902 251.136 263.296 257.816 255.222 257.816C247.185 257.816 240.652 251.283 240.578 243.098C240.578 242.841 247.955 230.51 248.176 230.363C250.341 229.299 252.616 228.602 255.222 228.602L255.222 228.602Z",
    stroke: "#FEEBDD",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 229.042C257.681 229.042 260.287 229.959 262.304 231.06C262.562 231.207 269.462 242.731 269.462 243.061C269.462 250.878 263.076 257.374 255.222 257.374C247.405 257.374 241.056 251.062 241.019 243.098C241.019 242.767 248.102 230.912 248.396 230.767C250.488 229.701 252.726 229.041 255.222 229.041L255.222 229.042Z",
    stroke: "#FEE8D9",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 229.481C257.607 229.481 260.14 230.362 262.084 231.426C262.415 231.61 269.021 242.657 269.021 243.06C269.021 250.657 262.819 256.969 255.222 256.969C247.661 256.969 241.496 250.804 241.422 243.133C241.422 242.692 248.249 231.315 248.579 231.132C250.634 230.104 252.799 229.48 255.222 229.48L255.221 229.481Z",
    stroke: "#FEE6D3",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 229.701C257.571 229.701 260.067 230.545 261.974 231.609C262.341 231.83 268.801 242.619 268.801 243.06C268.801 250.547 262.709 256.749 255.221 256.749C247.771 256.749 241.715 250.693 241.642 243.134C241.642 242.656 248.322 231.536 248.688 231.316C250.707 230.325 252.835 229.702 255.221 229.702L255.222 229.701Z",
    stroke: "#FEE3D2",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 230.107C257.534 230.107 259.883 230.951 261.754 231.98C262.194 232.236 268.397 242.549 268.397 243.063C268.397 250.33 262.451 256.312 255.222 256.312C247.992 256.312 242.12 250.44 242.083 243.137C242.083 242.586 248.469 231.943 248.909 231.723C250.854 230.732 252.909 230.107 255.221 230.107H255.222Z",
    stroke: "#FEE0CC",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 230.547C257.46 230.547 259.736 231.354 261.571 232.345C262.011 232.639 267.957 242.511 267.957 243.099C267.957 250.071 262.231 255.87 255.221 255.87C248.249 255.87 242.56 250.219 242.522 243.135C242.522 242.51 248.615 232.344 249.091 232.088C250.964 231.135 252.982 230.547 255.221 230.547L255.221 230.547Z",
    stroke: "#FEDEC8",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 230.986C257.387 230.986 259.589 231.757 261.35 232.711C261.865 233.042 267.516 242.437 267.516 243.097C267.516 249.85 261.974 255.466 255.221 255.466C248.468 255.466 243 249.96 242.964 243.135C242.964 242.438 248.762 232.785 249.313 232.455C251.11 231.538 253.056 230.987 255.222 230.987L255.221 230.986Z",
    stroke: "#FDDBC5",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 231.172C257.35 231.172 259.516 231.942 261.24 232.897C261.791 233.227 267.296 242.402 267.296 243.1C267.296 249.743 261.865 255.248 255.222 255.248C248.579 255.248 243.183 249.853 243.148 243.137C243.148 242.403 248.836 232.97 249.424 232.64C251.184 231.759 253.093 231.172 255.222 231.172L255.221 231.172Z",
    stroke: "#FDDBC2",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 231.393C257.313 231.393 259.442 232.126 261.13 233.081C261.718 233.448 267.076 242.366 267.076 243.101C267.076 249.634 261.754 255.029 255.221 255.029C248.688 255.029 243.405 249.744 243.367 243.139C243.367 242.368 248.908 233.192 249.496 232.826C251.258 231.944 253.129 231.393 255.221 231.393L255.221 231.393Z",
    stroke: "#FDD9BF",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 231.612C257.277 231.612 259.369 232.345 261.02 233.264C261.644 233.63 266.856 242.329 266.856 243.099C266.856 249.522 261.644 254.806 255.222 254.806C248.836 254.806 243.624 249.632 243.588 243.136C243.588 242.329 248.983 233.41 249.606 233.043C251.331 232.161 253.167 231.611 255.222 231.611L255.221 231.612Z",
    stroke: "#FDD9BF",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 231.832C257.24 231.832 259.296 232.529 260.91 233.446C261.571 233.851 266.635 242.292 266.635 243.099C266.635 249.374 261.497 254.586 255.221 254.586C248.945 254.586 243.844 249.485 243.807 243.136C243.807 242.292 249.055 233.594 249.716 233.227C251.404 232.346 253.203 231.832 255.221 231.832L255.222 231.832Z",
    stroke: "#FDD6BC",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 232.053C257.203 232.053 259.223 232.75 260.799 233.632C261.497 234.035 266.415 242.257 266.415 243.1C266.415 249.266 261.387 254.367 255.222 254.367C249.056 254.367 244.065 249.376 244.028 243.137C244.028 242.256 249.093 233.814 249.827 233.411C251.478 232.567 253.24 232.053 255.222 232.053L255.221 232.053Z",
    stroke: "#FDD6B9",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 232.271C257.166 232.271 259.149 232.932 260.726 233.813C261.424 234.253 266.231 242.218 266.231 243.098C266.231 249.154 261.277 254.182 255.221 254.182C249.166 254.182 244.285 249.264 244.248 243.136C244.248 242.218 249.166 233.997 249.899 233.593C251.551 232.749 253.276 232.272 255.221 232.272L255.221 232.271Z",
    stroke: "#FDD4B8",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 232.457C257.13 232.457 259.076 233.154 260.616 233.998C261.35 234.439 266.011 242.183 266.011 243.101C266.011 249.046 261.167 253.963 255.222 253.963C249.277 253.963 244.469 249.155 244.469 243.137C244.469 242.183 249.24 234.218 250.01 233.779C251.625 232.971 253.314 232.457 255.222 232.457L255.222 232.457Z",
    stroke: "#FDD4B6",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 232.678C257.093 232.678 259.002 233.338 260.506 234.182C261.277 234.623 265.791 242.146 265.791 243.101C265.791 248.936 261.02 253.743 255.221 253.743C249.423 253.743 244.688 249.009 244.651 243.138C244.651 242.184 249.313 234.44 250.12 233.962C251.661 233.192 253.35 232.678 255.221 232.678V232.678Z",
    stroke: "#FDD2B2",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 232.898C257.056 232.898 258.929 233.522 260.396 234.367C261.203 234.843 265.571 242.11 265.571 243.138C265.571 248.827 260.91 253.525 255.222 253.525C249.534 253.525 244.909 248.9 244.873 243.138C244.873 242.148 249.387 234.624 250.231 234.183C251.735 233.376 253.387 232.899 255.222 232.899L255.222 232.898Z",
    stroke: "#FDD1B0",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 233.119C257.02 233.119 258.819 233.743 260.287 234.551C261.131 235.027 265.352 242.075 265.352 243.139C265.352 248.717 260.8 253.304 255.221 253.304C249.643 253.304 245.129 248.79 245.092 243.139C245.092 242.111 249.46 234.845 250.34 234.367C251.808 233.596 253.423 233.119 255.221 233.119L255.222 233.119Z",
    stroke: "#FDD0B0",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 233.338C256.983 233.338 258.745 233.925 260.177 234.732C261.057 235.246 265.131 242.072 265.131 243.137C265.131 248.567 260.69 253.082 255.222 253.082C249.753 253.082 245.349 248.678 245.313 243.137C245.313 242.072 249.534 235.063 250.415 234.548C251.882 233.778 253.461 233.338 255.222 233.338L255.222 233.338Z",
    stroke: "#FDD0AD",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 233.965C256.873 233.965 258.525 234.516 259.883 235.286C260.8 235.836 264.471 241.965 264.471 243.14C264.471 248.241 260.324 252.462 255.221 252.462C250.12 252.462 245.973 248.315 245.973 243.177C245.973 241.966 249.753 235.653 250.743 235.103C252.102 234.405 253.569 233.965 255.221 233.965L255.222 233.965Z",
    stroke: "#FDCAA6",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 234.184C256.837 234.184 258.451 234.734 259.773 235.469C260.727 236.056 264.25 241.928 264.25 243.139C264.25 248.131 260.213 252.241 255.222 252.241C250.231 252.241 246.194 248.204 246.156 243.176C246.156 241.928 249.827 235.872 250.818 235.286C252.175 234.587 253.606 234.184 255.221 234.184L255.222 234.184Z",
    stroke: "#FDCAA4",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 234.405C256.8 234.405 258.378 234.918 259.662 235.653C260.653 236.239 264.067 241.892 264.067 243.14C264.067 248.021 260.103 252.02 255.221 252.02C250.341 252.02 246.413 248.057 246.377 243.175C246.377 241.891 249.9 236.092 250.928 235.505C252.249 234.808 253.643 234.404 255.221 234.404V234.405Z",
    stroke: "#FDC8A4",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 234.623C256.763 234.623 258.304 235.137 259.552 235.834C260.58 236.458 263.846 241.852 263.846 243.138C263.846 247.909 259.956 251.799 255.221 251.799C250.487 251.799 246.633 247.946 246.596 243.174C246.596 241.852 249.973 236.274 251.037 235.686C252.321 235.027 253.679 234.623 255.221 234.623L255.221 234.623Z",
    stroke: "#FDC8A1",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 235.242C256.653 235.242 258.084 235.719 259.223 236.38C260.36 237.04 263.185 241.738 263.185 243.133C263.185 247.538 259.626 251.134 255.221 251.134C250.817 251.134 247.258 247.574 247.258 243.17C247.258 241.738 250.194 236.894 251.331 236.234C252.505 235.609 253.79 235.242 255.221 235.242V235.242Z",
    stroke: "#FDC39B",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 235.461C256.616 235.461 258.01 235.902 259.112 236.562C260.287 237.259 262.966 241.7 262.966 243.168C262.966 247.426 259.479 250.949 255.221 250.949C250.927 250.949 247.478 247.463 247.478 243.168C247.478 241.701 250.267 237.113 251.442 236.416C252.578 235.828 253.826 235.461 255.221 235.461H255.221Z",
    stroke: "#FDC398",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 235.682C256.58 235.682 257.937 236.122 259.039 236.746C260.214 237.443 262.745 241.664 262.745 243.168C262.745 247.315 259.369 250.728 255.222 250.728C251.074 250.728 247.698 247.353 247.698 243.168C247.698 241.664 250.303 237.296 251.552 236.598C252.652 236.012 253.863 235.682 255.222 235.682H255.221Z",
    stroke: "#FDC097",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 235.91C256.543 235.91 257.864 236.313 258.929 236.938C260.14 237.672 262.525 241.673 262.525 243.177C262.525 247.214 259.259 250.517 255.222 250.517C251.185 250.517 247.918 247.251 247.881 243.177C247.881 241.636 250.377 237.526 251.661 236.828C252.726 236.241 253.9 235.91 255.222 235.91V235.91Z",
    stroke: "#FDC095",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 236.088C256.506 236.088 257.754 236.528 258.818 237.116C260.066 237.849 262.304 241.63 262.304 243.171C262.304 247.098 259.149 250.292 255.221 250.292C251.295 250.292 248.138 247.099 248.102 243.171C248.102 241.593 250.451 237.74 251.734 237.005C252.799 236.455 253.937 236.088 255.221 236.088L255.221 236.088Z",
    stroke: "#FDBE92",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 236.307C256.47 236.307 257.681 236.71 258.708 237.298C259.956 238.068 262.084 241.592 262.084 243.169C262.084 246.949 259.002 250.07 255.221 250.07C251.405 250.07 248.322 246.987 248.322 243.169C248.322 241.555 250.524 237.921 251.845 237.187C252.872 236.636 253.973 236.307 255.221 236.307L255.222 236.307Z",
    stroke: "#FDBE90",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 236.527C256.433 236.527 257.607 236.895 258.598 237.482C259.883 238.252 261.9 241.555 261.9 243.17C261.9 246.84 258.892 249.85 255.222 249.85C251.552 249.85 248.542 246.877 248.542 243.17C248.542 241.519 250.597 238.142 251.955 237.371C252.946 236.858 254.01 236.527 255.222 236.527L255.221 236.527Z",
    stroke: "#FDBB8F",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 236.746C256.396 236.746 257.534 237.113 258.488 237.664C259.809 238.471 261.68 241.517 261.68 243.168C261.68 246.728 258.782 249.627 255.221 249.627C251.662 249.627 248.762 246.765 248.762 243.168C248.762 241.48 250.67 238.361 252.065 237.553C252.983 237.04 254.047 236.746 255.221 236.746V236.746Z",
    stroke: "#FDBB8D",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 236.967C256.359 236.967 257.46 237.297 258.378 237.848C259.736 238.655 261.461 241.48 261.461 243.168C261.461 246.618 258.672 249.444 255.222 249.444C251.771 249.444 248.982 246.618 248.982 243.168C248.982 241.444 250.744 238.545 252.175 237.737C253.056 237.26 254.084 236.967 255.222 236.967V236.967Z",
    stroke: "#FDB98A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M255.221 237.188C256.323 237.188 257.387 237.517 258.267 238.031C259.662 238.875 261.24 241.445 261.24 243.169C261.24 246.509 258.525 249.225 255.221 249.225C251.882 249.225 249.203 246.509 249.203 243.169C249.203 241.408 250.818 238.765 252.249 237.958C253.13 237.444 254.12 237.188 255.221 237.188V237.188Z",
    stroke: "#FDB98A",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 237.373C256.286 237.373 257.313 237.704 258.194 238.217C259.589 239.061 261.02 241.41 261.02 243.171C261.02 246.401 258.415 249.007 255.222 249.007C251.992 249.007 249.423 246.402 249.386 243.171C249.386 241.373 250.892 238.951 252.359 238.144C253.203 237.667 254.157 237.373 255.222 237.373V237.373Z",
    stroke: "#FCB687",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 237.594C256.249 237.594 257.24 237.888 258.084 238.401C259.516 239.282 260.799 241.374 260.799 243.172C260.799 246.291 258.303 248.787 255.222 248.787C252.14 248.787 249.607 246.291 249.607 243.172C249.607 241.337 250.965 239.171 252.469 238.327C253.276 237.851 254.194 237.594 255.222 237.594V237.594Z",
    stroke: "#FCB685",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 237.813C256.212 237.813 257.166 238.106 257.974 238.583C259.442 239.464 260.579 241.335 260.579 243.17C260.579 246.143 258.193 248.565 255.221 248.565C252.25 248.565 249.827 246.143 249.827 243.207C249.827 241.299 251.037 239.39 252.579 238.51C253.35 238.07 254.23 237.812 255.221 237.812L255.222 237.813Z",
    stroke: "#FCB485",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M255.222 248.344C258.047 248.344 260.36 246.032 260.36 243.206C260.36 240.344 258.046 238.031 255.222 238.031C252.359 238.031 250.047 240.344 250.047 243.206C250.047 246.032 252.359 248.344 255.222 248.344Z",
    stroke: "#FCB482",
    strokeWidth: 0.173595,
    strokeMiterlimit: 2.6131
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.264 248.387C258.089 248.387 260.402 246.075 260.402 243.212C260.402 240.387 258.089 238.074 255.264 238.074C252.401 238.074 250.089 240.387 250.089 243.212C250.089 246.075 252.401 248.387 255.264 248.387Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M256.363 238.144L256.947 235.395",
    stroke: "black",
    strokeWidth: 0.13
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M255.813 238.075L256.101 235.283",
    stroke: "black",
    strokeWidth: 0.13
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M255.264 238.034V235.242",
    stroke: "black",
    strokeWidth: 0.13
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M254.748 238.075L254.452 235.283",
    stroke: "black",
    strokeWidth: 0.13
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M254.198 238.144L253.606 235.395",
    stroke: "black",
    strokeWidth: 0.13
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M253.682 238.295L252.802 235.613",
    stroke: "black",
    strokeWidth: 0.13
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M253.166 238.473L252.032 235.91",
    stroke: "black",
    strokeWidth: 0.13
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M252.692 238.693L251.263 236.273",
    stroke: "black",
    strokeWidth: 0.13
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M252.21 238.988L250.561 236.746",
    stroke: "black",
    strokeWidth: 0.13
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M251.813 239.353L249.901 237.264",
    stroke: "black",
    strokeWidth: 0.13
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M251.407 239.724L249.317 237.846",
    stroke: "black",
    strokeWidth: 0.13
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M251.077 240.165L248.801 238.516",
    stroke: "black",
    strokeWidth: 0.13
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M250.747 240.605L248.328 239.209",
    stroke: "black",
    strokeWidth: 0.13
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M250.527 241.079L247.955 239.945",
    stroke: "black",
    strokeWidth: 0.13
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M250.307 241.595L247.659 240.715",
    stroke: "black",
    strokeWidth: 0.13
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M250.155 242.11L247.439 241.518",
    stroke: "black",
    strokeWidth: 0.13
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M250.087 242.659L247.296 242.363",
    stroke: "black",
    strokeWidth: 0.13
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M250.045 243.209H247.262",
    stroke: "black",
    strokeWidth: 0.13
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M250.087 243.725L247.296 244.012",
    stroke: "black",
    strokeWidth: 0.13
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M250.155 244.275L247.406 244.859",
    stroke: "black",
    strokeWidth: 0.13
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M250.307 244.783L247.626 245.671",
    stroke: "black",
    strokeWidth: 0.13
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M250.493 245.299L247.922 246.441",
    stroke: "black",
    strokeWidth: 0.13
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M250.747 245.781L247.769 247.617",
    stroke: "black",
    strokeWidth: 0.13
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M251.034 246.254L244.944 250.585",
    stroke: "black",
    strokeWidth: 0.13
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M251.373 246.66L244.876 252.421",
    stroke: "black",
    strokeWidth: 0.13
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M251.736 247.059L246.374 253.047",
    stroke: "black",
    strokeWidth: 0.13
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M252.176 247.396L248.099 252.861",
    stroke: "black",
    strokeWidth: 0.13
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M252.616 247.727L248.361 255.103",
    stroke: "black",
    strokeWidth: 0.13
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M253.098 247.945L250.747 253.3",
    stroke: "black",
    strokeWidth: 0.13
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M253.606 248.166L251.22 255.542",
    stroke: "black",
    strokeWidth: 0.13
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M254.122 248.311L253.098 253.267",
    stroke: "black",
    strokeWidth: 0.13
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M254.672 248.387L253.936 256.016",
    stroke: "black",
    strokeWidth: 0.13
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M255.737 248.387L256.033 251.17",
    stroke: "black",
    strokeWidth: 0.13
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M256.287 248.311L257.937 255.5",
    stroke: "black",
    strokeWidth: 0.13
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M256.803 248.166L258.199 252.421",
    stroke: "black",
    strokeWidth: 0.13
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M257.311 247.98L260.584 255.06",
    stroke: "black",
    strokeWidth: 0.13
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M257.827 247.727L261.312 253.741",
    stroke: "black",
    strokeWidth: 0.13
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M258.267 247.43L263.3 254.036",
    stroke: "black",
    strokeWidth: 0.13
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M258.706 247.1L263.113 252.2",
    stroke: "black",
    strokeWidth: 0.13
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M259.079 246.736L265.609 252.674",
    stroke: "black",
    strokeWidth: 0.13
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M259.408 246.289L262.97 248.861",
    stroke: "black",
    strokeWidth: 0.13
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M259.738 245.848L262.157 247.243",
    stroke: "black",
    strokeWidth: 0.13
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M259.958 245.375L262.53 246.508",
    stroke: "black",
    strokeWidth: 0.13
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M260.178 244.859L262.817 245.739",
    stroke: "black",
    strokeWidth: 0.13
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M260.322 244.344L263.037 244.936",
    stroke: "black",
    strokeWidth: 0.13
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M260.398 243.793L263.19 244.089",
    stroke: "black",
    strokeWidth: 0.13
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M260.432 243.244H263.223",
    stroke: "black",
    strokeWidth: 0.13
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M260.398 242.727L263.19 242.439",
    stroke: "black",
    strokeWidth: 0.13
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M260.322 242.177L263.08 241.594",
    stroke: "black",
    strokeWidth: 0.13
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M260.178 241.671L262.86 240.791",
    stroke: "black",
    strokeWidth: 0.13
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M259.992 241.154L262.564 240.012",
    stroke: "black",
    strokeWidth: 0.13
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M259.772 240.638L262.2 239.242",
    stroke: "black",
    strokeWidth: 0.13
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M259.476 240.198L261.718 238.549",
    stroke: "black",
    strokeWidth: 0.13
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M259.112 239.758L261.202 237.889",
    stroke: "black",
    strokeWidth: 0.13
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M258.749 239.395L260.618 237.297",
    stroke: "black",
    strokeWidth: 0.13
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M258.309 239.022L259.958 236.789",
    stroke: "black",
    strokeWidth: 0.13
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M257.869 238.734L259.256 236.307",
    stroke: "black",
    strokeWidth: 0.13
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M257.387 238.515L258.529 235.943",
    stroke: "black",
    strokeWidth: 0.13
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M256.871 238.294L257.759 235.646",
    stroke: "black",
    strokeWidth: 0.13
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M255.264 231.46V229.295",
    stroke: "black",
    strokeWidth: 0.13
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M252.836 231.723L252.396 229.592",
    stroke: "black",
    strokeWidth: 0.13
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M250.493 232.459L249.605 230.514",
    stroke: "black",
    strokeWidth: 0.13
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M248.361 233.703L247.076 231.943",
    stroke: "black",
    strokeWidth: 0.13
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M246.526 235.318L244.91 233.889",
    stroke: "black",
    strokeWidth: 0.13
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M245.096 237.34L243.185 236.24",
    stroke: "black",
    strokeWidth: 0.13
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M244.064 239.572L242.009 238.879",
    stroke: "black",
    strokeWidth: 0.13
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M243.548 241.958L241.383 241.738",
    stroke: "black",
    strokeWidth: 0.13
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M243.548 244.42L241.383 244.64",
    stroke: "black",
    strokeWidth: 0.13
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M244.064 246.846L241.975 247.505",
    stroke: "black",
    strokeWidth: 0.13
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M265.423 249.121L267.3 250.221",
    stroke: "black",
    strokeWidth: 0.13
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M266.412 246.881L268.468 247.541",
    stroke: "black",
    strokeWidth: 0.13
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M266.928 244.496L269.094 244.716",
    stroke: "black",
    strokeWidth: 0.13
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M266.928 242.034L269.094 241.814",
    stroke: "black",
    strokeWidth: 0.13
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M266.412 239.615L268.51 238.955",
    stroke: "black",
    strokeWidth: 0.13
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M265.423 237.373L267.3 236.273",
    stroke: "black",
    strokeWidth: 0.13
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M263.993 235.394L265.609 233.922",
    stroke: "black",
    strokeWidth: 0.13
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M262.2 233.744L263.443 231.977",
    stroke: "black",
    strokeWidth: 0.13
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M260.068 232.493L260.948 230.514",
    stroke: "black",
    strokeWidth: 0.13
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M257.717 231.722L258.157 229.633",
    stroke: "black",
    strokeWidth: 0.13
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.267 245.629C258.267 245.629 257.533 245.225 257.092 245.225C256.652 245.225 254.706 245.115 253.936 245.335C253.496 245.482 253.129 245.848 253.129 245.848C253.129 245.848 253.642 246.363 254.67 246.473C255.734 246.545 256.394 246.473 256.945 246.289C257.57 246.105 258.267 245.629 258.267 245.629V245.629Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.276 244.858C253.276 244.858 253.349 243.426 254.34 241.628C254.34 241.628 254.011 242.142 253.827 242.582C253.827 242.582 253.276 242.876 252.945 242.472C252.616 242.142 252.799 241.995 253.055 241.481C253.275 241.077 253.238 240.674 253.532 240.417C253.788 240.16 254.009 240.123 254.707 240.123C255.405 240.123 255.844 240.196 256.431 241.004C256.945 241.701 257.239 242.362 257.496 242.728C258.082 243.646 258.083 244.747 258.083 244.747L258.266 245.628C258.266 245.628 257.532 245.224 257.092 245.224C256.652 245.224 254.706 245.113 253.935 245.334C253.495 245.481 253.128 245.847 253.128 245.847C253.128 245.847 252.835 245.189 253.276 244.858L253.276 244.858Z",
    fill: "#E60000",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M253.276 244.859C253.276 244.859 253.827 244.529 255.698 244.565C257.864 244.602 257.936 244.749 258.083 244.896",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.145 252.937V245.34C255.145 245.34 255.402 245.12 255.989 245.34V252.864C255.989 252.864 256.173 258.626 255.548 258.589C254.815 258.59 255.145 257.268 255.145 252.937V252.937Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.296 246.551L247.443 246.845L245.975 247.468L246.195 247.982L245.975 248.055C245.828 247.724 245.718 247.615 245.351 247.689L245.241 247.468L247.296 246.551L247.296 246.551Z",
    fill: "#E60000"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.714 245.925C245.604 245.851 245.494 245.705 245.457 245.522C245.383 245.154 245.53 244.751 246.008 244.641C246.227 244.568 246.778 244.568 246.962 245.264C247.035 245.558 246.999 245.925 246.521 246.108L246.449 245.815C246.705 245.742 246.778 245.522 246.705 245.264C246.631 244.972 246.375 244.861 246.081 244.935C245.787 245.008 245.678 245.264 245.715 245.522C245.752 245.669 245.861 245.815 246.045 245.888L246.082 246.108L244.834 246.219L244.578 245.081L244.871 245.044L245.091 245.962L245.714 245.925V245.925Z",
    fill: "#E60000"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.13 241.814C244.763 241.814 244.617 242.072 244.617 242.329C244.58 242.548 244.617 242.879 244.947 242.916C245.167 242.916 245.241 242.769 245.277 242.658L245.497 241.998C245.57 241.705 245.79 241.521 246.12 241.558C246.67 241.595 246.781 242.108 246.744 242.512C246.707 242.916 246.56 243.1 246.488 243.173C246.267 243.356 246.084 243.393 245.863 243.356L245.9 243.063C246.304 243.1 246.451 242.769 246.488 242.476C246.524 242.256 246.488 241.889 246.157 241.852C245.9 241.815 245.826 241.925 245.717 242.293L245.57 242.769C245.497 242.916 245.387 243.246 244.983 243.209C244.617 243.173 244.286 242.916 244.323 242.365C244.397 241.558 244.873 241.521 245.13 241.521V241.818L245.13 241.814Z",
    fill: "#E60000"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.02 240.383L245.681 240.603L246.084 239.391L246.341 239.502L245.937 240.676L246.671 240.933L247.112 239.612L247.368 239.685L246.855 241.301L244.653 240.603L245.167 238.988L245.46 239.098L245.02 240.383Z",
    fill: "#E60000"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M246.529 236.993C246.363 237.034 246.189 237.153 246.079 237.337L245.577 238.209L247.506 239.425L247.692 239.187L246.846 238.658L247.216 238.05C247.472 237.609 247.297 237.255 247.004 237.072C246.857 236.98 246.694 236.952 246.528 236.993L246.529 236.993ZM246.661 237.337C246.71 237.344 246.764 237.379 246.819 237.416C247.04 237.563 247.045 237.751 246.899 237.971L246.608 238.447L245.973 238.077L246.317 237.548C246.4 237.41 246.511 237.314 246.661 237.337L246.661 237.337Z",
    fill: "#E60000"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.203 237.117L249.02 237.336L247.552 235.942L247.002 236.493L246.818 236.309L248.103 234.951L248.323 235.135L247.772 235.722L249.203 237.117Z",
    fill: "#E60000"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.975 236.457L248.616 234.621L248.837 234.438L250.232 236.273L249.975 236.457Z",
    fill: "#E60000"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.938 234.033L250.268 234.657L251.405 234.07L251.516 234.326L250.415 234.914L250.745 235.574L251.993 234.95L252.103 235.171L250.598 235.978L249.534 233.923L251.038 233.152L251.148 233.409L249.938 234.033Z",
    fill: "#E60000"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.198 234.657L253.904 233.336C253.904 233.263 253.868 233.006 253.794 232.786L253.575 234.804L253.281 234.878L252.216 233.116C252.253 233.337 252.326 233.63 252.363 233.666L252.656 235.024L252.363 235.061L251.849 232.822L252.29 232.749L253.354 234.511L253.575 232.456L254.014 232.346L254.491 234.621L254.198 234.657V234.657Z",
    fill: "#E60000"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M254.962 232.314L254.856 234.614L255.834 234.641C256.348 234.677 256.654 234.4 256.654 234.033C256.69 233.629 256.404 233.525 256.257 233.451C256.514 233.342 256.574 233.122 256.574 232.975C256.611 232.646 256.406 232.378 255.966 232.341L254.951 232.316L254.962 232.314ZM255.306 232.632L255.808 232.685C256.138 232.685 256.257 232.781 256.257 233.002C256.22 233.259 256.075 233.329 255.781 233.292H255.253L255.306 232.632ZM255.253 233.583L255.808 233.636C256.028 233.636 256.284 233.713 256.284 234.006C256.284 234.227 256.102 234.376 255.808 234.376L255.226 234.323L255.253 233.583H255.253Z",
    fill: "#E60000"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M257.527 232.525L256.919 234.772L257.21 234.851L257.448 233.9L258.188 234.111C258.555 234.221 258.515 234.43 258.479 234.614C258.442 234.686 258.336 235.022 258.373 235.169L258.743 235.274V235.248C258.669 235.175 258.68 235.131 258.716 234.984L258.769 234.587C258.88 234.293 258.774 234.184 258.664 234.111C258.811 234.037 259.04 233.992 259.113 233.662C259.26 233.185 258.925 232.979 258.558 232.869L257.527 232.525ZM257.818 232.922L258.479 233.16C258.625 233.197 258.853 233.253 258.743 233.583C258.669 233.877 258.461 233.857 258.241 233.821L257.606 233.636L257.818 232.922Z",
    fill: "#E60000"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.251 233.849L259.883 234.436L260.984 235.097L260.837 235.317L259.736 234.693L259.369 235.354L260.544 236.051L260.434 236.272L258.966 235.427L260.104 233.445L261.572 234.289L261.425 234.546L260.251 233.849Z",
    fill: "#E60000"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M263.023 235.537L261.278 236.991L261.86 237.731C262.373 238.281 262.99 238.034 263.393 237.705C263.907 237.301 264.035 236.701 263.631 236.224L263.023 235.537V235.537ZM262.997 236.039L263.34 236.462C263.597 236.756 263.559 237.074 263.155 237.44C262.752 237.771 262.381 237.761 262.124 237.467L261.781 237.07L262.996 236.039L262.997 236.039Z",
    fill: "#E60000"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.617 238.107L263.957 238.437L264.544 239.538L264.287 239.685L263.738 238.548L263.041 238.878L263.664 240.126L263.407 240.236L262.636 238.731L264.691 237.703L265.462 239.208L265.205 239.318L264.617 238.107Z",
    fill: "#E60000"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.807 242.22L263.77 241.926L265.349 241.706L265.275 241.193L265.496 241.156C265.606 241.523 265.643 241.633 266.009 241.67L266.046 241.889L263.807 242.22L263.807 242.22Z",
    fill: "#E60000"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M264.529 242.914C264.419 242.914 264.22 242.905 264 243.126C263.853 243.309 263.815 243.535 263.815 243.681C263.778 244.195 264.145 244.447 264.476 244.447C264.659 244.484 264.91 244.423 265.057 244.13C265.094 244.24 265.213 244.422 265.507 244.421C265.8 244.458 266.115 244.273 266.115 243.76C266.151 243.246 265.789 243.046 265.533 243.046C265.313 243.046 265.157 243.144 265.084 243.363C265.01 243.107 264.822 242.951 264.529 242.914ZM264.529 243.284C264.712 243.284 264.909 243.441 264.872 243.734C264.872 243.954 264.769 244.13 264.476 244.13C264.145 244.13 264.106 243.864 264.106 243.681C264.106 243.351 264.346 243.284 264.529 243.284ZM265.533 243.39C265.68 243.39 265.861 243.466 265.824 243.76C265.824 244.053 265.643 244.13 265.533 244.13C265.349 244.093 265.189 243.928 265.189 243.707C265.189 243.524 265.349 243.39 265.533 243.39Z",
    fill: "#E60000"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.203 244.934C265.936 245.117 265.863 245.668 265.826 245.889C265.717 246.255 265.386 246.513 264.982 246.403C264.615 246.329 264.506 246.035 264.395 245.632L264.322 245.375C264.248 245.045 264.102 244.935 263.991 244.899L263.698 246.11L263.44 246.036L263.808 244.531C264.284 244.678 264.469 244.935 264.578 245.265L264.652 245.596C264.725 245.852 264.799 246.072 265.092 246.109C265.239 246.182 265.496 246.109 265.57 245.779C265.68 245.375 265.313 245.265 265.166 245.228L265.203 244.934L265.203 244.934Z",
    fill: "#E60000"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.97 247.135L263.116 246.842L264.547 247.539L264.768 247.061L264.988 247.135C264.841 247.502 264.804 247.649 265.098 247.868L265.025 248.089L262.97 247.135L262.97 247.135Z",
    fill: "#E60000"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M255.26 216.088L216.871 280.317H293.683L255.26 216.088Z",
    stroke: "black",
    strokeWidth: 0.303766,
    strokeMiterlimit: 2.6131
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M257.311 272.384C258.302 272.641 259.513 272.788 260.723 272.458C262.375 272.053 263.916 271.099 265.861 271.283C267.256 271.429 269.165 272.641 271.477 272.641C273.753 272.641 274.523 271.833 276.505 271.429C277.9 271.136 278.598 271.283 280.102 271.613C281.826 271.943 282.707 272.934 285.606 272.715",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M227.697 275.141C228.981 274.149 231.257 273.746 232.982 274.149C235.258 274.626 236.248 275.213 238.67 275.176C240.469 275.141 242.01 273.929 243.845 273.929C246.891 273.929 247.001 274.553 249.68 275.067C250.377 275.213 251.258 275.213 251.956 275.067C252.946 274.883 253.828 274.553 254.634 274.149C255.478 273.709 257.607 273.782 258.671 273.893C260.58 274.075 261.35 274.81 261.754 274.92C262.782 275.176 263.956 275.324 265.167 274.994C266.819 274.516 268.359 273.452 270.341 273.672C271.736 273.819 273.644 275.176 275.92 275.176C278.196 275.176 279.002 274.259 280.948 273.819C282.38 273.489 283.077 273.672 284.581 274.003C286.27 274.406 287.186 275.507 290.086 275.25",
    stroke: "white",
    strokeWidth: 0.477258,
    strokeMiterlimit: 2.6131
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M223.366 272.976C224.651 272.132 226.927 271.764 228.651 272.095C230.927 272.536 231.918 273.086 234.339 273.049C236.137 273.012 237.679 271.911 239.514 271.911C242.56 271.911 242.67 272.499 245.349 272.939C246.047 273.049 246.928 273.049 247.625 272.939C248.616 272.793 249.496 272.462 250.304 272.095C251.111 271.728 253.276 271.801 254.341 271.875C256.249 272.058 257.019 272.683 257.423 272.793C258.451 273.012 259.625 273.159 260.836 272.866C262.488 272.426 264.029 271.507 266.011 271.691C267.406 271.838 269.314 273.049 271.589 273.012C273.865 273.012 274.672 272.205 276.617 271.801C278.049 271.507 278.746 271.691 280.25 271.985C281.939 272.352 282.856 273.343 285.756 273.086",
    stroke: "white",
    strokeWidth: 0.347087,
    strokeMiterlimit: 2.6131
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M219.399 279.252C220.684 278.188 222.959 277.748 224.721 278.151C226.96 278.702 227.951 279.362 230.373 279.326C232.171 279.289 233.749 277.932 235.548 277.932C238.631 277.932 238.703 278.629 241.383 279.216C242.08 279.362 242.961 279.362 243.695 279.216C244.686 278.996 245.53 278.629 246.337 278.151C247.181 277.711 249.31 277.785 250.411 277.895C252.282 278.114 253.053 278.886 253.457 279.033C254.485 279.289 255.659 279.472 256.906 279.106C258.558 278.555 260.099 277.417 262.044 277.638C263.439 277.82 265.348 279.325 267.66 279.325C269.899 279.325 270.706 278.298 272.651 277.784C274.083 277.417 274.78 277.638 276.284 278.005C278.009 278.445 278.889 279.693 281.789 279.399",
    stroke: "white",
    strokeWidth: 0.607428,
    strokeMiterlimit: 2.6131
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M220.431 275.649C221.753 274.768 224.028 274.438 225.753 274.768C228.028 275.208 229.019 275.722 231.442 275.686C232.249 275.686 232.984 275.465 233.754 275.208",
    stroke: "white",
    strokeWidth: 0.347087,
    strokeMiterlimit: 2.6131
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M232.062 271.911C232.428 271.8 233.492 271.287 235.034 271.287C238.117 271.287 236.172 271.324 238.851 271.8C239.548 271.911 241.493 271.947 242.044 271.396",
    stroke: "black",
    strokeWidth: 0.303766,
    strokeMiterlimit: 2.6131
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M268.916 280.097C269.907 279.913 270.752 279.619 271.595 279.252C272.402 278.886 274.531 278.922 275.632 279.033C277.541 279.216 278.274 279.84 278.715 279.913C279.742 280.17 280.917 280.317 282.127 279.987C283.779 279.583 285.32 278.629 287.302 278.812C288.697 278.959 290.605 280.17 292.881 280.17",
    stroke: "black",
    strokeWidth: 0.303766,
    strokeMiterlimit: 2.6131
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M273.644 271.614C275.921 271.614 276.691 270.806 278.673 270.402C280.068 270.109 280.765 270.292 282.269 270.586C283.994 270.917 284.875 271.944 287.774 271.687",
    stroke: "white",
    strokeWidth: 0.347087,
    strokeMiterlimit: 2.6131
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M219.509 279.472C220.83 278.628 223.105 278.261 224.831 278.592C227.106 279.032 228.097 279.583 230.519 279.546C232.317 279.509 233.859 278.408 235.694 278.408C238.74 278.408 238.85 278.996 241.529 279.436C242.226 279.546 243.107 279.546 243.804 279.436C244.795 279.289 245.639 278.959 246.483 278.592C247.29 278.224 249.419 278.298 250.52 278.408C252.428 278.555 253.162 279.179 253.602 279.289",
    stroke: "black",
    strokeWidth: 0.130171,
    strokeMiterlimit: 2.6131
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M224.356 276.68C225.676 275.799 227.952 275.469 229.677 275.799C231.952 276.24 232.943 276.753 235.329 276.717C237.164 276.68 238.705 275.579 240.504 275.616C243.587 275.616 243.697 276.166 246.376 276.643C247.073 276.753 247.953 276.753 248.651 276.643C249.642 276.46 250.486 276.167 251.33 275.799C252.137 275.432 254.266 275.469 255.367 275.579C257.238 275.762 258.009 276.387 258.45 276.46C259.441 276.717 260.652 276.864 261.863 276.534C263.514 276.13 265.055 275.175 267.038 275.359C268.542 275.505 270.451 276.717 272.616 276.717C274.892 276.717 275.699 275.909 277.644 275.505C279.039 275.211 279.736 275.359 281.277 275.689C282.965 276.02 283.883 277.01 286.745 276.753",
    stroke: "black",
    strokeWidth: 0.607428,
    strokeMiterlimit: 2.6131
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.388 265.997C225.754 266.071 226.636 265.373 226.893 265.189C227.259 264.969 227.443 264.419 227.737 264.125C228.03 263.794 228.912 263.391 229.315 263.134C231.076 262.033 231.884 261.408 233.094 259.794C234.747 257.518 236.692 255.647 239.113 254.289C239.884 253.849 241.058 253.996 241.902 254.362C242.158 254.472 242.489 254.766 242.783 254.986C243.81 255.793 245.205 256.381 246.893 256.895C248.508 257.371 248.875 258.436 250.16 259.573C250.783 260.124 251.481 260.601 252.252 260.968C252.325 261.004 252.508 261.298 252.581 261.335C253.315 261.886 254.123 262.327 254.747 262.877C255.921 263.941 257.022 265.006 258.123 266.143C258.306 266.326 258.38 266.693 258.563 266.84C259.407 267.647 260.215 268.492 261.242 268.969C262.27 269.483 263.187 270.144 264.141 270.731C254.378 271.099 245.388 270.474 235.589 270.768C235.332 270.805 235.258 270.768 233.79 270.768C233.056 270.731 232.615 270.805 231.882 270.805C228.909 270.768 226.083 270.768 222.597 270.731L225.388 265.997L225.388 265.997Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.26
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.739 270.481C262.932 269.967 262.124 269.417 261.243 268.976C260.216 268.499 259.408 267.654 258.565 266.847C258.381 266.7 258.308 266.333 258.124 266.15C257.023 265.012 255.922 263.947 254.748 262.884C254.125 262.333 253.317 261.893 252.583 261.342C252.509 261.305 252.326 261.011 252.253 260.974C251.483 260.608 250.785 260.13 250.161 259.58C249.317 258.809 248.876 258.112 248.179 257.561L248.216 257.524C248.62 257.23 249.06 256.937 249.537 256.717C250.161 256.351 251.152 256.461 251.85 256.79C252.07 256.864 252.364 257.084 252.584 257.267C253.427 257.965 254.602 258.442 255.997 258.882C257.355 259.286 257.686 260.167 258.749 261.085C259.263 261.562 259.814 261.966 260.475 262.26C260.511 262.297 260.658 262.516 260.731 262.59C261.355 263.03 262.016 263.398 262.567 263.874C263.521 264.756 264.439 265.637 265.356 266.59C265.503 266.737 265.539 267.031 265.723 267.178C266.42 267.838 267.117 268.536 267.962 268.939C268.806 269.343 269.54 269.894 270.348 270.371C268.145 270.481 265.98 270.481 263.815 270.481H263.739L263.739 270.481Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.26
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.035 258.587C255.328 258.66 255.659 258.77 255.99 258.881C257.348 259.285 257.678 260.165 258.742 261.083C259.256 261.56 259.806 261.964 260.467 262.258C260.504 262.295 260.65 262.514 260.724 262.588C261.348 263.029 262.008 263.396 262.559 263.873C263.513 264.754 264.432 265.635 265.348 266.588C265.495 266.735 265.532 267.029 265.716 267.176C266.413 267.836 267.11 268.534 267.954 268.937C268.688 269.268 269.313 269.745 269.973 270.149C271.772 270.149 273.569 270.113 275.442 270.039C274.707 269.598 274.047 269.084 273.239 268.718C272.468 268.35 271.881 267.726 271.22 267.102C271.073 266.992 271.036 266.735 270.89 266.588C270.046 265.707 269.202 264.937 268.321 264.129C267.844 263.688 267.257 263.358 266.706 262.954C266.633 262.918 266.486 262.697 266.449 262.66C265.862 262.367 265.348 262.037 264.871 261.596C263.917 260.752 263.623 259.944 262.375 259.578C261.127 259.21 260.062 258.733 259.293 258.146C259.072 257.962 258.815 257.742 258.632 257.668C257.971 257.375 257.09 257.264 256.503 257.595C255.99 257.89 255.475 258.22 255.036 258.587L255.035 258.587Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.26
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.993 260.676C264.25 260.969 264.507 261.263 264.874 261.593C265.351 262.034 265.865 262.365 266.452 262.658C266.489 262.694 266.636 262.915 266.71 262.951C267.26 263.355 267.847 263.685 268.324 264.126C269.206 264.934 270.049 265.705 270.893 266.585C271.039 266.732 271.076 266.989 271.223 267.099C271.884 267.723 272.471 268.347 273.243 268.715C273.756 268.971 274.197 269.265 274.674 269.559H274.637C276.766 269.559 278.894 269.559 281.06 269.485C280.472 269.118 279.958 268.715 279.298 268.421C278.674 268.09 278.197 267.577 277.646 267.099C277.537 266.989 277.5 266.805 277.389 266.659C276.692 265.962 276.031 265.337 275.333 264.677C274.93 264.309 274.453 264.052 274.012 263.722C273.939 263.685 273.828 263.539 273.792 263.502C273.315 263.282 272.911 262.988 272.507 262.657C271.736 261.96 271.516 261.299 270.525 261.005C269.497 260.676 268.616 260.345 267.992 259.831C267.809 259.685 267.625 259.538 267.478 259.464C266.928 259.244 266.23 259.134 265.753 259.391C265.092 259.757 264.542 260.161 263.991 260.639V260.676H263.993L263.993 260.676Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.26
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.623 269.194C280.219 268.901 279.779 268.644 279.302 268.424C278.678 268.093 278.2 267.58 277.649 267.102C277.54 266.992 277.503 266.809 277.392 266.662C276.695 265.965 276.035 265.34 275.337 264.68C274.934 264.313 274.456 264.055 274.016 263.725C273.942 263.688 273.832 263.542 273.795 263.505C273.319 263.285 272.915 262.991 272.511 262.661C271.85 262.074 271.593 261.523 270.933 261.155L270.969 261.192C271.299 260.936 271.667 260.679 272.034 260.495C272.474 260.238 273.062 260.348 273.538 260.532C273.648 260.569 273.832 260.752 273.979 260.862C274.53 261.266 275.227 261.596 276.145 261.853C276.989 262.11 277.173 262.66 277.833 263.248C278.164 263.542 278.531 263.798 278.934 263.982C278.971 264.019 279.044 264.166 279.118 264.202C279.485 264.459 279.925 264.68 280.256 265.01C280.843 265.561 281.43 266.111 282.018 266.698C282.128 266.809 282.128 266.992 282.238 267.066C282.679 267.47 283.119 267.91 283.633 268.167C284.183 268.461 284.661 268.791 285.174 269.084C283.633 269.158 282.129 269.158 280.624 269.158V269.194H280.623V269.194Z",
    fill: "#FFCC00",
    stroke: "black",
    strokeWidth: 0.26
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M238.194 254.916C238.671 254.843 238.45 254.734 238.891 255.027",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M237.315 255.501C237.828 255.427 238.012 255.097 238.379 255.537",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M236.832 255.839C237.053 255.839 237.2 255.581 237.897 255.985",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M236.325 256.421C236.766 256.311 237.022 256.348 237.463 256.495",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M235.733 256.861C236.246 256.714 236.467 257.082 237.017 256.972",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M235.107 257.488C235.437 257.488 235.548 257.378 235.841 257.488C236.207 257.599 236.134 257.525 236.501 257.562",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M234.413 258.147C234.781 258.147 234.89 258.073 235.22 258.11C235.66 258.183 235.551 258.22 235.991 258.147",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M234.007 258.698C234.741 258.624 234.961 258.661 235.475 258.844",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M233.018 260.051C233.641 259.868 233.935 259.868 234.486 260.088",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M222.816 270.548C224.835 270.218 227.221 270.585 229.239 270.291",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M233.314 259.391C233.827 259.207 233.717 259.281 234.231 259.317C234.745 259.391 234.965 259.464 235.112 259.391",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M232.502 260.566C233.015 260.309 233.639 260.456 234.154 260.603",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M233.83 261.117C233.28 260.97 232.692 261.081 232.105 261.117",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M233.39 261.709C232.802 261.525 232.179 261.452 231.591 261.636",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M230.776 262.148C231.51 262.148 232.208 261.964 232.941 262.221",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M230.159 262.733C230.929 262.475 231.7 262.696 232.508 262.769",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M229.423 263.173C230.23 263.136 231 263.136 231.808 263.099C231.919 263.099 232.176 262.989 232.322 263.173",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M232.062 263.611C230.85 263.868 229.639 263.685 228.428 263.722",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M231.402 264.238C230.998 264.275 230.374 264.422 229.823 264.385C229.713 264.349 229.604 264.275 229.494 264.275C228.87 264.238 228.246 264.238 227.659 264.459",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M227.401 264.897C227.658 264.75 227.951 264.713 228.208 264.787C228.979 264.897 229.712 264.787 230.447 264.97C230.631 265.043 230.814 265.153 231.034 265.153",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M226.961 265.194C227.511 265.194 228.062 265.12 228.612 265.231C229.309 265.414 229.971 265.561 230.704 265.598H230.631",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M226.445 265.6C227.032 265.6 227.583 265.71 228.171 265.82C228.941 265.967 229.712 265.747 230.446 265.967",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M225.752 265.963C226.522 266.293 227.33 266 228.137 266.147C228.908 266.293 229.606 266.256 230.339 266.403",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M225.236 266.547C226.41 266.584 227.585 266.547 228.796 266.767C229.126 266.841 229.64 266.988 230.081 266.914",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M224.838 267.062C225.976 267.283 227.15 267.099 228.287 267.393C228.802 267.503 229.352 267.613 229.903 267.613H229.829",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M224.356 267.942C224.465 267.905 224.612 267.832 224.722 267.832C225.64 267.832 226.52 267.979 227.475 267.869C228.208 267.832 229.016 267.758 229.75 268.016H229.677",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M223.95 268.534C225.785 268.351 227.657 268.608 229.492 268.534",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M223.62 269.084C225.565 269.304 227.51 269.121 229.418 269.268",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M223.332 269.668C224.176 269.852 225.021 269.595 225.865 269.778C226.489 269.888 227.04 269.998 227.664 269.888C228.214 269.741 228.728 269.925 229.242 269.852",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M237.095 261.818H237.278",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M236.909 262.038C236.982 262.075 237.092 261.928 237.129 262.075",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M236.689 262.334H237.092",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M236.503 262.588H237.016",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M236.173 262.918C236.466 262.955 236.724 262.991 237.017 262.991H236.943",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M235.885 263.358C236.215 263.248 236.582 263.358 236.913 263.248H236.839",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M235.445 263.875H236.84H236.768",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M235.217 264.204C235.73 264.204 236.208 264.13 236.685 264.24H236.649",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M234.929 264.677C235.479 264.603 236.067 264.677 236.655 264.75",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M234.599 265.194C234.966 265.157 235.26 265.377 235.627 265.451C235.921 265.524 236.177 265.451 236.434 265.414",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M234.489 265.6C235.039 265.783 235.627 265.82 236.177 265.857",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M234.159 266.04C234.636 266.004 235.077 266.114 235.554 266.26C235.774 266.333 235.994 266.297 236.178 266.297H236.141",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M233.534 266.732C234.121 266.475 234.818 266.659 235.442 266.843C235.662 266.916 235.883 266.806 236.139 266.806H236.065",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M233.457 267.173C234.155 266.952 234.889 266.952 235.55 267.246C235.66 267.283 235.806 267.246 235.917 267.246",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M233.018 267.689C233.935 267.873 234.889 267.58 235.807 267.836",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M232.764 268.096C233.498 268.39 234.306 268.096 235.113 268.316C235.369 268.39 235.626 268.39 235.883 268.279",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M232.248 268.646C232.578 268.535 232.909 268.462 233.239 268.535C234.119 268.756 234.927 268.682 235.735 268.793",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M231.842 269.228C232.025 269.191 232.209 269.338 232.355 269.301C233.493 269.118 234.631 269.301 235.732 269.228",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M231.554 269.668C232.435 269.998 233.352 269.668 234.306 269.925C234.674 270.035 235.15 270.072 235.554 269.925",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M231.224 270.295C232.583 270.332 233.866 270.258 235.445 270.442",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M238.93 262.512C239.077 262.475 239.187 262.622 239.334 262.585",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M238.744 262.917C238.928 262.881 239.075 262.807 239.258 262.844",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M238.6 263.281C238.857 263.318 239.077 263.245 239.334 263.355",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M238.414 263.799C238.707 263.799 239.038 263.799 239.332 263.872",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M238.16 264.314C238.564 264.203 238.931 264.35 239.335 264.24",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M238.118 264.678C238.485 264.825 238.852 264.714 239.256 264.751V264.678",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M237.898 265.261C238.265 265.225 238.595 265.188 238.926 265.335C239.036 265.372 239.183 265.335 239.33 265.261",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M237.864 265.777C238.341 265.593 238.819 265.887 239.333 265.777",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M237.644 266.402C238.195 266.366 238.709 266.476 239.26 266.402",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M237.458 266.876C237.678 266.803 237.935 266.656 238.155 266.766C238.485 266.913 238.889 266.84 239.256 266.876",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M237.348 267.436C237.972 267.215 238.633 267.583 239.257 267.252",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M237.272 268.018C237.565 267.945 237.859 267.945 238.19 268.055C238.519 268.128 238.923 268.091 239.327 268.018",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M237.095 268.569C237.828 268.422 238.6 268.569 239.37 268.532L239.334 268.569",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M236.655 269.084C237.609 269.011 238.6 268.9 239.554 268.9",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M236.765 269.668C237.829 269.485 238.93 269.558 240.031 269.521",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M236.579 270.26C237.643 270.407 237.863 270.187 238.928 270.151C239.111 270.151 240.029 269.966 240.212 269.93C240.359 269.894 240.689 269.93 240.837 269.93",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M236.579 270.548C238.194 270.401 239.844 270.695 241.496 270.291",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M229.566 270.371H230.85",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M235.809 270.549C235.956 270.622 236.139 270.475 236.249 270.622",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M241.941 270.437C243.262 270.291 244.62 270.695 245.942 270.437",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M241.273 269.999C242.117 269.743 242.888 269.926 243.696 270.073C243.769 270.073 243.769 270.256 243.843 270.293C244.576 270.403 245.274 270.293 246.008 270.256",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M236.579 269.93H235.735",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M231.334 269.744C230.748 269.781 230.16 269.781 229.573 269.854",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M242.381 257.377H242.638",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M242.491 257.742C242.601 257.778 242.711 257.742 242.821 257.705",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M242.559 258.334C242.596 258.298 242.596 258.224 242.632 258.224C242.742 258.187 242.889 258.188 242.999 258.188",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M242.711 258.697C242.895 258.587 243.115 258.661 243.335 258.661",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M243.405 259.027C243.184 258.991 243.001 259.064 242.817 259.138",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M243.075 259.653C243.258 259.543 243.442 259.506 243.662 259.543",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M243.921 259.982H243.077",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M243.329 260.423C243.622 260.423 243.915 260.496 244.136 260.312",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M244.361 260.939C244.03 260.939 243.737 260.939 243.443 261.012",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M243.659 261.557C243.988 261.593 244.319 261.52 244.649 261.373",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M244.724 261.709C244.431 261.856 244.101 261.893 243.77 261.966",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M243.955 262.513C244.359 262.293 244.835 262.476 245.239 262.33",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M245.35 262.842C245.021 262.842 244.69 262.769 244.359 262.879C244.249 262.916 244.176 262.989 244.029 262.989",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M244.285 263.799C244.542 263.689 244.798 263.506 245.092 263.543C245.128 263.359 245.312 263.543 245.385 263.432C245.458 263.396 245.605 263.432 245.752 263.432",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M245.934 263.984C245.457 263.947 244.943 264.057 244.466 264.131",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M244.614 264.753C245.164 264.532 245.715 264.532 246.302 264.459",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M244.657 265.447C245.281 265.3 245.941 265.337 246.528 265.08",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M246.966 265.523C246.269 265.634 245.571 265.523 244.911 265.854",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M245.054 266.479C245.164 266.516 245.238 266.589 245.348 266.552C246.009 266.295 246.669 266.076 247.33 266.149",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M247.516 266.623C246.855 266.99 246.084 266.843 245.35 266.88C245.278 266.88 245.204 266.954 245.094 266.99",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M245.35 267.435C246.158 267.325 246.929 267.288 247.736 267.178",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M248.252 267.689C247.591 267.8 246.967 267.653 246.343 267.8C246.05 267.836 245.792 267.947 245.499 268.02",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M245.604 268.535C245.714 268.535 245.86 268.572 245.934 268.498C246.741 268.021 247.658 268.168 248.539 268.131",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M248.801 268.646C248.068 268.646 247.296 268.462 246.563 268.719C246.306 268.828 246.049 268.975 245.755 268.975",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M246.01 269.524C246.413 269.451 246.78 269.267 247.148 269.194C247.992 269.083 248.836 269.157 249.68 269.157",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M249.681 269.601C249.204 269.491 248.69 269.454 248.25 269.601C247.516 269.784 246.855 269.967 246.121 270.004",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M246.526 270.37C247.114 270.297 247.664 270.114 248.251 269.966C248.728 269.857 249.206 269.93 249.683 269.93",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M246.56 270.701C247.441 270.554 248.322 270.701 249.202 270.407C249.496 270.297 249.826 270.48 250.156 270.443",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M250.155 270.108C251.623 270.217 253.091 269.925 254.522 270.254",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M250.451 270.548C250.634 270.584 250.781 270.438 250.891 270.438C252.102 270.438 253.313 270.474 254.524 270.548",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M254.088 267.436H254.272",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M254.156 267.833C254.303 267.907 254.449 267.65 254.596 267.833",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M254.266 268.273H255.036",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M254.486 268.898C254.743 268.605 255.109 268.898 255.366 268.715",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M254.672 269.492C255.002 269.198 255.479 269.528 255.81 269.234",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M254.748 269.931C255.224 269.784 255.739 269.967 256.215 269.674",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M254.926 270.371C255.659 270.042 256.503 270.518 257.201 270.004",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M255.002 270.734C255.919 270.44 256.873 270.734 257.791 270.697",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M258.377 270.7C259.992 270.627 261.643 270.59 263.258 270.7",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M257.683 270.107C259.115 270.253 261.279 270.107 263.078 270.253",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M249.757 259.061C249.867 259.061 250.858 258.877 250.932 258.877",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M250.087 259.322C250.381 259.359 251.078 259.359 251.335 259.139",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M250.561 259.798C250.561 259.761 251.405 259.615 251.442 259.615C251.552 259.578 251.699 259.615 251.845 259.578",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M250.933 260.05C251.079 259.94 252.254 260.013 252.474 259.977",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M252.76 260.312C252.54 260.312 251.586 260.349 251.439 260.459",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M252.253 260.973C252.399 260.864 253.097 260.754 253.354 260.754",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M253.902 261.158C253.608 261.158 252.985 261.232 252.654 261.232",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M253.276 261.708C253.606 261.672 254.193 261.598 254.377 261.451",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M254.968 261.996C254.637 261.996 254.197 262.033 253.757 262.07",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M254.308 262.513C254.711 262.513 255.299 262.513 255.593 262.402",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M256.034 262.656C255.776 262.803 255.263 262.84 254.932 262.913",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M255.475 263.433C255.806 263.213 256.393 263.36 256.797 263.213",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M257.243 263.689C256.84 263.689 256.436 263.652 256.142 263.726C256.032 263.762 255.995 263.836 255.812 263.836",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M258.563 264.677C257.975 264.641 257.498 264.751 256.984 264.824",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M257.497 265.38C258.01 265.159 258.635 265.196 259.222 265.086",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M258.783 266.92C258.893 266.956 259.443 266.846 259.553 266.81C260.435 266.699 260.581 266.516 261.389 266.589",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M261.87 266.953C260.805 267.137 260.402 267.173 259.594 267.247C259.483 267.247 259.227 267.32 259.154 267.357",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M259.628 267.688C260.437 267.542 261.611 267.579 262.417 267.469",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M263.3 267.908C262.639 268.018 261.869 267.908 261.244 268.055C260.951 268.092 260.401 268.129 260.107 268.202",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M260.872 268.713C260.982 268.713 261.129 268.713 261.203 268.677C261.864 268.236 262.928 268.309 263.881 268.309",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M264.475 268.754C263.557 268.754 263.19 268.791 262.493 268.863C262.236 268.9 261.869 269.047 261.539 269.047",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M262.31 269.524C263.154 269.377 264.769 269.193 263.815 269.267C264.696 269.193 264.843 269.193 265.797 269.193",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M266.049 269.559C265.462 269.486 264.837 269.486 264.434 269.596C264.067 269.706 264.177 269.816 262.929 269.853",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M263.443 270.109C264.031 270.035 264.105 270.072 264.655 269.925C265.095 269.815 265.683 269.852 266.233 269.852",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M263.74 270.327C264.657 270.217 264.767 270.254 265.722 270.291C265.978 270.291 266.199 270.291 266.529 270.254",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M249.461 258.698C249.682 258.588 249.828 258.514 250.232 258.551C250.121 258.404 250.415 258.551 250.489 258.478C250.489 258.404 250.708 258.441 250.855 258.441",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M249.021 258.257C249.241 258.146 249.461 258.146 249.829 258.183C249.718 258 250.048 258.183 250.085 258.073C250.122 258.036 250.342 258.073 250.489 258.073",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M256.321 264.425C256.578 264.314 256.542 264.241 256.908 264.314C256.799 264.131 257.312 264.314 257.349 264.204C257.385 264.131 257.79 264.167 257.936 264.167",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M257.869 265.886C258.456 265.74 259.191 265.74 259.704 265.482",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M260.584 266.148C259.887 266.258 258.86 266.184 258.309 266.478",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M249.935 257.631C249.275 257.594 249.164 257.815 248.687 257.815",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M257.167 259.467C257.277 259.467 258.011 259.32 258.121 259.32",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M257.463 259.763C257.903 259.654 258.234 259.763 258.491 259.58",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M257.827 260.127C257.827 260.091 258.524 260.017 258.561 260.017C258.671 259.98 258.818 259.98 258.928 259.98",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M258.199 260.456C258.346 260.346 259.301 260.382 259.52 260.346",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M259.772 260.676C259.552 260.639 258.671 260.786 258.524 260.859",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M259.003 261.269C259.149 261.159 260.104 261.049 260.324 261.085",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M260.838 261.447C260.544 261.447 259.737 261.521 259.443 261.557",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M259.916 261.929C260.21 261.929 261.127 261.856 261.274 261.709",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M261.794 262.217C261.5 262.217 260.986 262.253 260.582 262.29",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M260.948 262.698C261.315 262.698 262.123 262.698 262.38 262.551",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M262.784 262.809C262.563 262.956 261.866 263.029 261.572 263.102",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M262.234 263.502C262.528 263.318 263.114 263.429 263.482 263.318",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M263.883 263.763C263.553 263.763 263.149 263.726 262.892 263.8C262.782 263.837 262.745 263.91 262.599 263.873",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M265.093 264.677C264.579 264.641 264.139 264.751 263.661 264.824",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M264.137 265.337C264.614 265.116 265.201 265.116 265.751 265.043",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M265.423 266.767C265.57 266.803 265.936 266.656 266.01 266.656C266.854 266.546 266.965 266.363 267.735 266.399",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M268.138 266.768C267.183 266.951 266.816 266.988 266.082 267.025C265.972 267.025 265.715 267.098 265.642 267.135",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M266.083 267.436C266.817 267.325 267.918 267.325 268.652 267.252",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M269.466 267.654C268.878 267.728 268.181 267.654 267.594 267.764C267.336 267.838 266.786 267.838 266.529 267.911",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M267.258 268.382C267.368 268.382 267.479 268.382 267.552 268.346C268.14 267.942 269.131 268.015 270.048 268.015",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M270.566 268.424C269.722 268.424 269.354 268.461 268.73 268.534C268.326 268.571 267.849 268.718 267.739 268.718",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M268.358 269.118C269.129 268.971 270.818 268.824 269.936 268.898C270.745 268.824 270.891 268.824 271.772 268.824",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M271.995 269.195C271.444 269.121 270.931 269.084 270.527 269.195C270.233 269.268 270.123 269.415 268.911 269.452",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M269.356 269.71C269.906 269.637 270.237 269.637 270.714 269.527C271.117 269.416 271.668 269.453 272.183 269.453",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M269.906 269.999C270.677 269.89 270.787 269.816 271.705 269.853C271.962 269.853 272.145 269.816 272.439 269.779",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M256.727 259.171C256.947 259.061 256.873 258.987 257.204 259.024C257.461 258.951 257.645 259.061 257.681 258.951C257.681 258.914 257.901 258.914 258.011 258.914",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M256.211 258.882C256.432 258.772 256.468 258.662 256.799 258.699C257.129 258.662 257.276 258.699 257.312 258.589C257.349 258.552 257.533 258.589 257.68 258.589",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M263.147 264.423C263.368 264.313 263.258 264.276 263.588 264.313C263.515 264.166 263.955 264.313 263.992 264.239C264.029 264.166 264.396 264.203 264.542 264.203",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M264.475 265.778C265.025 265.631 265.687 265.631 266.163 265.447",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M266.971 266.039C266.346 266.149 265.539 266.002 265.062 266.259",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M257.201 258.181C256.577 258.144 256.063 258.437 255.697 258.694",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M264.729 261.413C264.803 261.413 265.684 261.266 265.721 261.266",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M265.025 261.633C265.356 261.559 265.832 261.596 266.016 261.449",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M265.355 261.886C265.318 261.886 266.052 261.776 266.089 261.776C266.162 261.739 266.272 261.776 266.383 261.776",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M265.643 262.149C265.752 262.076 266.67 262.076 266.817 262.039",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M267.038 262.292C266.855 262.256 266.157 262.366 266.047 262.439",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M266.565 262.733C266.675 262.659 267.262 262.586 267.445 262.586",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M267.808 262.885C267.624 262.885 266.964 262.958 266.744 262.958",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M267.148 263.248C267.368 263.248 268.029 263.175 268.176 263.064",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M268.578 263.469C268.321 263.469 267.918 263.505 267.624 263.505",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M267.918 263.831C268.212 263.831 268.799 263.831 269.019 263.721",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M269.356 263.941C269.172 264.052 268.621 264.088 268.401 264.125",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M268.73 264.458C268.95 264.311 269.612 264.421 269.868 264.348",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M270.193 264.644C269.899 264.644 269.607 264.607 269.386 264.681C269.313 264.717 269.239 264.717 269.129 264.717",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M271.115 265.379C270.712 265.342 270.198 265.489 269.867 265.526",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M270.27 265.82C270.6 265.673 271.187 265.71 271.591 265.637",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M271.183 266.92C271.257 266.956 271.734 266.883 271.808 266.883C272.431 266.809 272.541 266.662 273.129 266.699",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M273.467 266.986C272.732 267.097 272.438 267.133 271.852 267.17C271.778 267.17 271.521 267.207 271.448 267.207",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M271.741 267.469C272.328 267.359 273.283 267.396 273.87 267.322",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M274.457 267.654C274.016 267.728 273.466 267.654 273.025 267.728C272.658 267.801 272.143 267.838 272.107 267.838",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M272.579 268.239C272.652 268.239 273.166 268.092 273.203 268.092C273.937 268.018 274.194 267.945 274.892 267.908",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M275.294 268.238C274.634 268.238 274.377 268.275 273.899 268.312C273.568 268.348 273.018 268.532 272.945 268.532",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M273.501 268.822C273.977 268.713 275.409 268.566 274.822 268.603C275.446 268.566 275.556 268.566 276.216 268.529",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M276.402 268.823C275.999 268.787 275.595 268.75 275.264 268.823C275.081 268.896 274.861 268.97 273.943 269.043",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M274.304 269.228C274.744 269.155 275.038 269.192 275.405 269.081C275.736 268.971 276.176 269.045 276.543 269.008",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M274.677 269.448C275.263 269.374 275.484 269.301 276.181 269.338C276.364 269.338 276.511 269.337 276.768 269.301",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M264.543 261.159C264.727 261.085 264.8 260.975 265.057 261.012C265.241 260.975 265.388 261.049 265.388 260.975C265.425 260.939 265.571 260.939 265.682 260.939",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M264.247 260.897C264.431 260.824 264.467 260.751 264.724 260.751C264.981 260.751 265.091 260.751 265.128 260.714C265.128 260.64 265.311 260.677 265.385 260.677",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M269.466 265.151C269.65 265.078 269.686 265.041 269.979 265.078C269.869 264.967 270.236 265.078 270.273 265.005C270.273 264.967 270.567 265.005 270.677 265.005",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M270.633 266.217C271.036 266.107 271.551 266.107 271.918 265.924",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M272.545 266.402C272.068 266.476 271.37 266.366 270.966 266.586",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M265.025 260.38C264.548 260.343 264.438 260.527 264.144 260.747",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M271.589 261.708C271.663 261.708 272.433 261.598 272.507 261.598",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M271.851 261.963C272.144 261.89 272.622 261.89 272.769 261.779",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M272.139 262.183L272.837 262.073C272.91 262.036 273.02 262.073 273.094 262.073",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M272.469 262.546C272.579 262.472 273.35 262.326 273.497 262.326",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M273.721 262.547C273.537 262.51 272.803 262.657 272.693 262.73",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M273.095 262.994C273.168 262.921 273.902 262.81 274.086 262.847",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M274.457 263.104C274.236 263.104 273.648 263.14 273.355 263.214",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M273.721 263.434C273.941 263.434 274.639 263.36 274.748 263.25",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M275.15 263.611C274.931 263.611 274.38 263.685 274.086 263.722",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M274.524 263.983C274.78 263.983 275.368 263.983 275.552 263.873",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M275.852 264.051C275.669 264.161 275.044 264.161 274.825 264.234",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M275.294 264.567C275.478 264.42 276.065 264.493 276.321 264.42",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M276.622 264.721C276.365 264.721 276.109 264.721 275.888 264.757C275.851 264.794 275.668 264.794 275.594 264.794",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M277.468 265.379C277.1 265.342 276.66 265.489 276.329 265.526",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M276.622 265.853C276.953 265.706 277.54 265.706 277.943 265.633",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M277.536 266.843C277.608 266.843 278.049 266.769 278.122 266.769C278.71 266.696 278.819 266.586 279.334 266.623",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M279.625 266.877C278.964 266.987 278.671 267.024 278.156 267.061C278.083 267.061 277.826 267.061 277.789 267.097",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M278.018 267.393C278.569 267.319 279.486 267.246 279.999 267.209",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M280.581 267.502C280.141 267.539 279.626 267.502 279.222 267.575C278.892 267.648 278.415 267.648 278.378 267.685",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M278.821 268.018C278.895 268.018 279.372 267.908 279.409 267.908C280.07 267.835 280.326 267.761 280.987 267.725",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M281.35 268.02C280.726 268.056 280.506 268.056 280.066 268.093C279.735 268.13 279.258 268.313 279.147 268.313",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M279.667 268.568C280.145 268.494 281.465 268.311 280.915 268.384C281.465 268.311 281.575 268.311 282.2 268.311",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M282.382 268.568C281.978 268.531 281.574 268.494 281.318 268.568C281.134 268.641 280.951 268.715 280.107 268.751",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M280.437 268.932C280.804 268.895 281.098 268.895 281.464 268.786C281.758 268.713 282.126 268.749 282.493 268.749",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M280.733 269.153C281.321 269.079 281.503 269.043 282.165 269.043C282.348 269.043 282.458 269.043 282.679 269.006",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M271.445 261.488C271.592 261.415 271.629 261.341 271.886 261.378C272.07 261.341 272.18 261.378 272.217 261.341C272.217 261.305 272.364 261.305 272.473 261.305",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M271.149 261.269C271.333 261.196 271.333 261.122 271.59 261.159C271.81 261.122 271.921 261.159 271.957 261.086C271.957 261.049 272.103 261.049 272.214 261.049",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M275.962 265.194C276.109 265.12 276.182 265.12 276.402 265.12C276.329 265.011 276.659 265.12 276.696 265.084C276.733 265.047 276.99 265.047 277.063 265.047",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M276.986 266.15C277.352 266.077 277.903 266.077 278.234 265.93",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M278.821 266.326C278.345 266.4 277.61 266.289 277.244 266.473",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M271.885 260.786C271.444 260.749 271.297 260.933 271.04 261.116",
    stroke: "#00633B",
    strokeWidth: 0.13
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M221.762 317.959L222.396 322.662C221.153 322.256 220.011 322.983 219.461 324.015C218.581 325.775 219.359 327.103 221.051 327.949L223.326 329.116L227.556 320.894L225.864 320.048L224.172 323.347H224.138L223.775 318.991L221.762 317.959V317.959ZM222.396 324.168C222.667 324.193 222.963 324.311 223.267 324.464L223.479 324.565L222.295 326.815L222.083 326.705C221.313 326.308 220.797 325.826 221.237 324.912C221.533 324.337 221.939 324.134 222.396 324.168V324.168Z",
    fill: "#FFCC00"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.412 322.262L215.549 320.574L213.053 318.921L213.935 317.635L216.393 319.288L217.787 317.233L215.219 315.51L216.099 314.189L220.21 316.979L215.072 324.614L210.961 321.859L211.843 320.574L214.412 322.262Z",
    fill: "#FFCC00"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M212.719 311.506L210.478 314.103L209.759 313.519C208.295 312.233 206.815 312.293 205.529 313.756C204.176 315.371 204.675 316.784 206.223 318.07L208.152 319.728L214.123 312.724L212.719 311.506V311.506ZM208.042 314.5C208.363 314.526 208.718 314.746 209.099 315.075L209.395 315.287L207.729 317.224L207.458 317.004C206.764 316.42 206.367 315.871 207.069 315.025C207.416 314.619 207.72 314.466 208.042 314.5V314.5Z",
    fill: "#FFCC00"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.382 313.747L200.134 312.352L203.951 308.866C204.794 308.131 205.932 306.956 204.868 305.783C203.804 304.608 202.519 305.599 201.676 306.37L197.858 309.82L196.61 308.462L200.684 304.755C202.373 303.25 204.281 302.846 206.006 304.718C207.73 306.627 207.143 308.535 205.456 310.04L201.382 313.747H201.382Z",
    fill: "#FFCC00"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M198.001 296.314C197.477 296.272 196.927 296.399 196.36 296.788C195.557 297.372 194.931 298.421 195.413 299.486C194.745 299.19 194 299.393 193.45 299.799C191.945 300.831 191.979 302.109 193.002 303.58L194.322 305.484L201.935 300.273L200.268 297.871C199.651 296.974 198.872 296.382 198.001 296.314V296.314ZM197.976 298.294C198.526 298.243 198.932 298.691 199.321 299.241L199.558 299.537L197.604 300.857L197.443 300.645C196.969 299.952 196.47 299.131 197.392 298.505C197.612 298.361 197.79 298.311 197.976 298.294V298.294ZM195.278 300.967C195.616 300.958 195.903 301.187 196.174 301.601L196.31 301.779L194.508 303.022L194.381 302.844C193.975 302.252 193.856 301.703 194.592 301.229C194.855 301.034 195.075 300.967 195.278 300.967V300.967Z",
    fill: "#FFCC00"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.254 289.377L197.419 293.339L189.309 297.746L188.391 296.094L195.143 292.464L193.896 290.112L195.254 289.377Z",
    fill: "#FFCC00"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.484 287.655L186.042 291.363L185.308 289.64L193.749 285.932L194.484 287.655Z",
    fill: "#FFCC00"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.279 279.539C183.839 280.2 183.765 281.081 183.986 281.851C184.572 283.54 186.371 284.018 187.912 283.54C189.381 283.063 190.518 281.558 189.968 279.907C189.748 279.137 189.087 278.512 188.39 278.182L190.408 277.521C190.958 278.108 191.399 278.696 191.62 279.43C192.464 281.999 190.959 284.568 188.537 285.376C186.041 286.183 183.252 285.082 182.371 282.403C182.151 281.669 182.114 280.935 182.225 280.201L184.279 279.539L184.279 279.539Z",
    fill: "#FFCC00"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M188.697 267.207L180.027 272.468L180.289 273.898L190.253 275.903L189.881 273.974L187.851 273.526L187.242 270.244L189.069 269.161L188.697 267.207V267.207ZM185.888 271.039L186.286 273.263L182.801 272.841V272.781L185.888 271.039Z",
    fill: "#FFCC00"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M183.833 249.977C181.448 249.985 179.57 251.643 179.367 254.257L179.155 256.896L188.324 257.64L188.536 254.993C188.756 252.278 186.912 250.222 184.307 250.002C184.146 249.985 183.994 249.968 183.833 249.977V249.977ZM183.486 252.092C183.689 252.075 183.901 252.066 184.121 252.092C185.77 252.201 186.844 253.115 186.658 255.204V255.475L181.135 255.018L181.16 254.756C181.287 253.056 182.082 252.185 183.486 252.092Z",
    fill: "#FFCC00"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.189 244.898L184.17 245.302L184.794 242.403L186.299 242.732L185.712 245.632L188.171 246.146L188.795 243.136L190.299 243.43L189.309 248.311L180.28 246.403L181.271 241.559L182.812 241.888L182.189 244.898Z",
    fill: "#FFCC00"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.712 232.786L187.584 233.52L188.685 230.731L190.152 231.318L189.052 234.108L191.363 234.988L192.501 232.125L193.97 232.676L192.171 237.3L183.547 233.961L185.381 229.336L186.85 229.887L185.712 232.786Z",
    fill: "#FFCC00"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.089 226.401L195.034 230.438L186.813 226.218L187.657 224.566L194.484 228.053L195.694 225.704L197.089 226.401Z",
    fill: "#FFCC00"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.051 213.597C196.463 213.633 195.95 213.816 195.583 214.294C195.215 214.807 195.215 215.505 195.693 215.872C196.94 216.79 198.702 213.34 201.197 215.211C202.666 216.312 202.995 218.037 201.821 219.615C201.051 220.68 199.876 221.01 198.628 220.899L198.444 219.248C199.178 219.468 200.06 219.321 200.536 218.66C201.013 218.073 200.793 217.302 200.207 216.899C199.436 216.312 198.701 216.899 198.004 217.339C196.903 218.036 195.876 218.403 194.738 217.559C193.49 216.642 193.196 214.954 194.151 213.669C194.664 212.972 195.693 212.274 196.537 212.164L197.051 213.597L197.051 213.597Z",
    fill: "#FFCC00"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M201.173 205.51L200.141 206.542L204.345 215.821L205.715 214.391L204.87 212.488L207.17 210.111L209.099 210.906L210.478 209.477L201.173 205.51ZM202.628 208.132L205.563 209.477L204.134 210.983L202.603 208.157L202.628 208.132Z",
    fill: "#FFCC00"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.402 205.555L211.879 208.419L206.081 201.224L207.549 200.051L212.356 205.996L214.412 204.344L215.402 205.555Z",
    fill: "#FFCC00"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.182 197.15L212.87 196.049L218.155 200.087L218.191 200.05L216.651 193.663L218.375 192.6L220.283 202.582L219.366 203.17L211.182 197.15Z",
    fill: "#FFCC00"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M224.908 189.176L223.589 189.81L224.062 199.986L225.864 199.165L225.779 197.025L228.791 195.68L230.271 197.161L232.098 196.34L224.908 189.176ZM225.28 192.187L227.556 194.539L225.644 195.384L225.28 192.238V192.187Z",
    fill: "#FFCC00"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M235.194 185.979C234.72 185.979 234.213 186.063 233.714 186.216L231.176 186.96L233.764 195.782L236.277 195.072C238.916 194.302 240.21 191.832 239.474 189.337C238.873 187.273 237.232 185.962 235.194 185.979ZM235.135 187.907C236.285 187.95 237.055 188.618 237.435 189.946C237.918 191.519 237.419 192.822 235.405 193.405L235.135 193.507L233.604 188.195L233.866 188.093C234.34 187.966 234.754 187.89 235.135 187.907V187.907Z",
    fill: "#FFCC00"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M246.266 183.305C246.097 183.313 245.911 183.339 245.742 183.356C242.984 183.728 241.352 186.206 241.716 188.778C242.045 191.383 244.279 193.32 247.036 192.956C249.819 192.584 251.435 190.14 251.105 187.534C250.792 185.124 248.812 183.229 246.266 183.305V183.305ZM246.055 185.369C247.518 185.183 248.753 186.392 248.939 187.746C249.083 188.998 248.203 190.723 246.765 190.943C245.336 191.129 244.016 189.657 243.83 188.406C243.686 187.052 244.549 185.555 246.055 185.369V185.369Z",
    fill: "#FFCC00"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M253.905 182.883L253.803 192.111H255.672L255.706 188.406H255.732L258.007 192.162L260.274 192.187L257.609 188.279C258.895 188.093 259.589 186.918 259.589 185.742C259.623 183.754 258.311 182.95 256.442 182.908L253.905 182.883ZM255.808 184.524H256.07C256.95 184.524 257.643 184.735 257.609 185.767C257.609 186.791 256.95 187.061 255.994 187.061H255.782L255.808 184.524Z",
    fill: "#FFCC00"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.498 186.579L273.026 188.561L275.886 189.259L275.519 190.8L272.615 190.066L272.029 192.489L275.038 193.259L274.635 194.764L269.825 193.553L272.073 184.598L276.874 185.809L276.507 187.351L273.498 186.579Z",
    fill: "#FFCC00"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.513 186.617L281.754 187.095L284.037 194.986H284.072L286.381 189.223L288.104 189.92L284.623 198.655L283.372 198.141L281.063 190.288H281.02L278.711 196.086L276.988 195.426L280.513 186.617Z",
    fill: "#FFCC00"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.199 204.014L290.377 201.628L295.301 193.811L296.875 194.802L292.8 201.298L295.039 202.693L294.199 204.014Z",
    fill: "#FFCC00"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M303.971 199.537L295.09 204.536L296.621 205.771L298.448 204.748L301.011 206.888L300.376 208.867L301.933 210.11L305.105 200.459L303.971 199.537V199.537ZM302.593 202.21L301.535 205.272L299.928 203.978L302.593 202.21Z",
    fill: "#FFCC00"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M317.793 213.969L307.964 216.481L309.097 218.071L311.161 217.589L313.09 220.262L311.956 222.03L313.141 223.645L318.664 215.136L317.793 213.969ZM315.813 216.193L313.986 218.883L312.768 217.191L315.813 216.193Z",
    fill: "#FFCC00"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.853 229.006L320.112 224.492V224.455L314.603 226.291L313.763 224.602L322.937 221.775L323.558 222.951L319.194 227.795L325.613 227.097L326.234 228.308L318.425 233.85L317.576 232.162L322.351 228.896L316.142 229.556L315.853 229.006Z",
    fill: "#FFCC00"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.864 235.063L324.958 235.723L325.911 238.513L324.407 239.026L323.445 236.201L321.101 237.008L322.089 239.944L320.585 240.458L319.01 235.723L327.747 232.787L329.357 237.484L327.852 237.999L326.864 235.063Z",
    fill: "#FFCC00"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M330.269 240.91L321.286 242.813L321.65 244.632L325.279 243.871H325.329L322.157 246.958L322.657 249.157L325.879 245.715C326.361 246.933 327.63 247.322 328.764 247.068C330.709 246.662 331.234 245.241 330.828 243.363L330.269 240.91V240.91ZM329.136 243.126L329.187 243.363C329.373 244.243 329.314 244.979 328.29 245.165C327.3 245.385 326.911 244.784 326.725 243.871L326.674 243.659L329.136 243.126Z",
    fill: "#FFCC00"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.789 251.027L331.963 249.963L332.181 251.799L323.007 252.863L322.789 251.027Z",
    fill: "#FFCC00"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.165 261.777C330.79 261.262 331.119 260.455 331.119 259.648C331.083 257.849 329.468 256.858 327.891 256.896C326.349 256.896 324.808 257.997 324.844 259.757C324.844 260.529 325.248 261.336 325.835 261.85L323.707 261.887C323.376 261.189 323.12 260.492 323.12 259.721C323.082 257.006 325.285 254.987 327.817 254.95C330.459 254.913 332.771 256.785 332.845 259.611C332.845 260.345 332.661 261.115 332.331 261.74L330.165 261.777L330.165 261.777Z",
    fill: "#FFCC00"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M323.375 263.512L323.164 265.466L324.983 266.472L324.585 269.771L322.53 270.245L322.318 272.233L332.147 269.822L332.333 268.342L323.375 263.512ZM326.463 267.284L329.347 268.612V268.638L326.201 269.348L326.463 267.284V267.284Z",
    fill: "#FFCC00"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.703 289.97C324.473 289.676 325.098 289.089 325.392 288.355C326.052 286.667 324.951 285.126 323.482 284.538C322.051 283.988 320.217 284.392 319.556 286.007C319.262 286.778 319.336 287.659 319.703 288.356L317.684 287.585C317.647 286.815 317.684 286.08 317.977 285.346C318.969 282.85 321.794 281.787 324.144 282.741C326.603 283.695 328.034 286.337 327.005 288.944C326.712 289.641 326.271 290.265 325.72 290.743L323.703 289.97L323.703 289.97Z",
    fill: "#FFCC00"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.203 294.923L320.401 293.97L318.976 296.576L317.611 295.841L319.011 293.235L316.807 292.019L315.337 294.774L313.982 294.005L316.326 289.641L324.442 294.04L322.089 298.404L320.698 297.634L322.203 294.923Z",
    fill: "#FFCC00"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.401 301.709L319.631 302.811L311.446 303.064L311.411 303.108L316.439 306.737L315.337 308.277L307.737 302.706L308.516 301.639L316.693 301.341H316.728L311.664 297.633L312.766 296.129L320.401 301.709Z",
    fill: "#FFCC00"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.219 313.639L309.539 312.239L303.994 306.922L305.28 305.566L310.825 310.884L312.18 309.493L313.282 310.56L309.32 314.706L308.219 313.639Z",
    fill: "#FFCC00"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M301.273 309.637L299.818 310.796L302.195 313.68V313.705L298.025 312.352L296.274 313.781L300.85 315.025C300.004 316.015 300.216 317.334 300.985 318.248C302.229 319.753 303.785 319.542 305.215 318.332L307.143 316.717L301.273 309.637V309.637ZM303.041 314.813L304.656 316.767L304.47 316.903C303.777 317.486 303.151 317.757 302.491 316.979C301.831 316.175 302.178 315.558 302.914 314.974L303.041 314.813V314.813Z",
    fill: "#FFCC00"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M295.513 314.416L293.821 315.473L294.193 317.537L291.359 319.28L289.727 318.036L288.035 319.094L296.147 325.201L297.365 324.44L295.513 314.416V314.416ZM294.455 319.254L295.276 322.325H295.225L292.687 320.362L294.455 319.254V319.254Z",
    fill: "#FFCC00"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.305 321.744L286.381 319.803L290.342 328.172L288.655 328.942L285.392 322.042L282.97 323.144L282.305 321.744Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSv);
export default __webpack_public_path__ + "static/media/SV.dbda5a26e1808ef89df61881d3c503aa.svg";
export { ForwardRef as ReactComponent };